const pl: Record<string, string> = {
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). PL gate copy
  //     translated from the approved DE/EN mockups (Om signs off wording in QA).
  //     Testimonial names/quotes/roles + photos are verbatim from the Webflow
  //     CMS (Janik 2026-06-11).
  'og.title.trust.lead': 'Wypróbuj Leadscraper ',
  'og.title.trust.grad': '3 dni za darmo',
  'og.title.trust.tail': ' z 50 prawdziwymi leadami.',
  'og.subtitle.trust':
    'Dzisiaj nic nie pobieramy. Testujesz na prawdziwych leadach z Twojej grupy docelowej, a jeśli to nie pasuje, kończysz okres próbny jednym kliknięciem. Bez rozmowy telefonicznej, bez okresu wypowiedzenia.',
  'og.trust.demo.tag': 'Demo na żywo · nie film marketingowy',
  'og.trust.demo.title': 'Zobacz, jak Leadscraper znajduje Twoje leady',
  'og.trust.demo.body':
    'Prawdziwe wyszukiwanie, prawdziwy dashboard, prawdziwe wyniki: założyciel Janik przeprowadza Cię przez cały proces, od opisania grupy docelowej aż po gotową listę leadów.',
  'og.trust.demo.play': 'Odtwórz film demo',
  'og.trust.demo.close': 'Zamknij',
  'og.trust.timeline.1.when': 'Dzisiaj',
  'og.trust.timeline.1.body':
    'Wybierz plan, dodaj metodę płatności. {s}, Twoje 50 Credits jest dostępne od razu.',
  'og.trust.timeline.1.strong': '0 € pobrania',
  'og.trust.timeline.2.when': 'Dzień 1–3',
  'og.trust.timeline.2.body':
    'Testujesz na prawdziwych leadach. Nie jesteś przekonany? {s} natychmiast kończy okres próbny, bez kontaktu, bez pytań.',
  'og.trust.timeline.2.strong': 'Jedno kliknięcie w koncie',
  'og.trust.timeline.3.when': 'Od dnia 3',
  'og.trust.timeline.3.body':
    'Dopiero teraz startuje Twoja subskrypcja w wybranym planie. {s}, bez minimalnego okresu.',
  'og.trust.timeline.3.strong': 'Anulujesz co miesiąc',
  'og.trust.ctaNote': 'Dzisiaj 0 € · Zakończenie = 1 kliknięcie',
  'og.trust.proof.head': 'Zespoły sprzedażowe, które już się przesiadły',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Opinie w serwisie {platform}',
  'og.trust.bar.card.title': '0 € dzisiaj',
  'og.trust.bar.card.body': 'Karta, PayPal lub polecenie zapłaty SEPA, bezpiecznie przez Stripe',
  'og.trust.bar.cancel.title': 'Anulujesz w 5 sekund',
  'og.trust.bar.cancel.body': '1 kliknięcie w koncie, bez kontaktu, działa natychmiast',
  'og.trust.bar.gdpr.title': 'Tylko dane publiczne',
  'og.trust.bar.gdpr.body': 'RODO by design · serwery w UE · tylko publiczne źródła',
  'og.trust.founderLine.title': 'Tworzone w Hamburgu, w Niemczech',
  'og.trust.founderLine.name': ', Janik Deimann, założyciel',
  'og.trust.founderLine.sub':
    'Niemiecka inżynieria, europejska ochrona danych, a gdy do nas napiszesz, odpowiada człowiek.',
  'og.trust.founderLine.ask':
    'Wciąż masz wątpliwości? Napisz do nas: support@leadscraper.eu, odpowie człowiek.',

  // --- Paywall wersja 19 (zatwierdzona przez Janika 11.09.2026) ---
  // Niemiecki to zatwierdzony oryginał: zachowaj doprecyzowane „do 50" oraz
  // informację o dodatkowych kredytach w każdym tłumaczeniu.
  'og.r19.accountReady': 'Konto utworzone · Aktywuj okres próbny',
  'og.r19.headline.lead': 'Znajdź do',
  'og.r19.headline.grad': '50 darmowych leadów.',
  'og.r19.lead':
    'Zacznij dziś od firm pasujących do Twojej oferty. Okres próbny zawiera {credits} kredytów na maksymalnie {credits} leadów firmowych.',
  'og.r19.offerNote':
    'Kontakty i research firm kosztują dodatkowe kredyty. Kredyty zużyte na to zmniejszają liczbę firm.',
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Doskonałe opinie użytkowników',
  'og.r19.rating.aria': 'Ocena klientów: 4,8 na 5 gwiazdek',
  'og.r19.product.footnote': 'To Ty decydujesz, które firmy zbadać dokładniej.',
  'og.r19.picker.title': 'Zacznij teraz za darmo.',
  'og.r19.picker.trialCredits': '{credits} kredytów próbnych',
  'og.r19.picker.trialPlan': '{plan} · {days} dni za 0 €, potem {renewal}, rezygnacja w każdym miesiącu',
  'og.r19.picker.trialPlanAll': '{plan} · test za 0 €, potem {renewal}, rezygnacja w każdym miesiącu',
  'og.r19.picker.today': '0 €',
  'og.r19.picker.todayLabel': 'dzisiaj',
  'og.r19.picker.description': 'Wybierz pakiet na okres po teście.',
  'og.r19.credits.title': 'Znalezienie 1 firmy',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 kredyt',
  'og.r19.credits.note': 'Kontakty i research firm kosztują dodatkowe kredyty.',
  'og.r19.credits.info': 'Zobacz przykład zużycia kredytów',
  'og.r19.credits.example':
    'Przykład: znajdujesz 20 firm i przy 10 z nich dodajesz kontakty oraz research firmy. To 40 kredytów.',
  'og.r19.credits.exampleRest': 'Z {credits} kredytów próbnych zostaje Ci {rest}.',
  'og.r19.credits.disclaimer':
    '{credits} kredytów to nie automatycznie {credits} w pełni zbadanych kontaktów.',
  'og.r19.plans.legend': 'Wybierz pakiet na okres po teście',
  'og.r19.plans.creditsPerMonth': '{credits} kredytów / miesiąc',
  'og.r19.plans.perMonth': '/ miesiąc',
  'og.r19.plans.caption.basic': 'Na dobry początek',
  'og.r19.plans.caption.starter': 'Do regularnej akwizycji',
  'og.r19.plans.caption.growth': 'Dla większego zespołu sprzedaży',
  'og.r19.cta': 'Zacznij za darmo',
  'og.r19.renewal': 'Potem {s} za {credits} kredytów.',
  'og.r19.renewal.strong': '{price} € / miesiąc',
  'og.r19.renewal.cancel': 'Anuluj przed końcem testu, a nie zapłacisz nic.',
  'og.r19.security': 'Metoda płatności w następnym kroku',
  'og.r19.help.faq': 'Test i anulowanie',
  'og.r19.help.features': 'Pakiety szczegółowo',
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'Na żywo',
  'mcp.tok.generate': 'Wygeneruj token',
  'mcp.tok.title': 'Połącz klienta AI',
  'mcp.tok.intro':
    'Wygeneruj osobisty token, aby połączyć Claude, Cursor lub własnego agenta z kontem Leadscraper. Token jest pokazywany tylko raz.',
  'mcp.tok.name': 'Nazwa tokena',
  'mcp.tok.generating': 'Generowanie…',
  'mcp.tok.once':
    'Skopiuj ten token teraz: ze względów bezpieczeństwa nie zostanie ponownie pokazany.',
  'mcp.tok.yourToken': 'Twój token',
  'mcp.tok.copy': 'Kopiuj',
  'mcp.tok.copied': 'Skopiowano',
  'mcp.tok.claudeConfig': 'Konfiguracja Claude Desktop',
  'mcp.tok.copyConfig': 'Kopiuj konfigurację',
  'mcp.tok.done': 'Gotowe',
  'mcp.tok.limit': 'Osiągnięto limit tokenów. Najpierw odwołaj stary.',
  'mcp.tok.mintFailed': 'Nie udało się wygenerować tokena. Spróbuj ponownie.',
  'mcp.tok.revoked': 'Token „{name}” odwołany',
  'mcp.tok.revokeFailed': 'Nie udało się odwołać tokena.',
  'mcp.tok.expires': 'wygasa',
  'mcp.tok.lastUsed': 'ostatnio użyty',
  'mcp.tok.neverUsed': 'nigdy nie użyty',
  'mcp.tok.revoke': 'Odwołaj',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Połącz z Claude',
  'mcp.claude.cardHint': 'Claude.ai (web) łączy się jednym kliknięciem przez OAuth, bez tokenu.',
  'mcp.claude.intro':
    'Dodaj Leadscraper do Claude.ai jako custom connector. Zatwierdzasz dostęp raz: żadnego tokenu do kopiowania ani wklejania.',
  'mcp.claude.cta': 'Otwórz konektory Claude',
  'mcp.claude.urlLabel': 'Twój adres URL serwera MCP',
  'mcp.claude.step1': 'Kliknij „Otwórz konektory Claude", a potem „Add custom connector".',
  'mcp.claude.step2': 'Wklej powyższy adres URL i kontynuuj.',
  'mcp.claude.step3': 'Zatwierdź dostęp („Allow"). Claude może teraz korzystać z Twoich leadów.',
  'mcp.claude.desktopNote': 'Używasz Claude Desktop, Cursora albo własnego agenta?',
  'mcp.claude.desktopCta': 'Wygeneruj token zamiast tego',
  'acct.bill.addMethod': 'Dodaj metodę płatności',
  'acct.bill.cardEnds': 'Visa kończąca się na •• 4242',
  'acct.bill.cardExpHolder': 'Wygasa 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Kwota',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Data',
  'acct.bill.col.desc': 'Opis',
  'acct.bill.col.invoice': 'Faktura',
  'acct.bill.col.status': 'Status',
  'acct.bill.descSub': 'Subskrypcja {plan} · {month} {year}',
  'acct.bill.empty': 'Nie znaleziono transakcji',
  'acct.bill.emptySub': 'Historia płatności pojawi się tutaj po pierwszym zakupie.',
  'acct.bill.filter.30': 'Ostatnie 30 dni',
  'acct.bill.filter.90': 'Ostatnie 90 dni',
  'acct.bill.filter.all': 'Zawsze',
  'acct.bill.history': 'Historia transakcji',
  'acct.bill.manageCards': 'Zarządzaj kartami',
  'acct.bill.manageViaStripe': 'Zarządzaj przez Portal Klienta Stripe',
  'acct.bill.methodAutoAdded': 'Zostanie automatycznie dodana po rozpoczęciu okresu próbnego.',
  'acct.bill.methodOnFile': 'Metoda płatności zapisana',
  'acct.bill.methods': 'Metody płatności',
  'acct.bill.noMethods': 'Nie znaleziono metod płatności',
  'acct.bill.paid': 'Opłacone',
  'acct.bill.pdfUnavailable': 'Tej faktury nie da się teraz wczytać tutaj jako PDF. Możesz ją otworzyć i pobrać w Stripe.',
  'acct.bill.pdfOpenStripe': 'Otwórz fakturę w Stripe',
  'acct.bill.primary': 'Główna',
  'acct.dataAccount': 'Dane i konto',
  'acct.deleteAccount.btn': 'Usuń konto',
  'acct.deleteAccount.confirmBtn': 'Usuń konto na stałe',
  'acct.deleteAccount.confirmPwLabel': 'Wprowadź hasło, aby potwierdzić',
  'acct.deleteAccount.deleting': 'Usuwanie …',
  'acct.deleteAccount.errFailed': 'Usuwanie nieudane.',
  'acct.deleteAccount.errPwRequired': 'Proszę wprowadzić hasło.',
  'acct.deleteAccount.modalBody':
    'Twoje konto zostanie dezaktywowane i ostatecznie usunięte po 30 dniach. W tym okresie możesz je reaktywować za pomocą e-maila + hasła. Wszystkie Twoje leady, profile i oceny zostaną wtedy nieodwracalnie usunięte.',
  'acct.deleteAccount.modalTitle': 'Usuń konto',
  'acct.deleteAccount.title': 'Usuń konto',
  'acct.deleteAccount.warn':
    'Twoje konto zostanie ostatecznie usunięte za 30 dni. Możesz je reaktywować w tym czasie.',
  'acct.seedimport.title': 'Importuj listę obecnych klientów',
  'acct.seedimport.desc':
    'Prześlij plik CSV lub tekstowy ze swoimi obecnymi klientami — jedna domena lub URL w wierszu (lub kolumna domen). Te firmy nigdy nie są dostarczane jako nowy lead w ŻADNEJ grupie odbiorców.',
  'acct.seedimport.hint': 'CSV lub .txt · maks. 5 MB',
  'acct.seedimport.cta': 'Prześlij CSV',
  'acct.seedimport.uploading': 'Importowanie …',
  'acct.seedimport.report':
    '{rows} wierszy · {resolved} rozpoznanych domen · {added} nowych · {total} na Twojej liście',
  'acct.seedimport.unresolved': '{n} wierszy pominięto (brak rozpoznawalnej domeny)',
  'acct.seedimport.capped': 'Osiągnięto limit importu — nie wszystkie domeny zostały dodane.',
  'acct.seedimport.failed': 'Import nie powiódł się. Sprawdź plik i spróbuj ponownie.',
  'acct.export.btn': 'Eksportuj',
  'acct.export.failed': 'Eksport nieudany. Spróbuj ponownie.',
  'acct.export.preparing':
    'Przygotowywanie eksportu: przy dużej ilości danych może to chwilę potrwać.',
  'acct.export.ready': 'Pobieranie rozpoczęte.',
  'acct.export.sub': 'RODO Art. 20: Wszystkie Twoje dane do pobrania jako JSON.',
  'acct.export.title': 'Eksportuj dane',
  'acct.int.apiKey': 'Klucz API',
  'acct.int.apiKeyP': 'Z ustawień programisty twojego CRM',
  'acct.int.autoPush': 'Auto-Push przy „Pasuje"',
  'acct.int.autoPushSub': 'Leads są automatycznie przekazywane do CRM po ich potwierdzeniu.',
  'acct.int.bulkPush': 'Wyślij {n} do CRM',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'Połączenie OAuth nie powiodło się',
  'acct.int.reconnect': 'Połącz ponownie',
  'acct.int.reconnectRequired': 'Wymagane ponowne połączenie',
  'acct.int.connectedVia': 'Połączono przez OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Wysyłanie…',
  'det.crmPushFail': 'Wysyłanie do CRM nie powiodło się',
  'det.crmSubRequired': 'Wysyłanie do CRM wymaga płatnego planu.',
  'det.crmDuplicate': 'Już w CRM',
  'det.crmNotConnected': 'Brak połączonego CRM: skonfiguruj jeden w Konto → Integracje',
  'det.crmOpenRecord': 'Zobacz rekord',
  'acct.int.pushFail': 'Wysyłanie do CRM nie powiodło się',
  'acct.int.pushDuplicate': 'Już w CRM',
  'acct.int.pushSubRequired': 'Wysyłanie do CRM wymaga płatnego planu.',
  'acct.int.bulkSummary': '{pushed} wysłanych · {skipped} pominiętych · {failed} nieudanych',
  'leads.bulkPushBtn': 'Wyślij {n} do {crm}',
  'leads.bulkPushPickBtn': 'Wyślij {n} do CRM ▾',
  'leads.bulkPushTitle': 'Wyślij aktualnie widoczne leady (maks. 50) do swojego CRM',
  'acct.int.cancel': 'Anuluj',
  'acct.int.connect': 'Połącz',
  // LEA-317
  'acct.int.subRequired':
    'Integracje CRM są dostępne tylko w planach płatnych. Ulepsz swój plan, aby połączyć CRM.',
  'acct.int.upgradeTitle': 'Ulepsz plan, aby połączyć CRM',
  'acct.int.upgradeCta': 'Ulepsz plan',
  'acct.int.connectFirst':
    'Połącz swoje CRM w ustawieniach konta, aby automatycznie przesyłać Leads.',
  'acct.int.connectSuccess': 'Połączono z {name}',
  'acct.int.connected': 'Połączony',
  'acct.int.disconnect': 'Rozłącz',
  'acct.int.disconnectSuccess': 'Rozłączono z {name}',
  'acct.int.manage': 'Zarządzaj',
  'acct.int.mapping': 'Mapowanie pól',
  'acct.int.mappingSub': 'Pola Leadscraper → Pola CRM',
  'acct.int.none': 'Brak połączonego CRM',
  'acct.int.notConnected': 'Niepołączony',
  'acct.int.notPushedYet': 'Jeszcze nie wysłane',
  'acct.int.object': 'Typ obiektu',
  'acct.int.openInCRM': 'Otwórz w {name}',
  'acct.int.owner': 'Właściciel',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': '{n} Lead(s) wysłane do {name}',
  'acct.int.pushToCRM': 'Wyślij do CRM',
  'acct.int.pushedAt': 'Wysłane {when}',
  'acct.int.pushedTo': 'W {name}',
  'acct.int.save': 'Zapisz połączenie',
  'acct.int.sectionLead': 'Status CRM',
  'acct.int.stage': 'Etap dla nowych Leads',
  'acct.int.sub':
    'Połącz swój CRM i automatycznie przekazuj pasujące Leads – lub ręcznie dla każdego Lead.',
  // LEA-334: webhook signing secret + verification handshake
  'acct.int.whsec.title': 'Sekret podpisujący webhooki',
  'acct.int.whsec.sub':
    'Każde wywołanie webhooka podpisujemy algorytmem HMAC-SHA256, dzięki czemu Twój endpoint może zweryfikować, że naprawdę pochodzi z Leadscraper.',
  'acct.int.whsec.revealed': 'Skopiuj go teraz: pokazujemy go tylko raz.',
  'acct.int.whsec.copy': 'Kopiuj',
  'acct.int.whsec.copied': 'Skopiowano',
  'acct.int.whsec.rotate': 'Wygeneruj i pokaż sekret',
  'acct.int.whsec.rotating': 'Generowanie…',
  'acct.int.whsec.rotateHint':
    'Wygenerowanie tworzy nowy sekret i pokazuje go jeden raz, pamiętaj, aby potem zaktualizować swój endpoint.',
  'acct.int.whsec.fail': 'Nie udało się wygenerować nowego sekretu podpisującego.',
  'acct.int.whsec.docs':
    'Weryfikacja: nagłówek X-Leadscraper-Signature: t=<unix>,v1=<hex>, gdzie hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Odrzuć żądanie, jeśli się nie zgadza lub znacznik czasu jest nieaktualny.',
  'acct.int.webhookUrl': 'Adres URL webhooka',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'Nowe leady są wysyłane do Twojego webhooka automatycznie, gdy tylko ich kontakty zostaną wzbogacone.',
  'acct.int.whverify.title': 'Zweryfikuj swój endpoint',
  'acct.int.whverify.sub':
    'Osiągalny endpoint (zwraca 2xx) to nie to samo co zweryfikowany. Potwierdź jednorazowy kod, żebyśmy wiedzieli, że leady faktycznie docierają. Do tego czasu nie dostarczamy żadnych.',
  'acct.int.whverify.verified': '✓ Zweryfikowano',
  'acct.int.whverify.unverified': 'Niezweryfikowany',
  'acct.int.whverify.send': 'Wyślij zdarzenie testowe',
  'acct.int.whverify.sending': 'Wysyłanie…',
  'acct.int.whverify.resend': 'Wyślij ponownie zdarzenie testowe',
  'acct.int.whverify.sent': 'Zdarzenie testowe wysłane. Sprawdź kod na swoim endpoincie.',
  'acct.int.whverify.sendFail': 'Nie udało się wysłać zdarzenia testowego.',
  'acct.int.whverify.enter': 'Wpisz kod (LSWH-…), który dotarł na Twój endpoint:',
  'acct.int.whverify.confirm': 'Potwierdź',
  'acct.int.whverify.ok': 'Webhook zweryfikowany. Leady mogą być już dostarczane.',
  'acct.int.whverify.mismatch': 'Ten kod się nie zgadza. Sprawdź swój endpoint i spróbuj ponownie.',
  'acct.int.whverify.expired': 'Ten kod wygasł. Wyślij nowe zdarzenie testowe.',
  'acct.int.testing': 'Testowanie połączenia…',
  'acct.int.title': 'Integracje CRM',
  'acct.menu.logout': 'Wyloguj się',
  'acct.menu.settings': 'Ustawienia konta',
  'acct.plan.active': 'Aktywny',
  'acct.plan.canceled': 'Anulowano',
  'acct.plan.refundedEnded':
    'Subskrypcja zwrócona. Plan zakończony. Wybierz plan, aby kontynuować.',
  'acct.plan.addOneOff': 'Dokup pakiet jednorazowy',
  'acct.plan.afterTrial': 'Po okresie próbnym',
  'acct.plan.bonusCredits': 'Credits z pakietu',
  'acct.plan.bonusCreditsTip':
    'Płatne Credits z pakietów jednorazowych, dodawane do miesięcznego limitu i nie wygasają.',
  'acct.plan.dayLeft':
    'Pozostał 1 dzień darmowego okresu próbnego, potem subskrypcja będzie automatycznie kontynuowana.',
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge':
    'Pierwsze obciążenie {date}. Zrezygnuj w każdej chwili jednym kliknięciem.',
  'acct.plan.daysLeft':
    'Pozostało {n} dni darmowego okresu próbnego, potem subskrypcja będzie automatycznie kontynuowana.',
  'acct.plan.endsToday':
    'Okres próbny kończy się dzisiaj. Subskrypcja rozpocznie się automatycznie.',
  'acct.plan.leftOf': 'z {total} pozostało',
  'acct.plan.monthUsage': 'Leads w tym miesiącu',
  'acct.plan.nextBill': 'Następna płatność {date} · {leads} Leads/miesiąc',
  'acct.plan.cancelsOn': 'Kończy się {date}',
  'acct.plan.cancelNote': 'Bez dalszych obciążeń, aktywny do {date}.',
  'acct.plan.perMonth': '/ miesiąc',
  'acct.plan.secureSub': 'Zabezpiecz subskrypcję',
  'acct.plan.switch': 'Zmień plan',
  'acct.plan.trial': 'Okres próbny',
  'acct.plan.trialCredits': 'Credits próbne',
  'acct.plan.trialCreditsTip':
    'Darmowe Credits próbne z rejestracji, dodawane do miesięcznego limitu i nie wygasają.',
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'Credits przeniesione',
  'acct.plan.carriedOverCreditsTip':
    'Twoje saldo sprzed przejścia na rozliczanie za kontakt, dodawane do miesięcznego limitu i nie wygasa.',
  'acct.plan.trialUsage': 'Testowe Leads w tym okresie',
  'acct.plan.usedThisMonth': '{used} / {total} wykorzystanych w tym miesiącu · Reset {date}',
  'acct.plan.your': 'Twój plan',
  'acct.prof.avatarErr': 'Nie udało się przesłać zdjęcia. Spróbuj ponownie.',
  'acct.prof.avatarMime': 'Wybierz plik JPG, PNG lub WebP.',
  'acct.prof.avatarSize': 'Plik za duży (maks. 2 MB).',
  'acct.prof.avatarUpdated': 'Zdjęcie profilowe zaktualizowane.',
  'acct.prof.email': 'Adres e-mail',
  'acct.prof.first': 'Imię',
  'acct.prof.lang': 'Język',
  'acct.prof.last': 'Nazwisko',
  'acct.prof.save': 'Zapisz',
  'acct.prof.title': 'Informacje o profilu',
  'acct.prof.upload': 'Prześlij zdjęcie',
  'acct.prof.uploadHint': 'JPG, PNG lub WebP. Maks. 2 MB.',
  'acct.pw.changing': 'Zmiana w toku…',
  'acct.pw.complexity':
    'Nowe hasło musi zawierać co najmniej 8 znaków, duże i małe litery, cyfrę i znak specjalny (@$!%*?&).',
  'acct.pw.confirm': 'Potwierdź nowe hasło',
  'acct.pw.cta': 'Zmień hasło',
  'acct.pw.current': 'Obecne hasło',
  'acct.pw.failed': 'Nie udało się zmienić hasła.',
  'acct.pw.minErr': 'Minimum 8 znaków.',
  'acct.pw.minHint': 'Minimum 8 znaków',
  'acct.pw.mismatch': 'Hasła nie pasują do siebie.',
  'acct.pw.new': 'Nowe hasło',
  'acct.pw.sameAsCurrent': 'Nowe hasło musi być inne od bieżącego.',
  'acct.pw.success': 'Hasło zmienione ✓',
  'acct.pw.title': 'Zmień hasło',
  'acct.pw.wrongCurrent': 'Bieżące hasło jest nieprawidłowe.',
  'acct.sec.active': 'Aktywne',
  'acct.sec.change': 'Zmień',
  'acct.sec.inactive': 'Nieaktywne',
  'acct.sec.pw': 'Zmień hasło',
  'acct.sec.pwSub': 'Zmień tutaj hasło do konta',
  'acct.sec.title': 'Ustawienia bezpieczeństwa',
  'acct.sec.twofa': 'Uwierzytelnianie dwuskładnikowe',
  'acct.sec.twofaActivate': 'Włącz 2FA',
  'acct.sec.twofaDeactivate': 'Wyłącz 2FA',
  'acct.sec.twofaSoon':
    'Uwierzytelnianie dwuskładnikowe (aplikacja Authenticator) nie jest jeszcze tutaj podłączone: przełącznik działał dotąd tylko lokalnie. Prawdziwe 2FA nadchodzi jako następne.',
  'acct.sec.twofaSub':
    'Uwierzytelnianie jest wyłączone. Włącz je, aby dodać dodatkową warstwę bezpieczeństwa do konta.',
  'acct.sub':
    'Zarządzaj ustawieniami profilu, zmieniaj metody płatności i pobieraj faktury za wcześniejsze transakcje.',
  'acct.tab.billing': 'Płatności',
  'acct.tab.integrations': 'Integracje',
  'acct.tab.profile': 'Profil',
  'acct.founder.title': 'Bezpośredni kontakt z założycielem',
  'acct.founder.body':
    'Feedback, pytanie, problem? Twoja wiadomość trafia bezpośrednio do Janika, nie do systemu ticketów.',
  'acct.founder.cta': 'Napisz do Janika',
  'acct.title': 'Profil',
  'acct.toast.failed': 'Zapisanie nie powiodło się. Spróbuj ponownie.',
  'acct.toast.saved': 'Profil zapisany.',

  'ai.collapse': 'Zwiń',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Ukryj',
  'ai.errorReply':
    'Nie mogę teraz uzyskać dostępu do moich danych. Spróbuj ponownie za chwilę, lub sformułuj pytanie krócej.',
  'ai.footer': 'Leadscraper zna tylko Twoje grupy docelowe i oceny, żadnych danych zewnętrznych.',
  'ai.greeting':
    'Hej 👋 Jestem Twoim asystentem Leadscraper. Widzę Twój aktywny profil "{profile}" i wszystkie wzorce, których system się nauczył. O co chodzi?',
  'ai.inputP': 'Zapytaj asystenta o coś …',
  'ai.ins.edge.cta': 'Zobacz leada',
  'ai.ins.edge.fallback':
    'Leadscraper jest tutaj niepewny. Twoja ocena pomoże doprecyzować wzorzec.',
  'ai.ins.edge.title': 'Przypadek graniczny: {company}',
  'ai.ins.pattern.cta': 'Sprawdź wzorzec',
  'ai.ins.pattern.title': 'Nowy wzorzec w "{profile}"',
  'ai.ins.tune.body':
    'Współczynnik dopasowań przy {rate} %. Mogę pomóc Ci sformułować następne wyszukiwanie bardziej precyzyjnie.',
  'ai.ins.tune.cta': 'Udoskonal wyszukiwanie',
  'ai.ins.tune.title': '"{profile}" wciąż w trakcie treningu',
  'ai.intro':
    'Monitoruję Twoje profile 24/7 i pomagam Ci formułować precyzyjniejsze wyszukiwania oraz pewne sygnały uczenia.',
  'ai.langHint':
    'Odpowiedz po polsku. Maksymalnie 3-4 krótkie zdania na odpowiedź, chyba że przy konkretnych instrukcjach.',
  'ai.moreN': '+{n} więcej',
  'ai.now': 'teraz',
  'ai.onlinePrefix': 'Online · zna Twoje {n} grup docelowych',
  'ai.openChat': 'Otwórz czat',
  'ai.quickStart': 'Szybki start',
  'ai.seedRefine': 'Zaproponuj dopracowane wyszukiwanie dla mojej grupy docelowej „{profile}".',
  'ai.send': 'Wyślij',
  'ai.sp1.label': 'Jak stoi moja aktywna grupa docelowa?',
  'ai.sp1.prompt':
    'Podsumuj mi w 3 zdaniach, jak dobrze Leadscraper zrozumiał już mój aktywny profil, co zostało nauczone, a co nie?',
  'ai.sp2.label': 'Które wzorce powinienem potwierdzić?',
  'ai.sp2.prompt':
    'Które nauczone wzorce powinienem jako następne potwierdzić lub odrzucić, żeby system uczył się szybciej?',
  'ai.sp3.label': 'Zaproponuj wyszukiwanie',
  'ai.sp3.prompt':
    'Zaproponuj mi precyzyjne następne wyszukiwanie oparte na moim aktywnym profilu, z branżą, lokalizacją, wielkością i dodatkami.',
  'ai.sp4.label': 'Gdzie tracę jakość?',
  'ai.sp4.prompt':
    'Gdzie w moich profilach widzisz potencjał na wyższe współczynniki dopasowań? Co powinienem dostosować?',
  'ai.tag.confirmed': 'potwierdzone',
  'ai.tag.uncertain': 'niepewne',
  'ai.tag.unconfirmed': 'niepotwierdzone',
  'ai.thinkingAbout': 'O czym teraz myślę',

  'api.confidence.cautiously_optimistic': 'ostrożnie optymistyczny',
  'api.confidence.fairly_sure': 'umiarkowanie pewny',
  'api.confidence.uncertain': 'niepewny',
  'api.confidence.very_sure': 'bardzo pewny',

  'apierr.intentParseTimeout': "Nasza AI potrzebowała zbyt dużo czasu na odczytanie opisu — spróbuj ponownie za chwilę.",

  'auth.login.docTitle': 'Logowanie · Leadscraper',
  'auth.login.email': 'E-mail',
  'auth.login.errCredentials': 'E-mail lub hasło jest nieprawidłowe.',
  'auth.login.errEmail': 'Nieprawidłowy adres e-mail.',
  'auth.login.errEmpty': 'Wypełnij wszystkie pola.',
  'auth.login.errGeneric': 'Logowanie nieudane. Spróbuj ponownie.',
  'auth.login.errUnverified': 'Najpierw potwierdź swój adres e-mail.',
  'auth.login.forgot': 'Zapomniałeś hasła?',
  'auth.login.google': 'Zaloguj się przez Google',
  'auth.login.googleBusy': 'Logowanie przez Google…',
  'auth.login.hidePassword': 'Ukryj hasło',
  'auth.login.microsoft': 'Zaloguj się przez Microsoft',
  'auth.login.microsoftBusy': 'Logowanie przez Microsoft…',
  'auth.login.noAccount': 'Nie masz jeszcze konta?',
  'auth.login.or': 'Lub',
  'auth.login.password': 'Hasło',
  'auth.login.remember': 'Pozostań zalogowany',
  'auth.login.showPassword': 'Pokaż hasło',
  'auth.login.signUp': 'Zarejestruj się',
  'auth.login.sub': 'Zaloguj się do swojego konta, aby uzyskać dostęp.',
  'auth.login.submit': 'Zaloguj się',
  'auth.login.submitting': 'Logowanie…',
  'auth.login.title': 'Witamy z powrotem',
  'auth.register.docTitle': 'Rejestracja · Leadscraper',
  'auth.register.email': 'E-mail',
  'auth.register.errEmail': 'Nieprawidłowy adres e-mail.',
  'auth.register.errEmpty': 'Wypełnij wszystkie pola.',
  'auth.register.errBotCheck': 'Ukończ weryfikację antybotową.',
  'auth.register.errPwMismatch': 'Hasła nie są identyczne.',
  'auth.register.errPwShort': 'Hasło musi mieć co najmniej 8 znaków.',
  'auth.register.firstName': 'Imię',
  'auth.register.google': 'Zarejestruj się przez Google',
  'auth.register.googleBusy': 'Rejestracja przez Google…',
  'auth.register.haveAccount': 'Masz już konto?',
  'auth.register.hidePassword': 'Ukryj hasło',
  'auth.register.lastName': 'Nazwisko',
  'auth.register.microsoft': 'Zarejestruj się przez Microsoft',
  'auth.register.microsoftBusy': 'Rejestracja przez Microsoft…',
  'auth.register.or': 'Lub',
  'auth.register.password': 'Hasło',
  'auth.register.passwordConfirm': 'Potwierdź hasło',
  'auth.register.showPassword': 'Pokaż hasło',
  'auth.register.signIn': 'Zaloguj się',
  'auth.register.sub':
    'Przetestuj, jak łatwo można dziś generować precyzyjne listy leadów dzięki agentom AI.',
  'auth.register.submit': 'Utwórz konto',
  'auth.register.submitting': 'Tworzenie…',
  'auth.register.title': 'Utwórz darmowe konto',
  'auth.reset.backToLogin': 'Powrót do logowania',
  'auth.reset.confirmLabel': 'Potwierdź hasło*',
  'auth.reset.confirmPlaceholder': 'Wprowadź hasło ponownie',
  'auth.reset.docTitle': 'Reset hasła · Leadscraper',
  'auth.reset.doneSub': 'Możesz się teraz zalogować używając nowego hasła.',
  'auth.reset.doneTitle': 'Hasło zostało pomyślnie zmienione',
  'auth.reset.emailLabel': 'E-mail*',
  'auth.reset.emailPlaceholder': 'Podaj swój adres e-mail',
  'auth.reset.errInvalidEmail': 'Podaj prawidłowy adres e-mail.',
  'auth.reset.errPwMismatch': 'Hasła nie są identyczne.',
  'auth.reset.errPwShort': 'Hasło musi mieć co najmniej 8 znaków.',
  'auth.reset.errPwWeak': 'Hasło musi zawierać wielkie i małe litery, cyfrę oraz znak specjalny.',
  'auth.reset.pwRules':
    'Co najmniej 8 znaków, w tym wielkie i małe litery, cyfra i znak specjalny.',
  'auth.reset.errRequest': 'Błąd żądania. Spróbuj ponownie.',
  'auth.reset.goToLogin': 'Przejdź do logowania',
  'auth.reset.haveAccount': 'Masz już konto?',
  'auth.reset.hidePassword': 'Ukryj hasło',
  'auth.reset.invalidSub': 'Ten link do resetowania hasła nie jest już aktywny. Poproś o nowy.',
  'auth.reset.invalidTitle': 'Link nieprawidłowy lub wygasł',
  'auth.reset.newPwLabel': 'Nowe hasło*',
  'auth.reset.newPwPlaceholder': 'Co najmniej 8 znaków',
  'auth.reset.newPwSub': 'Wybierz nowe hasło dla swojego konta.',
  'auth.reset.newPwTitle': 'Ustaw nowe hasło',
  'auth.reset.requestNew': 'Poproś o nowy link',
  'auth.reset.oauthTitle': 'To konto korzysta z logowania {provider}',
  'auth.reset.oauthSub': 'To konto nie ma hasła. Zaloguj się zamiast tego przez {provider}.',
  'auth.reset.resetBtn': 'Resetuj hasło',
  'auth.reset.saving': 'Zapisywanie…',
  'auth.reset.send': 'Wyślij link',
  'auth.reset.sending': 'Wysyłanie…',
  'auth.reset.sentSub':
    'Jeśli konto z tym adresem e-mail istnieje, wysłaliśmy Ci link do resetowania. Sprawdź swoją skrzynkę odbiorczą (oraz spam).',
  'auth.reset.sentTitle': 'E-mail wysłany',
  'auth.reset.showPassword': 'Pokaż hasło',
  'auth.reset.signIn': 'Zaloguj się',
  'auth.reset.sub': 'Podaj swój adres e-mail, a wyślemy Ci link do zresetowania hasła.',
  'auth.reset.title': 'Reset hasła',
  'auth.shell.nextSlide': 'Następny slajd',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  'auth.slides.1.headline':
    'Agenci AI znajdują firmy B2B, które dokładnie pasują do Twojego profilu klienta docelowego.',
  'auth.slides.2.headline':
    'Każda lista leadów jest generowana świeżo ze źródeł publicznych, żadnych nieaktualnych ani odsprzedawanych danych.',
  'auth.slides.3.headline':
    'Każdy lead zawiera istotnych decydentów, linki źródłowe i jasne uzasadnienie, dlaczego pasuje.',
  'auth.slides.aria.region': 'Najważniejsze funkcje produktu',
  'auth.slides.aria.slide': 'Slajd {n} z {total}',
  'auth.slides.aria.goTo': 'Przejdź do slajdu {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Przejdź do treści',
  'auth.r19.header.haveAccount': 'Masz już konto?',
  'auth.r19.hero.titleLead': 'Znajdź',
  'auth.r19.hero.titleGrad': 'klientów,',
  'auth.r19.hero.titleTail': 'dla których stworzona jest Twoja oferta.',
  'auth.r19.hero.lead':
    'Opisz, do kogo chcesz dotrzeć. Leadscraper znajduje pasujące firmy, wyszukuje osoby kontaktowe i pokazuje, od czego zacząć rozmowę.',
  'auth.r19.demo.caption': 'Twój research. Krok po kroku.',
  'auth.r19.demo.play': 'Zobacz przebieg',
  'auth.r19.form.title': 'Zacznij z Leadscraper.',
  'auth.r19.form.google': 'Przez Google',
  'auth.r19.form.microsoft': 'Przez Microsoft',
  'auth.r19.form.separator': 'lub przez e-mail',
  'auth.r19.form.businessEmail': 'Firmowy e-mail',
  'auth.r19.form.emailPlaceholder': 'ty@firma.pl',
  'auth.r19.form.show': 'Pokaż',
  'auth.r19.form.hide': 'Ukryj',
  'auth.r19.legal.accept':
    'Rejestrując się, akceptujesz nasz {terms}. Informacje o Twoich danych znajdziesz w naszej {privacy}.',
  'auth.r19.legal.privacyLink': 'polityce prywatności',
  'auth.r19.proof.founderTitle': 'Osobiste wsparcie założyciela.',
  'auth.r19.proof.founderBody': 'Janik jest Twoją bezpośrednią osobą kontaktową.',
  'auth.r19.confidence.eyebrow': 'Przed Twoją pierwszą rozmową',
  'auth.r19.confidence.title1': 'Wiesz, do kogo się zwracasz.',
  'auth.r19.confidence.title2': 'I dlaczego.',
  'auth.r19.confidence.p1.title': 'Źródła są częścią wyniku.',
  'auth.r19.confidence.p1.body':
    'Widzisz, na czym opiera się research, i możesz samodzielnie sprawdzić dane.',
  'auth.r19.confidence.p2.title': 'Luki pozostają widoczne.',
  'auth.r19.confidence.p2.body':
    'Jeśli brakuje jakiejś informacji, widać to. Sam decydujesz, jak prowadzić research dalej.',
  'auth.r19.confidence.p3.title': 'Dostajesz punkt zaczepienia.',
  'auth.r19.confidence.p3.body':
    'Wiedza o firmie pomaga przygotować pierwszy kontakt wokół konkretnego powodu.',
  'auth.r19.founder.eyebrow': 'Osobiście przy Tobie',
  'auth.r19.founder.role': 'Założyciel Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, założyciel Leadscraper',
  'auth.r19.founder.body':
    'Osobiście pomagam Ci w wyszukiwaniu i w pytaniach dotyczących Leadscraper.',
  'auth.r19.founder.contact': 'Zapytaj na czacie',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Prywatność',
  'auth.r19.footer.imprint': 'Nota prawna',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/pl/nota-prawna',
  'auth.r19.footer.navLabel': 'Informacje prawne',
  'auth.verify.defaultError': 'Wystąpił błąd.',
  'auth.verify.docTitle': 'Potwierdź e-mail · Leadscraper',
  'auth.verify.error': 'Potwierdzenie nie powiodło się',
  'auth.verify.goToDashboard': 'Przejdź od razu do panelu',
  'auth.verify.noToken': 'Brak linku potwierdzającego',
  'auth.verify.noTokenSub':
    'Kliknij w link z e-maila, który Ci wysłaliśmy. Jeśli nie otrzymałeś e-maila, możesz poprosić o nowy.',
  'auth.verify.resendError': 'Poproś o nowy e-mail potwierdzający',
  'auth.verify.resendFailed': 'Nie udało się wysłać e-maila ponownie.',
  'auth.verify.resendNoToken': 'Wyślij e-mail potwierdzający ponownie',
  'auth.verify.resending': 'Wysyłanie…',
  'auth.verify.resent': 'E-mail wysłany ponownie ✓',
  'auth.verify.success': 'Sukces!',
  'auth.verify.successSub': 'Twój adres e-mail został potwierdzony. Przekierowanie do panelu…',
  'auth.verify.title': 'Potwierdź e-mail',
  'auth.verify.toLogin': 'Do logowania',
  'auth.verify.verifying': 'Potwierdzanie e-mail…',
  'auth.verify.verifyingSub': 'Proszę czekać.',

  'bill.ret.cancelBody':
    'Nic nie zostało pobrane. Możesz ponownie rozpocząć proces płatności w dowolnym momencie.',
  'bill.ret.cancelCta': 'Powrót do panelu',
  'bill.ret.cancelTitle': 'Operacja anulowana',
  'bill.ret.cta': 'Do panelu',
  'bill.ret.docTitleCancel': 'Operacja anulowana · Leadscraper',
  'bill.ret.docTitleSuccess': 'Płatność udana · Leadscraper',
  'bill.ret.errorBody':
    'Twoja płatność mogła przejść pomyślnie. Nie mogliśmy właśnie załadować statusu. Sprawdź w swoim koncie w sekcji "Rozliczenia".',
  'bill.ret.errorTitle': 'Nie można pobrać statusu',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} dostępnych',
  'bill.ret.rowNextRenewal': 'Następne rozliczenie',
  'bill.ret.rowPlan': 'Plan',
  'bill.ret.seedCta': 'Do moich leadów',
  'bill.ret.seedDone': 'Wszystkie {delivered} leady są gotowe. Do dzieła.',
  'bill.ret.seedPartial':
    'Dostarczono {delivered} leadów. Reszta Twoich kredytów zostaje na koncie do własnych wyszukiwań.',
  'bill.ret.seedWorking':
    'Dostarczono {delivered} z {total} leadów, reszta jest właśnie wzbogacana. Całość trwa od 10 do 30 minut.',
  'bill.ret.seedWorkingCreated':
    'Utworzono {created} leadów. Wyszukiwanie kontaktów trwa od 10 do 30 minut. Eksportuj najlepiej dopiero, gdy będą wszystkie.',
  'bill.ret.seedWorkingZero':
    'Twoje leady są właśnie tworzone. Wyszukiwanie osób kontaktowych trwa od 10 do 30 minut. Eksportuj najlepiej dopiero, gdy będą wszystkie.',
  'bill.ret.successBodyCredits': 'Twoje Credits zostały dodane.',
  'bill.ret.successBodySub': 'Twoja subskrypcja jest aktywna. Masz teraz dostęp do swoich Leads.',
  'bill.ret.successTitle': 'Płatność udana',
  'bill.ret.verifying': 'Płatność jest przetwarzana…',
  'bill.ret.verifyingSub': 'Aktualizujemy Twoje konto. To zajmie tylko chwilę.',

  'billing.disabled': 'Płatności są obecnie niedostępne. Spróbuj ponownie później.',
  'billing.errorClose': 'Zamknij',
  'billing.errorTitle': 'Coś poszło nie tak',
  'billing.portalNoCustomer': 'Zarządzanie subskrypcją jest dostępne dopiero po pierwszym zakupie.',
  'billing.trialStarted': 'Witaj w subskrypcji {plan}, okres próbny trwa.',
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    'Twoja subskrypcja jest zaplanowana do zakończenia. Najpierw ją reaktywuj, potem zmienisz plan.',
  'billing.manageInPortal':
    'Tej subskrypcji nie można teraz zmienić. Otwórz portal rozliczeniowy, aby uregulować płatność.',
  'billing.unknownError': 'Nieznany błąd podczas procesu płatności.',
  'billing.alreadySubscribed': 'Masz już tę subskrypcję. Aktualny plan znajdziesz w zakładce Płatności.',

  'boot.connectionError': 'Błąd połączenia',
  'boot.connectionErrorDesc': 'Nie można połączyć się z serwerem: {msg}',
  'boot.retry': 'Spróbuj ponownie',
  'boot.reconnecting': 'Ponowne łączenie… (próba {n})',

  'common.cancel': 'Anuluj',
  'common.collapse': 'Zwiń',
  'common.edit': 'Edytuj',
  'common.hide': 'Ukryj',
  'common.loading': 'Ładowanie …',
  'common.month.apr': 'Kwiecień',
  'common.month.aug': 'Sierpień',
  'common.month.dec': 'Grudzień',
  'common.month.feb': 'Luty',
  'common.month.jan': 'Styczeń',
  'common.month.jul': 'Lipiec',
  'common.month.jun': 'Czerwiec',
  'common.month.mar': 'Marzec',
  'common.month.may': 'Maj',
  'common.month.nov': 'Listopad',
  'common.month.oct': 'Październik',
  'common.month.sep': 'Wrzesień',
  'common.refresh': 'Odśwież',
  'common.save': 'Zapisz',
  'common.saving': 'Zapisywanie …',

  'cortex.activeSince': 'Grupa docelowa aktywna od',
  'cortex.confirm': 'Potwierdź',
  'cortex.confirmed': 'przez ciebie potwierdzone',
  'cortex.correct': 'Popraw',
  'cortex.ctaRate': 'Oceń teraz pierwsze Leads',
  'cortex.feedbacks': 'Feedbacki',
  'cortex.fits': 'Pasuje',
  'cortex.fitsNot': 'Nie pasuje',
  'cortex.footer':
    'Gdy poprawisz lub zapomnisz jakieś stwierdzenie, nie będzie już używane do sortowania twoich Leads.',
  'cortex.forget': 'Zapomnij',
  'cortex.hero': 'To nauczył się Leadscraper z Twoich {n} ocen.',
  'cortex.heroEmpty': 'Jeszcze puste. Leadscraper zacznie się uczyć, gdy ocenisz pierwsze Leads.',
  'cortex.heroEmptySub':
    'Memory to pamięć Twojego Profilu: co preferujesz, co odrzucasz i gdzie system jest jeszcze niepewny.',
  'cortex.heroSub':
    'Każde stwierdzenie możesz potwierdzić, poprawić lub kazać zapomnieć. Zmiany obowiązują od następnego sortowania.',
  'cortex.learned': 'Czego nauczył się Leadscraper',
  'cortex.matchRate': 'Wskaźnik trafień',
  'cortex.medium': 'średni',
  'cortex.mediumNote': 'dalej obserwowane',
  'cortex.patterns': 'Nauczone wzorce',
  'cortex.patternsPending': 'Jeszcze do potwierdzenia',
  'cortex.perWeek': 'na tydzień',
  'cortex.plain': 'W prostych słowach, tak jak byś to czytał.',
  'cortex.roi.avgOrder': 'Ø Wartość zamówienia',
  'cortex.roi.disclaimer':
    'Wartość obliczeniowa: oparta na twojej obecnej trafności. Gdy Leadscraper będzie dojrzalszy, liczby staną się bardziej realistyczne.',
  'cortex.roi.expectedFits': 'Oczekiwane Leads Pasujące',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'Nowi klienci',
  'cortex.roi.revenue': 'Prognozowany przychód',
  'cortex.roi.revenueSub': 'przy obecnym stanie',
  'cortex.roi.sub': 'Ile może być wart twój obecny stan.',
  'cortex.roi.title': 'Oszacowanie ROI',
  'cortex.roi.viaRate': 'Ø Trafność',
  'cortex.roi.winLabel': 'Wskaźnik wygranych',
  'cortex.roi.winRate': 'Wskaźnik wygranych',
  'cortex.runs.col.action': 'Akcja',
  'cortex.runs.col.date': 'Data',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Trafność',
  'cortex.runs.col.params': 'Parametry wyszukiwania',
  'cortex.runs.count': 'Uruchomienia',
  'cortex.runs.repeat': 'Powtórz',
  'cortex.runs.sub': 'Wszystkie zapytania uruchomione dla tej grupy docelowej.',
  'cortex.runs.title': 'Wyszukiwania',
  'cortex.sinceStart': 'od początku',
  'cortex.step': 'Krok',
  'cortex.step1': 'Otwórz Leads',
  'cortex.step1d': 'Sprawdź pierwsze karty na swojej liście.',
  'cortex.step2': 'Pasuje / Nie pasuje',
  'cortex.step2d': 'Oceń każdy Lead. Przy odrzuceniu podaj krótki powód.',
  'cortex.step3': 'Przeczytaj tutaj',
  'cortex.step3d': 'Po ~20 feedbackach pojawią się tutaj pierwsze jasne stwierdzenia.',
  'cortex.strong': 'silny',
  'cortex.strongNote': 'niezawodne wzorce',
  'cortex.tierMedium': 'Średni',
  'cortex.tierStrong': 'Silny',
  'cortex.tierWeak': 'Słaby',
  'cortex.title': 'Memory',
  'cortex.uncertain': 'Leadscraper jest tutaj niepewny',
  'cortex.weak': 'słaby',
  'cortex.weakNote': 'Leadscraper jest tutaj niepewny',

  'crm.bald': 'WKRÓTCE',
  'crm.comingSoon': 'Wkrótce dostępne',
  'crm.customAgent': 'Własny Agent',
  'crm.history.duplicate': 'Już w CRM',
  'crm.history.empty':
    'Jeszcze żadnych wysłanych danych. Użyj "Wyślij do CRM" przy leadzie, aby rozpocząć.',
  'crm.history.failed': 'Nie udało się',
  'crm.history.loading': 'Ładowanie…',
  'crm.picker.title': 'Do którego CRM?',
  'crm.picker.subtitle': 'Wybierz, gdzie ten lead ma trafić, możesz zmienić w dowolnym momencie.',
  'crm.history.sent': 'Wysłane',
  'crm.history.sub': 'Ostatnie 50 Leads przesłanych do Twojego CRM, najnowsze na początku.',
  'crm.history.title': 'Historia Push',
  'crm.mcpComingSoon': 'Dostępne jak tylko serwer MCP zostanie uruchomiony.',
  'crm.mcpSub':
    'Połącz Leadscraper bezpośrednio z Claude, ChatGPT, Cursor lub własnym agentem poprzez Model Context Protocol. Twoje Leads, Profile i Memory będą dostępne natywnie jako narzędzia.',
  'crm.mcpTitle': 'Leadscraper jako serwer MCP',
  'crm.preview.bulkBody':
    'Tworzy {n} wpisów organizacji (i osoby dla Leads z danymi kontaktowymi). Duplikaty, które już znajdują się w Twoim CRM, zostaną pominięte, Twoje istniejące wpisy pozostaną niezmienione.',
  'crm.preview.bulkSub': '{n} Leads zostanie przesłanych do Twojego CRM',
  'crm.preview.dedupNote':
    'Jeśli ten Lead już istnieje w Twoim CRM (porównanie po domenie), push zostanie zarejestrowany, ale żaden nowy wpis nie będzie utworzony, zachowujesz to, co masz.',
  'crm.preview.noContact': 'Tylko Org',
  'crm.preview.plusMore': '+ {n} więcej …',
  'crm.preview.pushBtn': 'Wyślij teraz',
  'crm.preview.pushNBtn': 'Wyślij {n} teraz',
  'crm.preview.pushing': 'Wysyłanie…',
  'crm.preview.singleSub': 'To zostanie utworzone w Twoim CRM',
  'crm.preview.skipPerson': ': pominięte (brak e-maila lub telefonu w tym Lead)',
  'crm.preview.title': 'Podgląd: Push do {crm}',
  'crm.preview.willCreate': 'Zostanie utworzone',
  'crm.preview.willCreatePerson': ': główny kontakt z e-mailem/telefonem',
  'crm.preview.withContact': 'Org + Osoba',
  'crm.section.morePlanned': 'Planowane są kolejne integracje',
  'crm.tooltipComingSoon':
    'Integracja z {name} wkrótce, zostaniesz powiadomiony gdy będzie dostępna.',

  'dash.actNow': 'Otwórz',
  'dash.action': 'Akcja',
  'dash.activeRuns.run': 'Uruchomienie wyszukiwania',
  'dash.activeRuns.runs': 'Uruchomienia wyszukiwania',
  'dash.activeRuns.title': 'Leadscraper pracuje właśnie dla Ciebie',
  'dash.avgOrder': 'Śr. wartość zamówienia',
  'dash.cadence.daily': 'codziennie',
  'dash.cadence.hourly': 'co godzinę',
  'dash.cadence.manual': 'ręcznie',
  'dash.cadence.monthly': 'co miesiąc',
  'dash.cadence.weekly': 'co tydzień',
  'dash.close': 'Zamknij',
  'dash.col.lastRun': 'Ostatni przebieg',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Wskaźnik trafień',
  'dash.col.profile': 'Grupa docelowa',
  'dash.col.profileH': 'Grupa docelowa',
  'dash.col.query': 'Grupa docelowa',
  'dash.col.queryName': 'Zapytanie',
  'dash.col.statusH': 'Status',
  'dash.col.trained': 'Wytrenowane',
  'dash.col.whenH': 'Kiedy',
  'dash.company.analyzeBtn': 'Analizuj',
  'dash.company.analyzeFresh': '✨ Naucz Leadscraper',
  'dash.company.analyzing': 'Leadscraper czyta…',
  'dash.company.cachedToast': 'Profil załadowany z pamięci.',
  'dash.company.collapsed':
    'Leadscraper zna twoją firmę, wszystkie uzasadnienia są dostosowane do ciebie.',
  'dash.company.doneToast': '✓ Leadscraper cię teraz zna.',
  'dash.company.editBody':
    'Wpisz stronę swojej firmy. Leadscraper ją przeczyta i na stałe zapamięta, co oferujesz, do kogo sprzedajesz i jakie argumenty używasz, dzięki czemu każde uzasadnienie przy twoich Leads stanie się dopasowaną strategią pitchu zamiast tylko "pasuje do branży".',
  'dash.company.editTitle': 'Aby Leadscraper dopracował twoje pitche, powiedz nam, co sprzedajesz',
  'dash.company.emptyBody':
    'Wpisz stronę swojej firmy, a Leadscraper w 10 sekund zrozumie, co sprzedajesz. Od tego momentu każde uzasadnienie Lead wyjaśnia konkretnie, dlaczego TWOJA oferta pasuje do TEGO Lead, zamiast tylko "pasuje do branży". To jest moment olśnienia.',
  'dash.company.emptyTitle': 'Leadscraper cię jeszcze nie zna',
  'dash.company.errorFallback': 'Analiza nie powiodła się. Spróbuj ponownie.',
  'dash.company.setupBadge': 'Wymagana konfiguracja',
  'dash.company.stage1': 'Ładuję twoją stronę internetową…',
  'dash.company.stage2': 'Rozumiem co oferujesz…',
  'dash.company.stage3': 'Identyfikuję twoją grupę docelową…',
  'dash.company.stage4': 'Łączę wszystko z twoją wartością…',
  'dash.company.stage5': 'Prawie gotowe…',
  'dash.company.urlHint': 'Wpisz swoją stronę. Gdy URL będzie gotowy, możesz nauczyć Leadscraper.',
  'dash.company.urlPlaceholder': 'https://moja-firma.pl',
  'dash.cortex.reanalyze': 'Analizuj ponownie, Leadscraper przyjrzy się stronie na świeżo',
  'dash.cortex.reanalyzeKeepTitle': 'Zachować ręczne zmiany?',
  'dash.cortex.reanalyzeKeepBody':
    'Ten profil firmy został przez Ciebie ręcznie edytowany. Ponowna analiza może zachować Twoje zmiany i odświeżyć tylko resztę albo przywrócić wszystko do nowych sugestii AI.',
  'dash.cortex.reanalyzeKeepCta': 'Zachowaj moje zmiany',
  'dash.cortex.reanalyzeResetCta': 'Przywróć sugestie AI',
  'dash.cortex.sells': 'Co sprzedajesz',
  'dash.cortex.title': 'Co Leadscraper wie o Twojej firmie',
  'dash.cortex.toWhom': 'Do kogo',
  'dash.cortex.valueProps': 'Propozycje wartości',
  'dash.date': 'Data',
  'dash.done': 'Gotowe',
  'dash.empty.defineAudience': '+ Zdefiniuj teraz grupę docelową',
  'dash.empty.noFiltered': 'Brak zapytań w tym filtrze.',
  'dash.empty.noProfile': 'Nie utworzono jeszcze żadnej grupy docelowej.',
  'dash.empty.noQueryStartedAll':
    'Nie uruchomiono jeszcze żadnego zapytania o leady we wszystkich grupach docelowych.',
  'dash.empty.noQueryStartedForProfile':
    'Nie uruchomiono jeszcze zapytania o Leads dla "{profile}".',
  'dash.empty.showAll': 'Pokaż wszystkie ({n})',
  'dash.empty.startHint':
    'Kliknij „Uruchom wyszukiwanie" aby zdefiniować zapytanie (typ firmy, region, rola, …).',
  'dash.filter.all': 'Wszystkie',
  'dash.filter.oneshot': 'Jednorazowe',
  'dash.filter.running': 'Działające',
  'dash.filter.scheduled': 'Zaplanowane',
  'dash.fmtNext.inDays': 'za {n}d',
  'dash.fmtNext.inH': 'za {n}h',
  'dash.fmtNext.inMin': 'za {n}m',
  'dash.fmtNext.soon': 'zaczyna się wkrótce',
  'dash.fmtNext.tomorrow': 'jutro',
  'dash.funnel.deepened': 'Pogłębione',
  'dash.funnel.evaluated': 'Ocenione',
  'dash.funnel.identified': 'Zidentyfikowane',
  'dash.funnel.ready': 'Gotowe',
  'dash.inProgress': 'W trakcie',
  'dash.inbox.edge': 'Przypadek graniczny',
  'dash.inbox.edges': 'Przypadki graniczne',
  'dash.inbox.hint': 'Wskazówka',
  'dash.inbox.leadsFrom': '{leads} Leads z {profiles} {profileWord}',
  'dash.inbox.less': 'Pokaż mniej',
  'dash.inbox.more': '+ {n} więcej',
  'dash.inbox.profileWord': 'grupa docelowa',
  'dash.inbox.profilesWord': 'grup docelowych',
  'dash.inbox.showAll': 'Pokaż wszystkie {n}',
  'dash.inbox.title': 'Do zrobienia dzisiaj',
  'dash.lastQueries.subAll':
    'Twoje ostatnio uruchomione wyszukiwania we wszystkich profilach. Kliknij, aby otworzyć szczegóły i powtórzyć wyszukiwanie.',
  'dash.lastQueries.subForProfile':
    'Twoje ostatnio uruchomione wyszukiwania dla "{profile}". Kliknij, aby otworzyć szczegóły i powtórzyć wyszukiwanie.',
  'dash.lastQueries.title': 'Ostatnie zapytania o Leads',
  'dash.lastSearch': 'Ostatnie wyszukiwanie: {result}',
  'dash.lastSearch.error': 'Błąd',
  'dash.lastSearch.zero': '0 Leads',
  'dash.lastYear': 'Ostatni rok',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads wygenerowane',
  'dash.leadsGenerated': 'Lead wygenerowany',
  'dash.learning.body':
    'Z każdym ✓ „pasuje" lub ✗ „nie pasuje" {scope} Leadscraper doskonali swoje zrozumienie twojego idealnego Lead, i odpowiednio filtruje następne trafienia.',
  'dash.learning.cta': 'Oceń {n} Leads',
  'dash.learning.hint':
    'Uruchom wyszukiwanie na górze. Jak tylko pojawią się Leads, będziesz mógł je ocenić.',
  'dash.learning.scopeAll': 'w Twoich grupach docelowych',
  'dash.learning.scopeProfile': 'dla „{name}"',
  'dash.learning.title': 'Leadscraper czeka na twoją pierwszą opinię',
  'dash.maturity.label': 'Stopień dojrzałości: {label}',
  'dash.maturity.next.many': 'Jeszcze {n} opinii do {stage}.',
  'dash.maturity.next.one': 'Jeszcze {n} opinia do {stage}.',
  'dash.maturity.stage.calibrated': 'Skalibrowany',
  'dash.maturity.stage.early': 'Uczący się',
  'dash.maturity.stage.mature': 'Dojrzały',
  'dash.maturity.usage':
    'Leadscraper wykorzystuje Twoją opinię w różnym stopniu w następnym wyszukiwaniu w zależności od stopnia dojrzałości.',
  'dash.months': 'Maj,Cze,Lip,Sie,Wrz,Paź,Lis,Gru,Sty,Lut,Mar,Kwi',
  'dash.newBadge': 'nowe',
  'dash.newCust': 'Nowi klienci',
  'dash.newCustomers': 'Nowi klienci',
  'dash.newProfile': 'Nowa grupa docelowa',
  'dash.nextRun.autoPaused': 'Auto-wstrzymane · 3 puste uruchomienia',
  'dash.nextRun.in': 'Następne uruchomienie za {time}',
  'dash.nextRun.manual': 'Ręczne · brak harmonogramu',
  'dash.nextRun.paused': 'Wstrzymane',
  'dash.nextRun.pausedCredits': 'Wstrzymane · Credits wyczerpane',
  'dash.nextRun.soon': 'Zaraz',
  'dash.nextUp': 'Następne',
  'dash.onlyFavorites': 'Tylko Ulubione',
  'dash.openLeads': 'Otwórz Leads →',
  'dash.openProfile': 'Otwórz Leads',
  'dash.profileDrop.create': 'Utwórz pierwszą grupę docelową',
  'dash.profileDrop.createSub': 'Zdefiniuj grupę docelową, a potem można zaczynać',
  'dash.profiles': 'aktywne',
  'dash.progress': 'Postęp',
  'dash.projRevenue': 'Prognozowany przychód',
  'dash.projectedRevenue': 'Prognozowany przychód',
  'dash.query.businessType': 'Rodzaj firmy',
  'dash.query.contact': 'Osoba kontaktowa',
  'dash.query.dashExplain':
    '"—" oznacza: Leadscraper nie śledził tej wartości (pojawi się w V1.13 jako pełny ślad wykonania).',
  'dash.query.deepAnalysis': 'Analiza dogłębna',
  'dash.query.deepAnalysisHint': 'Przeczytanie strony internetowej + dane kontaktowe',
  'dash.query.delivered': 'Dostarczone',
  'dash.query.deliveredHint': 'Rzeczywiste trafienia',
  'dash.query.evaluated': 'Ocenione',
  'dash.query.evaluatedHint': 'Zastosowanie logiki Leadscraper',
  'dash.query.extras': 'Kryteria dodatkowe',
  'dash.query.failedTitle': 'Wykonanie wyszukiwania nie powiodło się',
  'dash.query.header': 'Zapytanie o Leads',
  'dash.query.howWorked': 'Jak pracował Leadscraper',
  'dash.query.identified': 'Zidentyfikowane',
  'dash.query.identifiedHint': 'Firmy znalezione z wyszukiwania w sieci + katalogach',
  'dash.query.leadsSoFar': '{n} Leads do tej pory · nadal w trakcie',
  'dash.query.loading': 'ładowanie…',
  'dash.query.noLeads': 'Nie znaleziono Leads',
  'dash.query.profile': 'Grupa docelowa: {name}',
  'dash.query.region': 'Region / Lokalizacja',
  'dash.query.rerun': 'Wykonaj ponownie',
  'dash.query.rerunTitle':
    'Uruchom to zapytanie ponownie w Leadscraper (np. po zmianach grupy docelowej)',
  'dash.query.restart': 'Uruchom ponownie',
  'dash.query.runHistory': 'Historia ostatnich wykonań',
  'dash.query.runningNoLeads': 'Nadal w trakcie, wkrótce pojawią się Leads',
  'dash.query.showLeads': 'Pokaż {n} Leads',
  'dash.query.rerunRow': 'Powtórz',
  'dash.query.rerunCta': 'Powtórz wyszukiwanie',
  'dash.query.searchedLabel': 'Czego szukałeś',
  'dash.query.autoRepeat': 'Powtarzaj automatycznie',
  'dash.query.openSettings': 'Otwórz ustawienia',
  'dash.query.startedAt': 'Rozpoczęto: {date}',
  'dash.query.suggestions': 'Sugestie Leadscraper',
  'dash.query.technicalDetails': 'Szczegóły techniczne',
  'dash.query.unfeasibleTitle': 'Leadscraper uważa zapytanie za nierealizowalne',
  'dash.query.unnamed': 'Nienazwane zapytanie',
  'dash.query.whenRuns': 'Kiedy wykonuje się to wyszukiwanie?',
  'dash.queryHint': 'Wskazówka do wyszukiwania',
  'dash.queryId': 'Query ID',
  'dash.renameQuery': 'Zmień nazwę zapytania',
  'dash.roi': 'Kalkulator ROI',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Grupa docelowa:',
  'dash.run.businessType': 'Rodzaj firmy',
  'dash.run.businessTypeP': 'np. producent opakowań z własną matrową',
  'dash.run.cancel': 'Anuluj',
  'dash.run.contact': 'Osoba kontaktowa',
  'dash.run.contactP': 'np. zarząd, kierownik zakupów',
  'dash.run.extras': 'Dodatkowe ograniczenia',
  'dash.run.extrasP':
    'np. nie koncern, chętnie firmę rodzinną, certyfikacja ISO preferowana, 50–250 pracowników',
  'dash.run.forWhich': 'Dla jakiej grupy docelowej?',
  'dash.run.minField': 'Podaj przynajmniej rodzaj firmy',
  'dash.run.notBackendProfile':
    'Ta grupa docelowa nie jest jeszcze zarejestrowana w backendzie. Utwórz prawdziwą przez',
  'dash.run.notBackendProfileCta': '+ Nowa grupa docelowa',
  'dash.run.notBackendProfileEnd': ', wtedy scraper będzie działać.',
  'dash.run.optional': '(opcjonalne)',
  'dash.run.pastQueries': 'Ostatnie zapytania o Leads',
  'dash.run.pastQueriesHint': 'Kliknięcie przejmuje wartości',
  'dash.run.region': 'Region / Lokalizacja',
  'dash.run.regionHint':
    'Miasto, województwo, region lub „ogólnopolsko", napisz tak, jak byś szukał.',
  'dash.run.regionP': 'np. Kraków, małopolskie, aglomeracja warszawska, lub ogólnopolsko',
  'dash.run.searchBtn': 'Znajdź 10 Leads',
  // LEA-338 Part A / LEA-355 — auto-enrich contact-persons toggle (added in LEA-355).
  'dash.run.withContact.label': 'Automatycznie wzbogacaj o osoby kontaktowe',
  'dash.run.withContact.hint':
    'Każdy nowy lead jest od razu wzbogacany o pasujące osoby kontaktowe i ich dane kontaktowe. Możesz też najpierw sprawdzić leady i wzbogacać je pojedynczo, co jest zalecane szczególnie na początku.',
  'dash.run.withContact.cost': 'Do {n} Credits, naliczane tylko przy udanym wzbogaceniu.',
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Koszt: {n} leadów = {n} kredytów (1 za dostarczony lead).',
  'dash.run.cost.extras': 'Kontakty i pełne insighty: +1 kredyt/lead każdy, tylko na żądanie.',
  'lt.next.connectCostHint': 'Tylko 1 kredyt przy dostępnym kontakcie, w przeciwnym razie gratis.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': 'Bezpłatnie — płacisz dopiero za odblokowanie osoby kontaktowej.',
  // LEA-356 — cascading Phase-3 acquisition-plan toggle.
  'dash.run.withPlan.label': 'Automatycznie twórz plan akwizycji',
  'dash.run.withPlan.hint':
    'Dla każdego wzbogaconego leada tworzony jest indywidualny plan akwizycji: konkretne podejście do kontaktu oparte na znalezionych osobach kontaktowych.',
  'dash.run.withPlan.cost': 'Do {n} Credits, naliczane tylko przy pomyślnym utworzeniu planu.',
  'dash.run.sub': '10 Credits · 10 Leads · typowo 5–12 min',
  'dash.run.title': 'Uruchom zapytanie o Leads',
  'dash.sched.change': 'zmień',
  'dash.sched.daily': 'Codziennie',
  'dash.sched.dailySub': 'Każdego dnia 10 świeżych Leads',
  'dash.sched.manual': 'Ręcznie',
  'dash.sched.manualSub': 'Bez harmonogramu, tylko na kliknięcie',
  'dash.sched.pause': '⏸ Wstrzymaj',
  'dash.sched.resume': '▶ Wznów',
  'dash.sched.sub': 'Leadscraper regularnie pobiera 10 nowych leadów dla tej grupy docelowej.',
  'dash.sched.time': 'Zaplanuj query',
  'dash.sched.title': 'Zaplanuj zapytanie',
  'dash.sched.toast.error': 'Nie udało się zapisać harmonogramu: {err}',
  'dash.sched.toast.manual': 'Harmonogram usunięty. Grupa docelowa działa tylko ręcznie.',
  'dash.sched.toast.paused': 'Grupa docelowa wstrzymana. Brak automatycznych uruchomień.',
  'dash.sched.toast.set': 'Harmonogram ustawiony. Leadscraper działa automatycznie ({cadence}).',
  'dash.sched.twiceWeekly': 'Pn / Czw',
  'dash.sched.twiceWeeklySub': '2× w tygodniu, ~20 Leads/tydzień',
  'dash.sched.weekly': 'Tygodniowo',
  'dash.sched.weeklySub': 'Raz w tygodniu 10 Leads',
  'dash.schedInd.nextRun': 'następne uruchomienie',
  'dash.schedInfo.everyNh': 'co {n} h',
  'dash.schedInfo.hourly': 'co godzinę',
  'dash.schedInfo.oneshot': 'jednorazowy',
  'dash.schedInfo.paused': 'wstrzymany',
  'dash.simulation': 'Symulacja',
  'dash.startRun': 'Rozpocznij wyszukiwanie',
  'dash.startRunDisabledHint': 'Najpierw utwórz grupę docelową, potem uruchom wyszukiwanie',
  'dash.status': 'Status',
  'dash.status.delivered.many': '{n} Leads dostarczonych',
  'dash.status.delivered.one': '{n} Lead dostarczony',
  'dash.status.deliveredSuffix.many': 'Leads dostarczonych',
  'dash.status.deliveredSuffix.one': 'Lead dostarczony',
  'dash.status.done': 'Gotowe',
  'dash.status.empty': 'Brak trafień',
  'dash.status.failed': 'Nie powiodło się',
  'dash.status.running': 'Działa',
  'dash.status.runningEllipsis': 'Działa…',
  'dash.status.runningPrefix': 'Działa · ',
  'dash.status.unfeasible': 'Niewykonalne',
  'dash.step.delivery': 'Zestawienie Leads',
  'dash.step.discovery': 'Identyfikacja firm',
  'dash.step.done': 'Gotowe',
  'dash.step.fallbackProfile': 'Grupa docelowa',
  'dash.step.hydration': 'Dogłębna analiza firm',
  'dash.step.planning': 'Leadscraper przypomina sobie',
  'dash.step.reasoning': 'Leadscraper ocenia',
  'dash.step.starting': 'Uruchamianie…',
  'dash.timeline': 'Rozwój wskaźników w czasie',
  'dash.totalLeads': 'Łączna liczba Leads',
  'dash.whenCell.next': 'następny {label}',
  'dash.winRate': 'Wskaźnik wygranych',
  'dash.yourLeads': 'Twoje Leads',
  'dash.yourProfiles': 'Twoje grupy docelowe',
  'dash.yourProfilesSub':
    'Wszystkie grupy docelowe, które trenujesz. Kliknięcie otwiera leady tej grupy docelowej.',

  'det.accepted': 'Zaakceptowany',
  'det.back': 'Powrót do wyników wyszukiwania',
  'det.city': 'Lokalizacja',
  'det.companyProfile': 'Profil firmy',
  'det.contact': 'Kontakt',
  'det.contactsEmpty':
    'Jeszcze nie wyodrębniono osób kontaktowych. Leadscraper szuka w stopce + LinkedIn.',
  'det.crmSoonTitle':
    'Integracja CRM wkrótce, zostaniesz powiadomiony gdy HubSpot, Pipedrive i inne będą podłączone.',
  'det.decider': 'Decydent',
  'det.delivers': 'Dostarcza:',
  'det.draftMail': 'Przygotuj szkic e-maila',
  'det.draftMailSoonToast': 'Szkice e-maili z Lead jeszcze nie są dostępne. Wkrótce.',
  'det.fetched': 'pobrane',
  'det.fits': 'Pasuje',
  'det.fitsNot': 'Nie pasuje',
  'det.founded': 'Założenie',
  'det.markedFit': '✓ Oznaczony jako Pasuje',
  'det.rejectAnyway': '↩ Jednak nie pasuje?',
  'det.markedNotFit': '× Oznaczony jako Nie pasuje',
  'det.memoryHint': 'Wskazówka dla twojej pamięci',
  'det.memoryHintText':
    'Gdy zaakceptujesz lub odrzucisz ten Lead, wpłynie to na podobne Leads w "{profile}", ale nie na twoje inne Profile.',
  'det.open': 'Otwórz',
  'det.patterns': 'Nauczone wzorce, które tutaj działają',
  'det.publicOnly':
    'Wszystkie źródła są publicznie dostępne. Leadscraper nigdy nie przechowuje danych pochodzących z niepublicznych lub płatnych katalogów.',
  'det.research.footer':
    'Leadscraper próbuje różnych ścieżek wyszukiwania (LinkedIn, strona firmy, prasa, Xing), zanim użyje fallback dyrektora zarządzającego. Dzięki temu jest transparentne, dlaczego wyświetla się dokładnie ten kontakt.',
  'det.research.hit': '✓ Trafienie',
  'det.research.label': 'Ścieżka wyszukiwania',
  'det.research.noHit': '○ brak trafienia',
  'det.research.resultMany': 'Wyniki',
  'det.research.resultOne': 'Wynik',
  'det.research.summaryFallback':
    'Wypróbowano {n} ścieżek wyszukiwania, nie znaleziono konkretnej roli, dyrektor zarządzający jako fallback',
  'det.research.summaryFound': 'Kontakt znaleziony na etapie {stage}: {label}',
  'det.research.summaryNoHit': '{n} ścieżek wyszukiwania bez trafienia',
  'det.sector': 'Branża',
  'det.shortProfile': 'Krótki profil',
  'det.similar': 'Podobny do Leads, które wcześniej zaakceptowałeś',
  'det.size': 'Pracownicy',
  'det.sourcesCount': 'Źródła',
  'det.sourcesSub': 'Każde pole w tym Lead można prześledzić do konkretnego publicznego źródła.',
  'det.sourcesTitle': 'Skąd pochodzą te informacje',
  'det.trail.searched': 'Cortex przeszukał {n} źródeł publicznych',
  'det.trail.website': 'Strona firmy',
  'det.trail.register': 'Rejestr handlowy',
  'det.trail.google': 'Wyszukiwanie Google',
  'det.trail.press': 'Prasa',
  'det.trail.pages': '{n} stron',
  'det.trail.profiles': '{n} profile',
  'det.capturedAt': 'zarejestrowano',
  'det.derivedAt': 'wywnioskowano',
  'det.sourcePage': 'Strona źródłowa',
  'det.sourcesBelegtCount': '{n} udokumentowanych',
  'det.sourcesTagline': 'Skąd pochodzi każda informacja, jawnie i do sprawdzenia.',
  'det.sourcesBelegt': '{n} z {total} udokumentowanych',
  'det.sourcesFieldCount': '{n} pól',
  'det.lastChecked': 'ostatnio sprawdzone',
  'det.sourcesUnsourced': 'Jeszcze bez źródła',
  'det.sourcesHonesty':
    'Dane urzędowe i publiczne są udokumentowane bezpośrednio; szacunki AI są wyraźnie oznaczone. Leadscraper nie korzysta z płatnych baz danych.',
  'det.sourcesFlex': 'Inni ukrywają, skąd mają dane. My pokazujemy każde źródło, do sprawdzenia.',
  'ld.tier.officialName': 'Źródło urzędowe',
  'ld.tier.officialSub': 'Rejestr urzędowy i obowiązkowe dane prawne',
  'ld.tier.publicName': 'Źródło publiczne',
  'ld.tier.publicSub': 'Publicznie dostępne w sieci',
  'ld.tier.inferredName': 'Wywnioskowane przez Cortex',
  'ld.tier.inferredSub': 'Szacunek, sprawdź przed wysłaniem',
  'ld.tier.officialFallback': 'Źródło urzędowe',
  'ld.tier.publicFallback': 'Źródło publiczne',
  'ld.tier.inferredFallback': 'Wywnioskowane przez Cortex',
  'ld.tier.legendOfficial': 'urzędowe',
  'ld.tier.legendPublic': 'publiczne',
  'ld.tier.legendInferred': 'wywnioskowane · sprawdź',
  'ld.tier.legendUnsourced': 'do uzupełnienia',
  'ld.srcLabel.dork': 'Publiczne wyszukiwanie w sieci',
  'ld.srcLabel.icypeas_finder': 'Wywnioskowany e-mail',
  'ld.srcLabel.role_match': 'Dopasowanie roli',
  'ld.srcLabel.cortexNace': 'Analiza branży Cortex',
  'ld.field.vatId': 'NIP',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Kraj',
  'ld.field.contactPhone': 'Telefon (kontakt)',
  'det.toCRM': 'Przenieś do CRM',
  'det.webExcerpts': 'Fragmenty strony',
  'det.website': 'Strona internetowa',
  'det.whyFits': 'Dlaczego to do ciebie pasuje',
  'det.whyFitsSub': 'na podstawie tego, czego Leadscraper się o tobie nauczył',

  'error.account_deleted': 'To konto zostało usunięte.',
  'error.email_unverified': 'Najpierw zweryfikuj swój adres e-mail (link w mailu rejestracyjnym).',
  'error.demo_read_only': 'W wersji demo ta funkcja jest wyłączona. Nic nie zostało zmienione.',
  'error.impersonate_target_not_found':
    'Konto testowe nie zostało znalezione: UID nie istnieje w tym środowisku BD (Mini / Staging / Production).',
  'error.invalidInput': 'Nieprawidłowe dane wejściowe.',
  'error.noProfile': 'Nie wybrano grupy docelowej.',
  'error.profileNotRegistered':
    'Grupa docelowa nie jest jeszcze zarejestrowana w backendzie. Otwieram kreatora.',
  'error.unauthenticated': 'Nie jesteś zalogowany. Odśwież stronę i zaloguj się ponownie.',

  'expired.body':
    'Twój dostęp jest wstrzymany. Reaktywuj abonament, aby ponownie wyszukiwać Leads i uruchamiać grupy docelowe.',
  'expired.readOnly':
    'Nadal możesz przeglądać i eksportować swoje Leads. Nowe wyszukiwania i wyszukiwanie kontaktów wymagają aktywnego abonamentu.',
  'expired.creditsKept': 'Twoje {credits} Credits są zamrożone, nie usunięte.',
  'expired.cta': 'Reaktywuj abonament',
  'expired.ctaLoading': 'Wczytywanie…',
  'expired.title': 'Twój abonament się zakończył',
  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Witaj ponownie',
  'revealMigration.subtitle': 'Leadscraper rozlicza teraz za kontakt',
  'revealMigration.free': 'Wyszukiwanie firm i kontaktów jest bezpłatne',
  'revealMigration.payPerContact': 'Płacisz tylko wtedy, gdy odblokowujesz osobę kontaktową',
  'revealMigration.units': 'Twoje saldo zostaje – kontakty do odblokowania: {n}',
  'revealMigration.unitsOne': 'Twoje saldo zostaje: 1 kontakt do odblokowania',
  'revealMigration.unitsNone': 'Kontakty kupujesz w pakietach, gdy ich potrzebujesz',
  'revealMigration.cta': 'Dalej',
  'revealMigration.ctaLoading': 'Chwileczkę…',
  'revealMigration.error': 'Nie udało się. Spróbuj ponownie.',

  'fb.blocked.headline': 'Zapytanie jest zbyt szerokie',
  'fb.blocked.subline':
    'Leadscraper znajdzie głównie portale, stowarzyszenia lub firmy doradcze, nie prawdziwe pojedyncze firmy.',
  'fb.cta.adjust': 'Dostosuj zapytanie',
  'fb.cta.bypass': 'Rozpocznij mimo to',
  'fb.cta.bypassTitle':
    'Zapytanie zostanie uruchomione w Leadscraper mimo to, na własną odpowiedzialność',
  'fb.cta.sharpen': 'Wróć i doprecyzuj',
  'fb.field.ansprechpartner': 'Osoba kontaktowa',
  'fb.field.ort': 'Miejsce',
  'fb.field.rawQuery': 'Tekst wolny',
  'fb.field.region': 'Region',
  'fb.field.unternehmensart': 'Typ firmy',
  'fb.field.zusatz': 'Dodatkowe kryteria',
  'fb.fieldWarnings': 'Pola z uwagami',
  'fb.suggestions': 'Bardziej konkretne sformułowania',
  'fb.suggestionsHint':
    'Skopiuj jedną z propozycji z powrotem do pola lub sformułuj własną, to wymiernie zwiększa wskaźnik trafień.',
  'fb.warning.headline': 'To zapytanie jest bardzo specyficzne',
  'fb.warning.subline':
    'Z tą kombinacją filtrów Leadscraper może znaleźć tylko nieliczne lub żadne wyniki. Możesz mimo to rozpocząć lub nieco rozszerzyć zapytanie.',

  'find.amount': 'Liczba Leads',
  'find.amountHint': 'Wartość musi być między 1 a 1000',
  'find.businessType': 'Typ firmy',
  'find.businessTypeP': 'np. restauracja, prawnik, księgowy',
  'find.contact': 'Osoba kontaktowa',
  'find.contactP': 'np. właściciel, pracownik sprzedaży, dyrektor zarządzający',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.extras': 'Dodatkowe ograniczenia',
  'find.extrasP': 'Zdefiniuj swoją grupę docelową jeszcze dokładniej',
  'find.forProfile': 'Dla której grupy docelowej?',
  'find.forProfileHint': 'Twoje oceny trenują Leadscraper dla tej grupy docelowej.',
  'find.location': 'Lokalizacja',
  'find.locationP': 'np. Warszawa, Kraków, Gdańsk',
  'find.start': 'Uruchom Leadscraper',
  'find.title': 'Znajdź nowe Leads',
  'find.trainsProfile': 'Trenuje',

  'hero.eyebrow': 'Leadscraper poznaje Cię',
  'hero.stat.feedbacks': 'Łączna liczba feedbacków',
  'hero.stat.matchrate': 'Śr. wskaźnik trafień',
  'hero.stat.profiles': 'aktywne grupy docelowe',
  'hero.sub':
    'Każde „Pasuje / Nie pasuje" określa, które Leads będą na górze jutro. To są Twoje obecne wskaźniki.',
  'hero.title':
    'We wszystkich grupach docelowych Leadscraper staje się dokładniejszy, z każdą opinią.',

  'inbox.sched.body': 'Następny przebieg {rel}, nowe Leads automatycznie trafią {where}.',
  'inbox.sched.cta': 'Zobacz',
  'inbox.sched.inCRM': 'do CRM',
  'inbox.sched.inList': 'na twojej liście',
  'inbox.sched.title': '{n} zaplanowanych przebiegów aktywnych',

  'ld.aggregatorWarn':
    'Strona internetowa firmy jest jeszcze ustalana. Do tego czasu pokazujemy źródłowy URL (katalog/prasa), z którego pochodzi ta firma.',
  'ld.comingSoon': '· wkrótce',
  'ld.company': 'Firma',
  'ld.companySite': 'Strona firmowa',
  'ld.contacts': 'Osoby kontaktowe',
  'ld.decisionMaker': '· Decydent',
  'ld.email.apply': 'Zastosuj wzór',
  'ld.email.confGuessed': 'domniemany',
  'ld.email.confLikely': 'prawdopodobnie',
  'ld.email.confPlausible': 'prawdopodobnie',
  'ld.email.copied': 'Domniemany email skopiowany do schowka.',
  'ld.email.derivedFrom':
    'Wyprowadzony z {n} email{s} ze strony firmowej. {conf}, sprawdź sam przed wysłaniem maila.',
  'ld.email.noDirectExplain':
    'Nie znaleźliśmy bezpośredniego emaila dla {first} {last}. Rozpoznaliśmy jednak schemat emaili firmy, po kliknięciu pokażemy ci prawdopodobny adres. Ponosisz odpowiedzialność.',
  'ld.email.notFound': 'Nie znaleziono bezpośredniego emaila dla tego kontaktu.',
  'ld.emailLabel': 'E-mail',
  'ld.emailPattern': 'Wzorzec email',
  'ld.emailPattern.confHigh': 'wysokie',
  'ld.emailPattern.confLow': 'niskie',
  'ld.emailPattern.confMid': 'średnie',
  'ld.emailPattern.hint': 'Wszyscy kontakty w tej firmie prawdopodobnie używają tego wzorca.',
  'ld.emailPattern.noPattern': 'Znalezione emaile ({n}) nie używają wyraźnego wzorca.',
  'ld.emailPattern.noSamples': 'Nie znaleziono emaili pracowników na stronie internetowej.',
  'ld.emailPattern.notFound': 'Nie znaleziono wzorca',
  'ld.emailPattern.notRecognized': 'nierozpoznane',
  'ld.emailPattern.sourceMany': 'Źródła',
  'ld.emailPattern.sourceOne': 'Źródło',
  'ld.fetchedThisWeek': 'w tym tygodniu',
  'ld.field.acquisitionHook': 'Leadscraper Hook Akwizycyjny',
  'ld.field.centralEmail': 'Email centralny',
  'ld.field.centralPhone': 'Telefon centralny',
  'ld.field.certs': 'Certyfikaty',
  'ld.field.city': 'Miasto',
  'ld.field.companyName': 'Nazwa firmy',
  'ld.field.customerRefs': 'Referencje klientów',
  'ld.field.description': 'Krótki profil',
  'ld.field.email': 'Email (decydent)',
  'ld.field.employees': 'Liczba pracowników',
  'ld.field.firstName': 'Imię (decydent)',
  'ld.field.foundedYear': 'Rok założenia',
  'ld.field.hrNumber': 'Numer rejestru handlowego',
  'ld.field.jobSnapshot': 'Otwarte stanowiska',
  'ld.field.lastName': 'Nazwisko (decydent)',
  'ld.field.legalForm': 'Forma prawna',
  'ld.field.linkedin': 'LinkedIn (decydent)',
  'ld.field.locations': 'Lokalizacje',
  'ld.field.nace': 'Branża NACE',
  'ld.field.ownership': 'Właściciel / Historia',
  'ld.field.revenueRange': 'Zakres przychodów',
  'ld.field.role': 'Rola (decydent)',
  'ld.field.sizeClass': 'Klasa wielkości',
  'ld.field.street': 'Ulica',
  'ld.field.triggerEvent': 'Trigger Event',
  'ld.field.website': 'URL strony',
  'ld.field.xing': 'XING (decydent)',
  'ld.field.deciderProfile': 'Profil decydenta',
  'ld.field.zip': 'Kod pocztowy',
  'ld.linkedinPublic': 'LinkedIn · publiczny',
  'ld.match.borderline': 'przypadek graniczny',
  'ld.match.excellent': 'doskonały',
  'ld.match.solid': 'solidne dopasowanie',
  'ld.match.strong': 'mocne dopasowanie',
  'ld.sparkle.certs': 'Certyfikaty i nagrody',
  'ld.sparkle.customers': 'Referencje klientów',
  'ld.sparkle.hookFake':
    'Tutaj możesz się zaczepić, bo {company} pokazuje klasyczny profil średniego biznesu z konkretnym zapotrzebowaniem, pasuje bezpośrednio do twojej oferty.',
  'ld.sparkle.hookLabel': 'Leadscraper Hook Akwizycyjny',
  'ld.sparkle.hookUnlockLink': 'swoją stronę firmową',
  'ld.sparkle.hookUnlockPost':
    ', Leadscraper wygeneruje wtedy spersonalizowany hook dla każdego leada.',
  'ld.sparkle.hookUnlockPre': 'Wprowadź powyżej w dashboardzie ',
  'ld.sparkle.jobs': 'Snapshot stanowisk',
  'ld.sparkle.jobsBadge': '{n} otwartych stanowisk',
  'ld.sparkle.locations': 'Lokalizacje',
  'ld.sparkle.locked': ': zablokowany',
  'ld.sparkle.ownerSince': 'od {year}',
  'ld.sparkle.ownership': 'Struktura właścicielska',
  'ld.sparkle.staleAction':
    'Uruchom zapytanie ponownie w dashboardzie, wtedy wygenerujemy dla TEGO leada spersonalizowany hook akwizycyjny plus wszystkie sygnały sprzedażowe (trigger events, otwarte stanowiska, klientów, …).',
  'ld.sparkle.staleMsg':
    'Ten lead został wygenerowany zanim twój profil firmowy został zapisany w Leadscraper.',
  'ld.sparkle.sub': ': Sygnały sprzedażowe z analizy live-web',
  'ld.sparkle.title': 'Leadscraper Magic',
  'ld.sparkle.trigger': 'Trigger Event',
  'ld.sparkle.waitLabel': ': czeka na ponowne uruchomienie',
  'ld.specialization': 'Specjalizacja',
  'ld.srcDesc.firecrawl': 'Strona główna witryny firmowej (z cache).',
  'ld.srcDesc.footer': 'Stopka strony: lokalizacje, certyfikaty, alternatywne sposoby kontaktu.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper wyodrębnił strukturalne pola z treści strony (opis, klienci, wydarzenia wyzwalające).',
  'ld.srcDesc.handelsregister':
    'Oficjalny niemiecki rejestr przedsiębiorstw: numer HRB, siedziba, data wpisu.',
  'ld.srcDesc.impressum':
    'Strona z danymi obowiązkowymi: nazwa firmy, forma prawna, adres, zarząd. Jest pobierana i przetwarzana.',
  'ld.srcDesc.json_ld':
    'Maszynowo czytelne metadane Schema.org strony internetowej (profil organizacji).',
  'ld.srcDesc.karriere': 'Strona kariery: otwarte pozycje, poszukiwane profile (sygnał wzrostu).',
  'ld.srcDesc.kontakt':
    'Strona kontaktowa/lokalizacyjna: numery telefonów, adresy email, ewentualnie osoby kontaktowe.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper wyodrębnił strukturalne pola z treści strony (opis, klienci, wydarzenia wyzwalające).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper ocenił leada względem Twojej grupy docelowej + pamięci.',
  'ld.srcDesc.news':
    'Strona prasowa/aktualności: ostatnie wydarzenia, rozbudowa zakładów, nagrody.',
  'ld.srcDesc.regex_derived':
    'Wyprowadzone z innych danych: np. wzór emaila z znanego emaila firmowego + nazwiska.',
  'ld.srcDesc.serp': 'Wyniki Google dla ukierunkowanego wyszukiwania domeny lub osób.',
  'ld.srcDesc.team': 'Strona zespołu/pracowników: osoby i role.',
  'ld.srcDesc.ueber_uns': 'Opis firmy: historia, właściciele, wartości, referencje klientów.',
  'ld.srcDesc.user_feedback':
    'Ręcznie potwierdziłeś lub odrzuciłeś tego leada, najwyższy poziom zaufania.',
  'ld.srcLabel.firecrawl': 'Strona firmowa (strona główna)',
  'ld.srcLabel.footer': 'Stopka strony',
  'ld.srcLabel.haiku_extracted': 'Ekstrakcja AI',
  'ld.srcLabel.handelsregister': 'Rejestr handlowy',
  'ld.srcLabel.impressum': 'Stopka prawna',
  'ld.srcLabel.json_ld': 'Dane strukturalne (Schema.org)',
  'ld.srcLabel.karriere': 'Strona kariery',
  'ld.srcLabel.kontakt': 'Strona kontaktowa',
  'ld.srcLabel.llm_haiku': 'Ekstrakcja AI',
  'ld.srcLabel.llm_sonnet': 'Ocena AI',
  'ld.srcLabel.news': 'Prasa / Aktualności',
  'ld.srcLabel.regex_derived': 'Wyprowadzenie wzoru',
  'ld.srcLabel.serp': 'Wyszukiwanie Google',
  'ld.srcLabel.team': 'Strona zespołu',
  'ld.srcLabel.ueber_uns': 'Strona o nas',
  'ld.srcLabel.user_feedback': 'Twoja opinia',
  'ld.trust.inferred': '🔵 Wywnioskowane przez AI',
  'ld.trust.inferredTitle': 'Wywnioskowane przez Leadscraper AI, nie oficjalne źródło.',
  'ld.trust.official': '🛡 Oficjalny',
  'ld.trust.officialTitle': 'Prawnie-autorytatywne źródło (rejestr handlowy/regulamin).',
  'ld.trust.public': '🟡 Publiczny',
  'ld.trust.publicTitle': 'Publicznie dostępne na stronie firmowej.',
  'ld.uncertainty': 'Leadscraper jest tutaj {score}: {text}.',
  'ld.websiteExcerpt': 'Fragment strony',
  'ld.xingPublic': 'XING · publiczny',

  'leads.act.cancel': 'Anuluj',
  'leads.act.details': 'Szczegóły',
  'leads.act.fits': 'Pasuje',
  'leads.act.fitsDone': 'Zapisano jako Pasuje',
  'leads.act.fitsNot': 'Nie pasuje',
  'leads.act.fitsNotDone': 'Zapisano jako Nie pasuje',
  'leads.act.reason': 'Wybierz powód',
  'leads.allProfiles': 'Wszystkie grupy docelowe',
  'leads.allProfilesHeader': 'Wszystkie grupy docelowe',
  'leads.allProfilesShow': 'Pokaż wszystkie grupy docelowe',
  'leads.backToActive': '← powrót do aktywnej grupy docelowej',
  'leads.cardView': 'Karty',
  'leads.chip.edge': 'Przypadek graniczny · Ocena?',
  'leads.chip.pattern': 'Tworzy wzorzec',
  'leads.col.actions': 'Akcje',
  'leads.col.centralEmail': 'E-mail',
  'leads.col.centralPhone': 'Telefon',
  'leads.col.city': 'Lokalizacja',
  'leads.col.company': 'Firma',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Decydent',
  'leads.col.founded': 'Założenie',
  'leads.col.lastActivity': 'Ostatnia aktywność',
  'leads.col.legalForm': 'Forma prawna',
  'leads.col.match': 'Dopasowanie',
  'leads.col.nace': 'Branża',
  'leads.col.phone': 'Telefon',
  'leads.col.profile': 'Grupa docelowa',
  'leads.col.revenue': 'Przychody',
  'leads.col.sector': 'Podbranża',
  'leads.col.size': 'Zatrudnienie',
  'leads.col.status': 'Status',
  'leads.col.website': 'Strona internetowa',
  'leads.cols.btn': 'Kolumny',
  'leads.cols.fixed': 'Stałe',
  'leads.cols.reset': 'Resetuj',
  'leads.cols.sub': 'Pokaż tylko to, czego potrzebujesz.',
  'leads.cols.title': 'Pokaż kolumny',
  'leads.count': '{shown} z {total} Leads',
  'leads.crm.push': 'Wyślij',
  'leads.crm.notSynced': 'Niezsynchronizowano',
  'leads.crm.syncedTo': 'Zsynchronizowano z {crm}',
  'leads.crm.pushFailed': 'Wysyłka nie powiodła się',
  'leads.crossOverview.many': '{n} leadów · wszystkie grupy docelowe',
  'leads.crossOverview.one': '{n} lead · wszystkie grupy docelowe',
  'leads.daysAgo': '{n} dni temu',
  'leads.empty':
    'Brak Leads dla tego profilu. Rozpocznij nowe wyszukiwanie przez „Znajdź nowe Leads".',
  'leads.exp.memoryRefs': 'Z twojej pamięci',
  'leads.exp.uncertain': 'Leadscraper ma {score} pewności: {note}.',
  'leads.exp.whyShown': 'Dlaczego Leadscraper pokazuje ci tego leada',
  'leads.export': 'Eksport',
  'leads.filter.all': 'Wszystkie',
  'leads.filter.fits': 'Pasuje',
  'leads.filter.fitsNot': 'Nie pasuje',
  'leads.filter.unrated': 'Nieocenione',
  'leads.filterBy': 'Filtruj według grupy docelowej',
  'leads.footerHint':
    'Kliknij na wiersz, aby zobaczyć krótką ocenę. Przycisk „Szczegóły" otwiera widok 360°.',
  'leads.searchP': 'Firma, branża, lokalizacja, decydent…',
  'leads.status.accepted': 'Pasuje',
  'leads.status.rejected': 'Nie pasuje',
  'leads.status.unseen': 'Niewyświetlone',
  'leads.sub':
    '{n} Leads · pogrupowane według twoich profili. Kliknięcie otwiera widok 360° firmy.',
  'leads.tableView': 'Tabela',
  'leads.title': 'Twoje Leads',
  'leads.toast.accepted': '„{c}" zapisano jako Pasuje. Leadscraper uczy się z tego.',
  'leads.toast.export': 'Funkcja eksportu już wkrótce.',
  'leads.toast.rejected':
    '„{c}" odrzucono · Powód: {r}. Leadscraper uczy się z tego na następne uruchomienia.',

  'lp.card.examplesHint': '(ID Leads z twojej historii ocen dla tego klastra)',
  'lp.card.hideExamples': 'Ukryj przykłady',
  'lp.card.showExamplesMany': 'Pokaż {n} przykładowych Leads',
  'lp.card.showExamplesOne': 'Pokaż {n} przykładowy Lead',
  'lp.cl.age': 'Wiek firmy',
  'lp.cl.age.mock': 'Preferowane firmy o ugruntowanej pozycji założone przed 2010',
  'lp.cl.bizModel': 'Model biznesowy',
  'lp.cl.bizModel.mock': 'Dostawcy operacyjni, nie agencje ani pośrednicy',
  'lp.cl.buyingSignals': 'Sygnały zakupowe',
  'lp.cl.buyingSignals.mock': 'Poszukiwane aktywne wydarzenia wyzwalające (wzrost, rekrutacja)',
  'lp.cl.domainBlock': 'Blok domen',
  'lp.cl.domainBlock.mock': 'Domeny konkurentów są konsekwentnie wykluczane',
  'lp.cl.geo': 'Lokalizacja',
  'lp.cl.geo.mock': 'NRW + BaWü silnie preferowane, wschodnie Niemcy raczej nie',
  'lp.cl.industry': 'Branża',
  'lp.cl.industry.mock': 'Preferuje sektor usług (M-N) nad przemysłem',
  'lp.cl.ownership': 'Właściciel',
  'lp.cl.ownership.mock': 'Firmy rodzinne >> spółki PE i koncerny',
  'lp.cl.role': 'Osoba kontaktowa',
  'lp.cl.role.mock': 'Oczekiwany poziom zarządu, kierownicy działów zbyt juniorzy',
  'lp.cl.size': 'Wielkość firmy',
  'lp.cl.size.mock': 'Tendencja do mniejszych operatorów (10-50 pracowników)',
  'lp.cl.techStack': 'Stos technologiczny',
  'lp.cl.techStack.mock': 'Określone technologie są konsekwentnie poszukiwane/unikane',
  'lp.cta.count': 'Oceń {n} Leads',
  'lp.cta.open': 'Otwórz Leads',
  'lp.cta.rate': 'Oceń Leads',
  'lp.error.load': 'Błąd podczas ładowania',
  'lp.evidence.many': '{n} dowodów',
  'lp.evidence.one': '{n} dowód',
  'lp.journey.active': 'Aktywnie spersonalizowane',
  'lp.journey.matchRate': 'Wskaźnik trafień',
  'lp.journey.matched': 'pasowały',
  'lp.journey.notMatched': 'nie pasowały',
  'lp.journey.preview': 'Pierwsze uczenie',
  'lp.journey.title': '{n} ocen · {accepted} pasuje · {rejected} nie pasuje',
  'lp.loading': 'Ładowanie postępu nauki…',
  'lp.locked.pill': 'od {n} ocen',
  'lp.ps.bizModel.analyse':
    "Leadscraper ma aktywny standardowy filtr: agencje, dystrybutorzy i marketplace'y są automatycznie depriorytetyzowane w rozumowaniu, gdy nie pasują do zapytania.",
  'lp.ps.bizModel.content': 'Operacyjni dostawcy (nie tylko pośrednicy)',
  'lp.ps.bodyDefault':
    'Te karty pokazują co Leadscraper konkretnie **przeanalizował** z twojego profilu + potwierdzonych Leads. Oceniaj bardziej celowo z uzasadnieniem, aby klastry się zaostrzyły.',
  'lp.ps.bodyHigh':
    'Przy tylko {rejected} {rejectWord} Leadscraper nie może tworzyć twardych klastrów wykluczających: te karty pokazują co Leadscraper konkretnie **przeanalizował** z twojego profilu + {accepted} potwierdzonych Leads. Jak tylko będziesz odrzucać bardziej celowo, klastry dojrzeją do twardych filtrów.',
  'lp.ps.footerBody':
    'Od **50 ocen** Leadscraper przy każdym nowym wyszukiwaniu uwzględnia nie tylko twoje wprowadzenie i to co sprzedaje twoja firma, ale także twój **wyuczony profil jako tendencję**: branżę, klasę wielkości, lokalizację, rolę, strukturę właścicielską. Nie jako twardy filtr, ale jako dodatkowe ważenie w rozumowaniu. Oznacza to, że nowe zapytanie o „Doradca podatkowy Hamburg" nie wyszukuje ogólnie wszystkich kancelarii doradztwa podatkowego, ale automatycznie preferuje kancelarie średnich firm prowadzone przez właścicieli, analogicznie do obrazu profilu, który tutaj zbudowałeś.',
  'lp.ps.footerTitle': 'Jak to wpływa na twoje następne wyszukiwania',
  'lp.ps.geo.analyseNo':
    'Leadscraper priorytetowo traktuje trafienia z tego regionu i kuruje trafienia z okolicy, gdy region główny staje się rzadki.',
  'lp.ps.geo.analyseYes':
    'Leadscraper potwierdził {n} firm z tego regionu jako pasujące, geograficzna kotwica pasuje.',
  'lp.ps.geo.fallback': 'Region DACH',
  'lp.ps.industry.analyseNo':
    'Leadscraper systematycznie wyszukuje firmy, które pasują do opisu twojej branży.',
  'lp.ps.industry.analyseYes':
    'Leadscraper potwierdza tę branżę przez {n} zaakceptowanych Leads, zawężenie branży pasuje.',
  'lp.ps.industry.anyBranche':
    'Twój profil jest otwarty na branże. Cortex wyprowadza rzeczywistą tendencję z Twoich ocen. Obecnie {n} zaakceptowanych Leads jako kotwica. Im więcej ocen, tym ostrzejsza będzie wyprowadzona tendencja branżowa.',
  'lp.ps.industry.fallback': 'Wywiedziony z intencji twojego profilu',
  'lp.ps.ownership.analyseHigh':
    'Leadscraper rozpoznaje z potwierdzonych Leads, że twój nacisk leży na firmach prowadzonych przez właścicieli, córki koncernów są sugerowane z większą powściągliwością.',
  'lp.ps.ownership.analyseLow':
    'Oceń konkretnie córkę koncernu jako "nie pasuje", aby Leadscraper mógł tutaj utworzyć twardy klaster właścicieli.',
  'lp.ps.ownership.contentHigh': 'Profil właściciel/średnie firmy potwierdzony',
  'lp.ps.ownership.contentLow': 'Mix struktur właścicielskich i mniejszych koncernowych',
  'lp.ps.ownership.label': 'Struktura właścicielska',
  'lp.ps.rejectionMany': 'odrzucenia',
  'lp.ps.rejectionOne': 'odrzucenie',
  'lp.ps.role.analyseHigh':
    'Leadscraper aktywnie pisze w rozumowaniu według tej roli: stopka + strony kariery + LinkedIn są celowo filtrowane pod tym kątem.',
  'lp.ps.role.analyseLow':
    'Leadscraper wyszukuje w stopce + na stronach kariery celowo te role, wraca do dyrektorów tylko gdy specjalna rola nie jest wypisana.',
  'lp.ps.role.fallback': 'Poziom zarządu',
  'lp.ps.size.analyseHigh':
    'Z {pct}% trafnością Leadscraper widzi, że twoja pożądana klasa wielkości jest stabilnie trafiona, nie widać potrzeby korekty.',
  'lp.ps.size.analyseLow':
    'Leadscraper dostosowuje zakres pracowników z każdym odrzuceniem bardziej precyzyjnie do twoich wyobrażeń.',
  'lp.ps.size.contentHigh': 'Leadscraper precyzyjnie trafia klasę wielkości',
  'lp.ps.size.contentLow': 'Tendencja średnich firm z potwierdzonych Leads',
  'lp.ps.titleDefault': 'Co Leadscraper rozumie z twoich ocen',
  'lp.ps.titleHigh': 'Leadscraper rozumie Twoją grupę docelową: {pct}% trafień',
  'lp.ps.understands': 'Leadscraper rozumie',
  'lp.s0.body':
    'Przy {preview} ocenionych Leads pokazujemy ci pierwsze wrażenie. Przy {active} Leadscraper aktywnie wyszukuje dla CIEBIE, na podstawie twoich konkretnych wzorców.',
  'lp.s0.eyebrow': 'Leadscraper uczy się z Tobą',
  'lp.s0.headline': 'Leadscraper buduje Twoją grupę docelową',
  'lp.s0.openMany': '{n} Leads jeszcze nieocenionych, oceń je, aby szybciej postępować.',
  'lp.s0.openOne': '{n} Lead jeszcze nieoceniony, oceń go, aby szybciej postępować.',
  'lp.s1.body':
    'Pierwsze tendencje są widoczne, przy {n} ocenach wpływa to aktywnie na twoje wyszukiwania.',
  'lp.s1.eyebrow': 'Pierwsze wrażenie',
  'lp.s1.headline': 'Leadscraper zbiera jeszcze dowody',
  'lp.s1.morePatterns': 'Dalsze wzorce, będą widoczne przy {n} ocenach',
  'lp.s1.strongestLabel': 'Najsilniejsza tendencja dotąd',
  'lp.s2.headline': 'Leadscraper wyszukuje dla CIEBIE',
  'lp.s2.ignoredMany':
    '{n} ocen to "już znamy" lub "błędne dane", nie wpływają świadomie na uczenie.',
  'lp.s2.ignoredOne':
    '{n} ocena to "już znamy" lub "błędne dane", nie wpływają świadomie na uczenie.',
  'lp.s2.pillActive': 'Aktywnie spersonalizowany',
  'lp.s2.pillSharp': 'Grupa docelowa dobrze dopasowana',
  'lp.s2.pillUpdating': 'Aktualizacja w toku',
  'lp.s2.reanalysisAgo': 'Ostatnia re-analiza: {n} ocen temu · Następna przy {next}',
  'lp.s2.reanalysisCurrent': 'Re-analiza obecnie · Następna przy {n}',
  'lp.s2.weakLabel': 'Słabe tendencje, będą twardsze z większą ilością danych',
  'lp.sq.activeSubS1':
    'Na podstawie twoich pierwszych {n} ocen, będą ostrzejsze z każdym krokiem re-analizy.',
  'lp.sq.activeSubS2': 'Zaktualizowano po {n} ocenach · Ponowna analiza co {interval} ocen.',
  'lp.sq.activeTitle': 'Leadscraper proponuje te wyszukiwania',
  'lp.sq.badge.crossSell': 'Cross-Sell',
  'lp.sq.badge.expansion': 'Rozszerzenie',
  'lp.sq.badge.pattern': 'Wzorzec',
  'lp.sq.badge.salesFit': 'Sales-Fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody': 'Propozycje będą obliczone z twoją następną re-analizą wzorców (co {n} ocen).',
  'lp.sq.eyebrow': 'Zoptymalizowane zapytania wyszukiwania',
  'lp.sq.launch': 'Rozpocznij wyszukiwanie',
  'lp.sq.loading': 'Leadscraper oblicza propozycje…',
  'lp.sq.lockedBody':
    'Jak tylko ocenisz {n} Leads, Leadscraper zaproponuje 3–5 zapytań wyszukiwania, ustrukturyzowanych jak twoje wprowadzenia, z prawdopodobieństwem dopasowania i krótkim uzasadnieniem.',
  'lp.sq.lockedTitle': 'Leadscraper przygotowuje konkretne propozycje',
  'lp.sq.mockA.contact': 'Zarząd',
  'lp.sq.mockA.rationale': 'Przykładowa propozycja jak Leadscraper proponuje wyszukiwania.',
  'lp.sq.mockA.region': 'Bawaria',
  'lp.sq.mockA.type': 'Średni producenci maszyn',
  'lp.sq.mockB.rationale': 'Przykładowa propozycja jak Leadscraper proponuje wyszukiwania.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'Projektanci TGA sektor szpitalny',
  'lp.sq.tier.hypothesis': 'Hipoteza testowa',
  'lp.sq.tier.solid': 'Solidny',
  'lp.sq.tier.strong': 'Silny',
  'lp.sq.tier.veryStrong': 'Bardzo silny',
  'lp.tone.drop': 'MOCNO ODRZUĆ',
  'lp.tone.keep': 'MOCNO ZACHOWAJ',
  'lp.tone.softDrop': 'LEKKO ODRZUĆ',
  'lp.tone.softKeep': 'LEKKO ZACHOWAJ',

  'lt.badge.soft': 'możliwy',
  'lt.dashHint1': 'W Dashboard znajdziesz wskazówkę na ten temat (symbol',
  'lt.dashHint2': 'obok statusu).',
  'lt.exp.btn': 'Eksport',
  'lt.exp.csvHint': '.csv (rozdzielone przecinkami)',
  'lt.exp.fail': 'Eksport nie powiódł się: {err}',
  'lt.exp.ing': 'Eksportowanie…',
  'lt.exp.noRows': 'Nie znaleziono Leads do eksportu.',
  'lt.exp.success': '{n} wierszy wyeksportowanych jako {fmt}.',
  'lt.exp.tipNoLeads': 'Eksportować można tylko leady z osobami kontaktowymi lub gotowym planem',
  'lt.exp.tipReady': 'Eksportuj {n} Leads',
  'lt.exp.tipWrongFilter':
    'Tylko pasujące Leads mogą być eksportowane. Przełącz na filtr „Pasuje".',
  'lt.exp.toastNoLeads':
    'Eksportować można tylko leady z osobami kontaktowymi lub gotowym planem akwizycji.',
  'lt.exp.unknownErr': 'Nieznany błąd',
  'lt.expH.city': 'Lokalizacja',
  'lt.expH.company': 'Firma',
  'lt.expH.companyEmail': 'E-mail firmowy',
  'lt.expH.companyPhone': 'Telefon firmowy',
  'lt.expH.contact': 'Osoba kontaktowa',
  'lt.expH.direct': 'bezpośredni',
  'lt.expH.email': 'E-mail',
  'lt.expH.emailSource': 'Źródło e-mail',
  'lt.expH.guessed': 'domniemany ({n}%)',
  'lt.expH.profile': 'Grupa docelowa',
  'lt.expH.role': 'Rola',
  'lt.expH.sector': 'Branża',
  'lt.feedbackFail': 'Nie udało się zapisać opinii. Spróbuj ponownie.',
  'lt.naceF.A': 'Rolnictwo, leśnictwo i rybołówstwo',
  'lt.payoff.avoided': 'Dossier od teraz unika:',
  'lt.payoff.flowsIn': 'Zasili następną analizę.',
  'lt.naceF.B': 'Górnictwo i wydobywanie',
  'lt.naceF.C': 'Przetwórstwo przemysłowe',
  'lt.naceF.D': 'Wytwarzanie i zaopatrywanie w energię elektryczną, gaz, parę wodną i gorącą wodę',
  'lt.naceF.E': 'Dostawa wody; gospodarowanie ściekami i odpadami',
  'lt.naceF.F': 'Budownictwo',
  'lt.naceF.G': 'Handel hurtowy i detaliczny; naprawa pojazdów samochodowych',
  'lt.naceF.H': 'Transport i gospodarka magazynowa',
  'lt.naceF.I': 'Działalność związana z zakwaterowaniem i usługami gastronomicznymi',
  'lt.naceF.J': 'Informacja i komunikacja',
  'lt.naceF.K': 'Działalność finansowa i ubezpieczeniowa',
  'lt.naceF.L': 'Działalność związana z obsługą rynku nieruchomości',
  'lt.naceF.M': 'Działalność profesjonalna, naukowa i techniczna',
  'lt.naceF.N': 'Świadczenie pozostałych usług gospodarczych',
  'lt.naceF.O': 'Administracja publiczna, obrona narodowa; obowiązkowe zabezpieczenia społeczne',
  'lt.naceF.P': 'Edukacja',
  'lt.naceF.Q': 'Opieka zdrowotna i pomoc społeczna',
  'lt.naceF.R': 'Działalność związana z kulturą, rozrywką i rekreacją',
  'lt.naceF.S': 'Pozostała działalność usługowa',
  'lt.naceF.T': 'Gospodarstwa domowe zatrudniające pracowników',
  'lt.naceF.U': 'Organizacje i zespoły eksterytorialne',
  'lt.naceS.A': 'Rolnictwo/Leśnictwo',
  'lt.naceS.B': 'Górnictwo',
  'lt.naceS.C': 'Przetwórstwo',
  'lt.naceS.D': 'Energetyka',
  'lt.naceS.E': 'Woda/Odpady',
  'lt.naceS.F': 'Budownictwo',
  'lt.naceS.G': 'Handel',
  'lt.naceS.H': 'Transport/Magazynowanie',
  'lt.naceS.I': 'Hotelarstwo',
  'lt.naceS.J': 'IT/Media',
  'lt.naceS.K': 'Finanse/Ubezpieczenia',
  'lt.naceS.L': 'Nieruchomości',
  'lt.naceS.M': 'Zawody wolne',
  'lt.naceS.N': 'Pozostałe usługi',
  'lt.naceS.O': 'Administracja publiczna',
  'lt.naceS.P': 'Edukacja',
  'lt.naceS.Q': 'Ochrona zdrowia',
  'lt.naceS.R': 'Kultura/Rozrywka',
  'lt.naceS.S': 'Pozostałe usługi',
  'lt.naceS.T': 'Gospodarstwa domowe',
  'lt.naceS.U': 'Eksterytorialne',
  'lt.next.title': 'Następne kroki',
  'lt.next.verifyContacts': 'Zweryfikuj kontakty',
  'lt.next.verifyingContacts': 'Weryfikacja kontaktów …',
  'lt.next.contactsVerified': 'Zweryfikowano {n} kontaktów',
  'lt.next.contactVerified': 'Kontakt zweryfikowany',
  'lt.next.openPlan': 'Otwórz plan',
  'lt.next.generatingPlan': 'Generowanie planu akwizycji …',
  'lt.next.credit': '1 kredyt',
  'lt.next.retry': 'Spróbuj ponownie',
  'lt.next.verifyFirst': 'Najpierw zweryfikuj kontakty',
  'lt.next.failedHint': 'Ostatnia próba się nie powiodła. Możesz spróbować ponownie.',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} leadów · wszystkie zapytania tej grupy docelowej trafiają tutaj',
  'lt.profileSubOne': '1 lead · wszystkie zapytania tej grupy docelowej trafiają tutaj',
  'lt.queryClear': 'Usuń filtr',
  'lt.queryLabel': 'Przefiltrowane według Query:',
  'lt.resetToast': 'Ocena dla {c} została zresetowana',
  'lt.ring.match': 'Dopasowanie {pct}%',
  'lt.ring.rejected': 'Odrzucono: zaliczone jako 0',
  'lt.rm.cancel': 'Anuluj',
  'lt.rm.header': 'Odrzuć Lead',
  'lt.rm.noteOptional': 'Notatka dla Leadscraper (opcjonalne)',
  'lt.rm.noteRequired': 'Proszę krótko opisać (wymagane)',
  'lt.rm.placeholderOpt':
    'Co Leadscraper przegapił lub źle ocenił? (Im bardziej konkretnie, tym lepiej system się uczy.)',
  'lt.rm.placeholderReq': 'Np. „Konkurent: sprzedaje podobne rozwiązanie"',
  'lt.rm.sub':
    'Powiedz nam dlaczego, Leadscraper uczy się z tego i następnym razem dostarczy lepsze wyniki.',
  'lt.rm.submit': 'Odrzuć lead',
  'lt.rr.already_known': 'Już znamy',
  'lt.rr.already_known.hint': 'Już w CRM lub wcześniej kontaktowani (brak sygnału uczenia)',
  'lt.rr.bad_data': 'Nieprawidłowe dane',
  'lt.rr.bad_data.hint': 'Adres, nazwa lub dane kontaktowe nie są poprawne',
  'lt.rr.no_buying_signal': 'Brak rozpoznawalnego zapotrzebowania',
  'lt.rr.no_buying_signal.hint':
    'Brak wydarzeń wyzwalających, otwartych stanowisk, sygnałów wzrostu',
  'lt.rr.not_operator': 'Nie operator',
  'lt.rr.not_operator.hint': 'Agencja, pośrednik lub deweloper zamiast operacyjnego dostawcy',
  'lt.rr.other': 'Inny powód',
  'lt.rr.other.hint': 'Napisz krótko dlaczego poniżej (tekst dowolny)',
  'lt.rr.wrong_industry': 'Zła branża',
  'lt.rr.wrong_industry.hint': 'Leadscraper błędnie rozpoznał obszar działalności',
  'lt.rr.wrong_ownership': 'Zła struktura właścicielska',
  'lt.rr.wrong_ownership.hint':
    'Spółka zależna koncernu zamiast firmy rodzinnej, nieprawidłowa forma prawna itp.',
  'lt.rr.wrong_region': 'Zła lokalizacja',
  'lt.rr.wrong_region.hint': 'Siedziba / region nie pasuje do wyszukiwania',
  'lt.rr.wrong_role': 'Zła osoba kontaktowa',
  'lt.rr.wrong_role.hint': 'Osoba lub stanowisko nie jest decydentem',
  'lt.rr.wrong_size': 'Zły rozmiar firmy',
  'lt.rr.wrong_size.hint': 'Za mała, za duża lub koncern zamiast średniej firmy',
  'lt.tip.accepted': 'Zaakceptowany, kliknij aby cofnąć',
  'lt.tip.contacts': 'Pokaż {n} osoby kontaktowe',
  'lt.tip.dragCol': 'Przeciągnij szerokość kolumny',
  'lt.tip.openCompany': 'Otwórz szczegóły firmy',
  'lt.tip.openLead': 'Otwórz szczegóły Lead',
  'lt.tip.rejected': 'Odrzucony, kliknij aby cofnąć',
  'lt.tip.softKeep': 'Potencjalnie istotny, Leadscraper ma tutaj wątpliwość, zobacz szczegóły',
  'lt.tip.unseen': 'Jeszcze niewidziany',
  // AddCompanyManualModal — ręczne dodawanie przez URL
  'lt.manual.modal.eyebrow': 'Pipeline · ręcznie',
  'lt.manual.modal.title': 'Dodaj firmę',
  'lt.manual.modal.desc':
    'Leadscraper weryfikuje stronę internetową i pobiera podstawowe dane firmy. Lead trafia następnie do {phase}, skąd możesz pozyskać kontakty + plan akwizycji.',
  'lt.manual.modal.phase': '„Firma dodana"',
  'lt.manual.modal.websiteLabel': 'Strona internetowa',
  'lt.manual.modal.placeholder': 'np. heuerlogistics.de',
  'lt.manual.modal.hint':
    'Spróbujemy połączyć się ze stroną. W razie błędu kredyt nie zostanie pobrany.',
  'lt.manual.modal.cancel': 'Anuluj',
  'lt.manual.modal.close': 'Zamknij',
  'lt.manual.modal.submit': 'Dodaj',
  'lt.manual.modal.submitting': 'Dodawanie …',
  'lt.manual.modal.creditOne': '{n} kredyt',
  'lt.manual.modal.creditMany': '{n} kredytów',
  'lt.manual.modal.errEmpty': 'Podaj stronę internetową.',
  'lt.manual.modal.errInvalid':
    'To nie wygląda na prawidłową stronę internetową (np. heuerlogistics.de).',

  'mem.cancel': 'Anuluj',
  'mem.editHint': 'Leadscraper użyje tego stwierdzenia od następnego sortowania.',
  'mem.editKicker': 'Popraw wyuczone założenie',
  'mem.editTitle': 'Jak ma się tego nauczyć Leadscraper?',
  'mem.param.contact': 'Osoba kontaktowa',
  'mem.param.extras': 'Dodatkowe',
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Lokalizacja',
  'mem.param.sector': 'Branża',
  'mem.profile': 'Profil',
  'mem.save': 'Zapisz założenie',
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · puste',
  'mem.toast.confirmed': 'Założenie potwierdzone.',
  'mem.toast.corrected': 'Korekta zapisana.',
  'mem.toast.forgotten': 'Założenie zapomniane.',
  'mem.today': 'Dzisiaj',

  'mob.abo': 'Subskrypcja i Credits',
  'mob.acct.aria': 'Moje konto',
  'mob.active': 'Aktywny',
  'mob.back': '← Wstecz',
  'mob.changePassword': 'Zmień hasło',
  'mob.changePlan': 'Zmień plan',
  'mob.detail.contacts': 'Osoby kontaktowe ({n})',
  'mob.detail.fits': '✓ Pasuje',
  'mob.detail.label.email': 'E-mail',
  'mob.detail.label.phone': 'Telefon',
  'mob.detail.label.website': 'Strona internetowa',
  'mob.detail.notFitting': '✗ Nie pasuje',
  'mob.detail.rejected': '✗ Odrzucone',
  'mob.detail.section.company': 'Firma',
  'mob.fb.fits': '✓ Pasuje',
  'mob.fb.rejected': '✗ Odrzucone',
  'mob.home.activeProfile': 'Aktywna grupa docelowa',
  'mob.home.cta.newSearch': 'Rozpocznij nowe wyszukiwanie',
  'mob.home.emptyHint': 'Rozpocznij nowe wyszukiwanie lub zmień grupę docelową.',
  'mob.home.newLeads': 'Nowe Leads',
  'mob.home.stat.fits': 'Pasuje',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Wskaźnik dopasowań',
  'mob.home.viewAll': 'Zobacz wszystkie →',
  'mob.leads.cta.newSearch': 'Rozpocznij nowe wyszukiwanie',
  'mob.leads.filter.all': 'Wszystkie',
  'mob.leads.filter.fits': 'Pasuje',
  'mob.leads.filter.open': 'Otwarte',
  'mob.leads.filter.rejected': 'Odrzucone',
  'mob.leads.new': '＋ Nowe',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Wyloguj',
  'mob.logoutConfirm': 'Czy na pewno chcesz się wylogować?',
  'mob.more.help': 'Pomoc i kontakt',
  'mob.more.invoices': 'Faktury',
  'mob.more.label.email': 'E-mail',
  'mob.more.plan.monthly': 'Subskrypcja miesięczna',
  'mob.more.plan.trial': 'Trial',
  'mob.more.section.account': 'Moje konto',
  'mob.more.section.help': 'Pomoc i aplikacja',
  'mob.more.title': 'Więcej',
  'mob.more.toDesktop': 'Przełącz na komputer',
  'mob.more.toDesktop.value': 'Pełna funkcjonalność',
  'mob.nav.account': 'Konto',
  'mob.nav.home': 'Strona główna',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Grupy docelowe',
  'mob.onDesktop': 'Na komputerze',
  'mob.profile.active': 'Aktywny',
  'mob.profile.leadsCount': '{n} Leads',
  'mob.profile.newCount': '{n} nowych',
  'mob.profile.stat.match': 'Dopasowanie',
  'mob.profile.switchTo': 'Przełącz na',
  'mob.profile.title': 'Grupy docelowe',
  'mob.queryPlaceholder': 'np. piekarnie, doradcy podatkowi, sklepy obuwnicze',
  'mob.search.askWho': 'Kogo szukasz?',
  'mob.search.cancel': 'Anuluj',
  'mob.search.profileLabel': 'Grupa docelowa: {name}',
  'mob.search.region': 'Region (opcjonalnie)',
  'mob.search.regionPlaceholder': 'np. Mazowieckie, Kraków, Śląsk',
  'mob.search.start': 'Rozpocznij wyszukiwanie',
  'mob.search.title': 'Nowe wyszukiwanie',
  'mob.toast.accepted': '✓ Oznaczone jako pasujące',
  'mob.toast.rejected': '✗ Odrzucone',
  'mob.toast.runStarted': 'Wyszukiwanie rozpoczęte, wyniki za ~2 min',
  'mob.trialLeads': 'Pozostałe testowe Leads',
  'mob.upgrade': 'Przejdź na Pro',
  'mob.upgradeHint': 'Więcej Leads + harmonogram',
  'mob.wizardHint':
    'Utwórz swój pierwszy profil na komputerze: kreator nie jest jeszcze dostępny na urządzeniach mobilnych.',

  'mobile.empty.noContactData': 'Brak dostępnych danych kontaktowych.',
  'mobile.empty.noOpenLeads': 'Brak otwartych Leads.',
  'mobile.empty.noProfileSelected': 'Nie wybrano grupy docelowej.',
  'mobile.empty.noProfileShort': 'Brak grupy docelowej.',
  'mobile.empty.nothingFound': 'Nic nie znaleziono.',
  'mobile.note.label': 'Uwaga:',
  'mobile.note.scheduleDesktop': 'Harmonogramy i pamięć grupy docelowej edytujesz na komputerze.',
  'mobile.tip.label': 'Wskazówka:',
  'mobile.tip.profilesDesktop':
    'Wiele grup docelowych (np. według branży lub regionu) tworzysz na komputerze.',

  'ms.aud.computingBody':
    'Za kilka sekund Leadscraper opisze tutaj twoją grupę docelową własnymi słowami.',
  'ms.aud.computingEyebrow': 'Leadscraper analizuje twoje oceny',
  'ms.aud.computingTitle': 'Rozpoznawanie wzorców w toku…',
  'ms.aud.derivedFrom': 'Wyprowadzone z twoich {n} ocen',
  'ms.aud.eyebrowS1': 'Pierwsza ocena od Leadscraper',
  'ms.aud.eyebrowS2': 'Aktualna ocena od Leadscraper',
  'ms.aud.fallbackBody':
    'Gdy tylko ponowna analiza zostanie zakończona (za kilka sekund), pojawi się tutaj konkretny opis twojej grupy docelowej.',
  'ms.aud.fallbackEyebrow': 'Pierwsza ocena od Leadscraper',
  'ms.aud.fallbackTitle': 'Leadscraper właśnie aktualizuje ocenę o twoje ostatnie {n} ocen.',
  'ms.aud.learnedLabel': 'Konkretnie nauczone',
  'ms.aud.lockedEyebrow': 'Grupa docelowa w słowach Leadscraper',
  'ms.aud.lockedMock':
    'Szukasz mniejszych operatorów w NRW z aktywnym rekrutowaniem, kontakty na poziomie zarządu, firmy rodzinne z wyraźną tendencją branżową w kierunku budowy maszyn.',
  'ms.aud.lockedPill': 'od {n} ocen',
  'ms.aud.nextReanalysis': ' · Następna ponowna analiza przy {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper aktualizuje twoją ocenę',
  'ms.aud.recomputeTitle': 'Z twoimi ostatnimi ocenami ocena jest ponownie przeliczana…',
  'ms.aud.trainS1':
    'Trenuj scraper dalej, a otrzymasz **naprawdę mocne wyniki**, każda ocena czyni Leadscraper bardziej precyzyjnym.',
  'ms.aud.trainS2':
    'Trenuj Leadscraper dalej, **każda ocena wyostrza wyszukiwania**, które od teraz działają automatycznie dla ciebie.',
  'ms.card.label': 'Status Leadscraper',
  'ms.card.ratings': '{n} / {threshold} ocen',
  'ms.card.s2active': '{n} ocen · aktywne w analizie',
  'ms.card.s2reanalysis': '{n} ocen · ponownie analizowane',
  'ms.cv.age': 'Wiek firmy: {rule}',
  'ms.cv.bizModel': 'Model biznesowy: {rule}',
  'ms.cv.buyingSignals': 'Sygnały zakupu: {rule}',
  'ms.cv.domainBlock': 'Wykluczenie: {rule}',
  'ms.cv.geo': 'Region: {rule}',
  'ms.cv.industry': 'Branża: {rule}',
  'ms.cv.ownership': 'Własność: {rule}',
  'ms.cv.role': 'Osoba kontaktowa: {rule}',
  'ms.cv.size': 'Rozmiar: {rule}',
  'ms.cv.techStack': 'Stos technologiczny: {rule}',
  'ms.donut.match': 'pasuje',
  'ms.donut.matchRate': 'Współczynnik trafień',
  'ms.donut.noMatch': 'nie pasuje',
  'ms.donut.ratings': 'Oceny',
  'ms.donut.title': 'Stan ocen',
  'ms.error': 'Błąd',
  'ms.msg.s0': 'Uczy się z tobą · {n}/{threshold} do podglądu',
  'ms.msg.s1': 'Pierwsze wrażenie · {n}/{threshold} do aktywacji',
  'ms.msg.s2active': 'Aktywnie spersonalizowane · {n} ocen',
  'ms.msg.s2reanalysis': 'Właśnie ponownie analizowane · {n}',
  'ms.stage0.eyebrow': 'Uczy się z tobą',
  'ms.stage1.eyebrow': 'Pierwsze wrażenie',
  'ms.stage2.eyebrow': 'Aktywnie spersonalizowane',

  'nace.A': 'Rolnictwo, leśnictwo i rybołówstwo',
  'nace.B': 'Górnictwo i wydobycie',
  'nace.C': 'Przetwórstwo przemysłowe',
  'nace.D': 'Wytwarzanie i zaopatrywanie w energię elektryczną, gaz, parę wodną i gorącą wodę',
  'nace.E':
    'Dostawa wody; gospodarowanie ściekami i odpadami oraz działalność związana z rekultywacją',
  'nace.F': 'Budownictwo',
  'nace.G': 'Handel hurtowy i detaliczny; naprawa pojazdów samochodowych i motocykli',
  'nace.H': 'Transport i gospodarka magazynowa',
  'nace.I': 'Działalność związana z zakwaterowaniem i usługami gastronomicznymi',
  'nace.J': 'Informacja i komunikacja',
  'nace.K': 'Działalność finansowa i ubezpieczeniowa',
  'nace.L': 'Działalność związana z obsługą rynku nieruchomości',
  'nace.M': 'Działalność profesjonalna, naukowa i techniczna',
  'nace.N': 'Działalność w zakresie usług administrowania i działalność wspierająca',
  'nace.O': 'Administracja publiczna i obrona narodowa; obowiązkowe zabezpieczenia społeczne',
  'nace.P': 'Edukacja',
  'nace.Q': 'Opieka zdrowotna i pomoc społeczna',
  'nace.R': 'Działalność związana z kulturą, rozrywką i rekreacją',
  'nace.S': 'Pozostała działalność usługowa',
  'nace.T': 'Gospodarstwa domowe zatrudniające pracowników',
  'nace.U': 'Organizacje i zespoły eksterytorialne',

  'naceShort.A': 'Rolnictwo/Leśnictwo',
  'naceShort.B': 'Górnictwo',
  'naceShort.C': 'Przetwórstwo',
  'naceShort.D': 'Energia',
  'naceShort.E': 'Woda/Odpady',
  'naceShort.F': 'Budownictwo',
  'naceShort.G': 'Handel',
  'naceShort.H': 'Transport/Magazyny',
  'naceShort.I': 'Gastronomia',
  'naceShort.J': 'IT/Media',
  'naceShort.K': 'Finanse/Ubezp.',
  'naceShort.L': 'Nieruchomości',
  'naceShort.M': 'Usługi prof.',
  'naceShort.N': 'Inne usługi',
  'naceShort.O': 'Administracja',
  'naceShort.P': 'Edukacja',
  'naceShort.Q': 'Zdrowie',
  'naceShort.R': 'Kultura/Rozr.',
  'naceShort.S': 'Inne usługi',
  'naceShort.T': 'Gosp. domowe',
  'naceShort.U': 'Eksterytorialne',

  'nav.activeProfile': 'Aktywna grupa docelowa',
  'nav.apiStatus.checking': 'Sprawdzanie statusu API …',
  'nav.apiStatus.down': 'API niedostępne, proszę odświeżyć stronę',
  'nav.apiStatus.ok': 'API dostępne',
  'nav.apiStatus.slow': 'API odpowiada wolno',
  'nav.buyLeads': 'Kup Leads teraz',
  'nav.cortex': 'Grupa docelowa',
  'nav.credits': 'Dostępne Credits',
  'nav.credits.available': 'Dostępne',
  'nav.credits.label': 'Stan konta',
  'nav.credits.remaining': 'Pozostało',
  'nav.credits.total': 'Łącznie',
  'nav.credits.upgrade': 'Upgrade',
  'nav.dashboard': 'Pulpit',
  'nav.deleteProfile': 'Usuń grupę docelową',
  'nav.deleteProfileTitle': 'Usunąć grupę docelową?',
  'nav.deleteProfileBody':
    'Wszystkie leady, oceny i wyuczone wzorce dla „{name}" zostaną trwale usunięte. Tej operacji nie można cofnąć.',
  'nav.deleteProfileBusy': 'Usuwanie…',
  'nav.deleteProfileError': 'Nie udało się usunąć grupy docelowej. Spróbuj ponownie.',
  'nav.deleteProfileInFlight':
    'Trwa wyszukiwanie dla tej grupy docelowej. Zaczekaj, aż się zakończy.',
  'nav.deleteProfileSuccess': 'Grupa docelowa usunięta.',
  'nav.feedbacks': 'Opinie',
  'nav.leads': 'Leads',
  'nav.matchRate': 'Współczynnik trafień',
  'nav.rated': 'ocenione',
  'nav.open': 'otwarte',
  'nav.rateNudge.title': 'Przejdź do jeszcze nieocenionych Leadów',
  'nav.allRated': 'Wszystkie ocenione',
  'nav.newProfile': 'Utwórz nową grupę docelową',
  'nav.onboardingRequired': 'Proszę najpierw zakończ 3 kroki wdrożenia.',
  'nav.openSettings': 'Otwórz ustawienia i learnings "{name}"',
  'nav.profileName': 'Nazwa grupy docelowej',
  'nav.profileNameP': 'np. Usługi IT DACH',
  'nav.renameProfile': 'Zmień nazwę grupy docelowej',
  'nav.renameProfileSub': 'Wybierz nową nazwę dla tej grupy docelowej.',
  'nav.runs.footer': 'Kliknij grupę docelową, aby zobaczyć postęp. Możesz dalej pracować.',
  'nav.runs.leadsReady': '{n} Lead{s} gotowy',
  'nav.runs.many': '{n} wyszukiwań w toku',
  'nav.runs.one': '1 wyszukiwanie w toku',
  'nav.runs.title': 'Trwające wyszukiwania',
  'nav.startSubscription': 'Rozpocznij subskrypcję',
  'nav.switchProfiles': 'Przełącz grupy docelowe',

  'notif.act.edge': 'Zobacz przypadki graniczne',
  'notif.act.pattern': 'Potwierdź w Leadscraper',
  'notif.act.review': 'Do Leads',
  'notif.dismiss': 'Ukryj',
  'notif.edge.body':
    '{n} niepewnych Leads w {profile}, twoja ocena najbardziej wzmacnia Leadscraper.',
  'notif.edge.title': 'Przypadki graniczne wymagają twojej oceny',
  'notif.empty.sub': 'Leadscraper się uczy.',
  'notif.empty.title': 'Wszystko w porządku.',
  'notif.kind.edge': 'Przypadek graniczny',
  'notif.kind.pattern': 'Wzorzec',
  'notif.kind.review': 'Ocena',
  'notif.pattern.back': 'Wstecz',
  'notif.pattern.badge': 'Wyuczony wzorzec',
  'notif.pattern.confirmedLabel': 'Wzorzec potwierdzony.',
  'notif.pattern.needsConfirm': 'Czy to się zgadza?',
  'notif.pattern.no': 'Nie, odrzuć',
  'notif.pattern.rejectedLabel': 'Wzorzec odrzucony.',
  'notif.pattern.saveAndClose': 'Zapisz',
  'notif.pattern.stage2': 'Zapisano',
  'notif.pattern.title': 'Rozpoznano wzorzec',
  'notif.pattern.whyLabel': 'Dlaczego? (opcjonalne)',
  'notif.pattern.whyPlaceholder':
    'Pomaga Leadscraper nauczyć się niuansów, ale nie jest konieczne.',
  'notif.pattern.yes': 'Tak, zgadza się',
  'notif.review.body': 'Masz jeszcze {n} nieocenionych Leads.',
  'notif.review.cta': 'Oceń teraz',
  'notif.review.title': 'Oceń nowe Leads',
  'notif.sub': 'Podpowiedzi, które czynią Leadscraper bardziej precyzyjnym.',
  'notif.title': 'Powiadomienia',

  'np.abort': 'Anuluj',
  'np.audience': 'Opisz grupę docelową',
  'np.audienceHint':
    'Im konkretniej, tym lepszy pierwszy przebieg sortowania. Możesz to zmienić w każdej chwili później.',
  'np.audienceHintLong':
    'Napisz to tak, jak wyjaśniłbyś to nowemu pracownikowi sprzedaży. Leadscraper wykorzystuje to jako podstawę do oceny, i uczy się dalej z każdej opinii.',
  'np.audienceLabel': 'Opis grupy docelowej',
  'np.audienceP':
    'Przykład: Chcemy pozyskać średniej wielkości kancelarie podatkowe dla naszego rozwiązania rekrutacyjnego. Celem jest pierwsza rozmowa z zarządem.',
  'np.back': 'Wstecz',
  'np.briefingHelp.q1': 'Jaki jest twój cel z tą grupą docelową?',
  'np.briefingHelp.q2': 'Co oferujesz?',
  'np.briefingHelp.q3': 'Dlaczego twoja oferta jest istotna dla tej grupy docelowej?',
  'np.briefingHelp.q4': 'Jaka jest twoja najsilniejsza przewaga konkurencyjna?',
  'np.briefingHelp.q5': 'Jakie problemy rozwiązujesz?',
  'np.briefingHelp.q6': 'Do kogo chcesz zwrócić się w pierwszej kolejności?',
  'np.briefingHelp.q7': 'Który kanał działa dla ciebie: e-mail, telefon, LinkedIn?',
  'np.briefingHelp.q8': 'Jaki ma być następny krok: odpowiedź, spotkanie, demo, oferta?',
  'np.briefingHelp.q9': 'Czego należy unikać w komunikacji?',
  'np.briefingHelpTitle': 'Pomocne dla Leadscraper',
  'np.coldStart': 'Start od zera, bez parametrów bazowych',
  'np.coldStartDesc':
    'Profil rozpoczyna się całkowicie pusty. Po około 20 opiniach w Leadscraper pojawią się pierwsze jasne wnioski.',
  'np.companySize': 'Wielkość firmy',
  'np.companySizeP': 'np. 50–250 pracowników',
  'np.continue': 'Dalej',
  'np.create': 'Utwórz grupę docelową',
  'np.created': 'Grupa docelowa utworzona. Leadscraper jest gotowy.',
  'np.creating': 'Tworzenie...',
  'np.header': 'Nowa grupa docelowa',
  'np.headline': 'Zdefiniuj grupę docelową',
  'np.suggHeading': 'Sugestie dla Twojej grupy docelowej',
  'np.suggHint':
    'Kliknięcie zastosuje sugestię, możesz przełączać się między nimi, wpisać własny tekst lub utworzyć od razu.',
  'np.draftWriting': 'Leadscraper pisze Twój briefing …',
  'np.draftErrorLabel': 'Uwaga:',
  'np.draftErrorFallback':
    'Nie udało się wygenerować szkicu briefingu. Możesz pisać dalej ręcznie.',
  'np.industry': 'Branża',
  'np.industryP': 'np. opakowania, pudełka składane',
  'np.name': 'Nazwa grupy docelowej',
  'np.nameP': 'np. Producenci pudełek składanych NRW',
  'np.notes': 'Dodatkowe wskazówki',
  'np.notesP': 'Wykluczenia, typy klientów, słowa sygnalne…',
  'np.nothingYet':
    'Nic nie jest predefiniowane. Leadscraper będzie kształtowany przez twoje opinie.',
  'np.optional': 'Opcjonalne',
  'np.region': 'Region / Województwo',
  'np.regionP': 'np. Śląsk, CEE, cała Polska',
  'np.skip': 'Pomiń',
  'np.step1Sub':
    'Nadaj swojemu profilowi jasną nazwę. Leadscraper wykorzystuje ten opis jako punkt wyjścia, zanim Twoja ocena wyostrzy wzorzec.',
  'np.step1Title': 'Kogo lub czego szukasz?',
  'np.step2Sub':
    'Opcjonalne: Leadscraper wykorzystuje te dane jako punkt wyjściowy. Profil uczy się dalej, gdy oceniasz Leads.',
  'np.step2Title': 'Podstawowe parametry',
  'np.stepOf': 'Krok {n} z 2',
  'np.summaryTitle': 'Leadscraper startuje z',
  'np.title': 'Utwórz nową grupę docelową',
  'np.whatHappens': 'Co dzieje się potem?',
  'np.whatHappensBody':
    'W dashboardzie uruchamiasz <b>zapytanie wyszukiwania</b> i określasz branżę, region i wielkość. Leadscraper znajduje pasujące firmy z osobami kontaktowymi i na podstawie tego briefingu tworzy plan akwizycji dla każdego Leada.',

  'offer.beta.pricing.intro': 'Zaproszenie Beta · 55% rabatu na pierwszy miesiąc',

  'og.beta.cardCta': 'Aktywuj pakiet Beta',
  'og.beta.cardFeature.1': '500 Leads / miesiąc w zakresie Growth',
  'og.beta.cardFeature.2': 'Natychmiastowa aktywacja. Bez trialu',
  'og.beta.cardFeature.3': 'Anuluj w każdej chwili jednym kliknięciem',
  'og.beta.cardFoot': 'Karta wymagana · bezpieczna płatność przez Stripe',
  'og.beta.cardName': 'Twój pakiet Beta',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' miesięcznie: zweryfikowane e-maile i numery telefonu',
  'og.beta.feature.2': 'AI-targeting w naturalnym języku',
  'og.beta.feature.3': 'Integracje CRM + eksport CSV/Excel',
  'og.beta.feature.4': 'Zgodne z RODO · Dane w UE',
  'og.beta.feature.5.bold': 'dostęp WhatsApp do Janika',
  'og.beta.feature.5.lead': 'Bezpośredni ',
  'og.beta.feature.5.tail': ' w przypadku pytań',
  'og.beta.narrativeBody':
    'Szukamy {profis}, którzy wcześnie wykorzystają nasz system, będą szczerze dawać feedback i współdecydować o rozwoju Leadscraper. W zamian płacisz {price} za pierwszy miesiąc pakietu Growth, zamiast regularnych 490 € — potem obowiązuje cena regularna, anuluj w każdej chwili.',
  'og.beta.narrativePrice': 'tylko 220 €',
  'og.beta.narrativeProfis': '30 aktywnych profesjonalistów sprzedaży',
  'og.beta.narrativeTitle': 'Dlaczego ta oferta?',
  'og.beta.priceNowSuffix': '/ pierwszy miesiąc',
  'og.beta.priceFootnote': 'potem {n} €/mies. · anuluj w każdej chwili',
  'og.beta.priceOld': '{n} € / miesiąc standardowo',
  'og.beta.savings': 'Oszczędzasz {n} € w pierwszym miesiącu',
  'og.cancelAny': 'Anuluj w każdym momencie',
  'og.cta': 'Testuj 3 dni za darmo: {plan}',
  'og.ctaBeta': 'Zabezpiecz dostęp Beta: {price} € / miesiąc',
  'og.ctaPlain': 'Kontynuuj z {plan}',
  'og.ctaSub':
    'Brak płatności przez pierwsze 3 dni · Następnie {price},00 € / miesiąc · {leads} testowych Leads w zestawie',
  'og.ctaSubPlain': '{price},00 € / miesiąc · natychmiastowa aktywacja',
  'og.dsgvo': 'Zgodne z RODO · Serwery w DE',
  'og.eyebrow.beta': 'Osobiste zaproszenie Beta',
  'og.eyebrow.trial50': '50 Credits w prezencie',
  'og.hlBanner.trial50.body':
    'Po wyborze planu natychmiast otrzymasz {credits} na swoje konto. Wykorzystaj je w ciągu najbliższych 3 dni, jeśli nie anulujesz, automatycznie przejdziesz na wybrany plan.',
  'og.hlBanner.trial50.credits': '{n} Credits',
  'og.hlBanner.trial50.title': 'Tak działa twój trial:',
  'og.later': 'Zdecyduj później →',
  'og.leadsIncl': '{n} Leads miesięcznie w zestawie',
  'og.maiOffer.cta': 'Oferta majowa: 100 Leads B2B za 49 €',
  'og.maiOffer.detail': 'Idealnie na start, bez zobowiązań.',
  'og.maiOffer.feature.1': 'Zweryfikowane e-maile i numery telefonów',
  'og.maiOffer.feature.2': 'Targeting AI w języku naturalnym',
  'og.maiOffer.feature.3': 'Integracje CRM + eksport CSV/Excel',
  'og.maiOffer.feature.4': 'Zgodność z RODO · Dane w UE',
  'og.maiOffer.feature.5': 'Od 2. miesiąca: 190 €/miesiąc, można anulować jednym kliknięciem',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / miesiąc',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '49 €',
  'og.maiOffer.priceNote': '0,49 € zamiast 1,90 € za Lead, tylko w tym miesiącu.',
  'og.maiOffer.priceOriginal': 'Zamiast 190 € / miesiąc',
  'og.maiOffer.priceSuffix': '/ miesiąc',
  'og.moneyBack': '14 dni gwarancji zwrotu pieniędzy',
  'og.perMonth': '€ / miesiąc',
  'og.plan': 'Plan',
  'og.planBadge.recommended': 'Polecany',
  'og.planCta.loading': 'Przechodzę do płatności …',
  'og.planCta.pick.basic': 'Wybierz Basic',
  'og.planCta.pick.growth': 'Wybierz Growth',
  'og.planCta.pick.starter': 'Wybierz Starter',
  'og.planCta.trial.basic': 'Testuj za darmo przez 3 dni',
  'og.planCta.trial.growth': 'Testuj za darmo przez 3 dni',
  'og.planCta.trial.starter': 'Testuj za darmo przez 3 dni',
  'og.planDetail.basic': 'Dla małych zespołów sprzedaży, które działają celowo.',
  'og.planDetail.growth': 'Dla zespołów, które chcą skalować outbound.',
  'og.planDetail.starter': 'Najlepszy stosunek jakości do ceny dla aktywnych zespołów.',
  'og.planFeature.basic.1': 'Zweryfikowane e-maile i numery telefonu',
  'og.planFeature.basic.2': 'AI-targeting w naturalnym języku',
  'og.planFeature.basic.3': 'Integracje CRM + eksport CSV/Excel',
  'og.planFeature.basic.4': 'Zgodność z RODO · Dane w UE',
  'og.planFeature.growth.1': 'Wszystko ze Starter',
  'og.planFeature.growth.2': '5× więcej Leads miesięcznie',
  'og.planFeature.growth.3': 'Osobista rozmowa wdrożeniowa',
  'og.planFeature.growth.4': 'Premium wsparcie bezpośrednio z Janik',
  'og.planFeature.starter.1': 'Wszystko z Basic',
  'og.planFeature.starter.2': '2,5× więcej Leads miesięcznie',
  'og.planFeature.starter.3': 'Priorytetowa kolejka Leads',
  'og.planFeature.starter.4': 'Wsparcie e-mailowe < 4 h',
  'og.planLeadsUnit': 'Leads / miesiąc',
  'og.planPriceNote.basic.default': 'Odpowiada 1,90 € za Lead',
  'og.planPriceNote.basic.trial': 'Potem {price}\u00A0€/mies. · 100 Credits wliczone',
  'og.planPriceNote.growth.default': 'Odpowiada 0,98 € za Lead. Oszczędzasz 48%',
  'og.planPriceNote.growth.trial':
    'Potem {price}\u00A0€/mies. · 500 Credits wliczone · Oszczędzasz 48%',
  'og.planPriceNote.starter.default': 'Odpowiada 1,16 € za Lead. Oszczędzasz 39%',
  'og.planPriceNote.starter.trial':
    'Potem {price}\u00A0€/mies. · 250 Credits wliczone · Oszczędzasz 39%',
  'og.planPriceSuffix.default': '/ miesiąc',
  'og.planPriceSuffix.trial': '/ miesiąc po okresie próbnym',
  'og.planPriceSuffix.trialToday': 'dzisiaj',
  'og.ready': 'Twoje konto jest gotowe',
  'og.recommended': 'Polecane',
  'og.split.badge.start': 'Idealne na start',
  'og.split.rating.note': '· Doskonałe opinie użytkowników',
  'og.split.rating.score': '4.8 / 5.0',
  'og.split.trust.cancel': 'Anulowanie jednym kliknięciem',
  'og.split.trust.gdpr': 'Zgodne z RODO',
  'og.step.activateBeta': 'Aktywuj pakiet Beta',
  'og.step.created': 'Konto utworzone',
  'og.step.pickPlan': 'Wybierz plan',
  'og.step.start': 'Rozpocznij',
  'og.step.startTrial': 'Testuj 3 dni za darmo',
  'og.sub1': 'Wybierz swoją subskrypcję, aby przetestować Leadscraper',
  'og.sub1b': '3 dni za darmo',
  'og.sub2': 'Brak płatności teraz, możesz anulować w każdym momencie podczas okresu próbnego.',
  'og.subtitle.beta':
    'Jako tester Beta otrzymujesz nasz najsilniejszy pakiet, 500 Leads miesięcznie, w cenie promocyjnej: pierwszy miesiąc kosztuje 220 € zamiast 490 €. Brak minimalnego okresu, anuluj w każdej chwili.',
  'og.subtitle.default':
    'Trzy plany, ta sama jakość danych. Wybierz, ile Leads potrzebujesz miesięcznie, możesz zmienić i anulować w każdej chwili jednym kliknięciem.',
  'og.subtitle.mai':
    'W pierwszym miesiącu oszczędzasz 74%, potem zmień lub anuluj jednym kliknięciem w każdym momencie.',
  'og.subtitle.trial50': '50 Leads za darmo, testuj przez 3 dni, anuluj w każdym momencie.',
  'og.title.beta.grad': 'ręcznie wybrany',
  'og.title.beta.lead': 'Zostałeś ',
  'og.title.beta.tail': ' do Beta.',
  'og.title.default.grad': 'zacznij w 60 sekund',
  'og.title.default.lead': 'Wybierz swój plan i ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'nieuczciwa przewaga konkurencyjna',
  'og.title.mai.lead': 'Twoja ',
  'og.title.mai.tail': ' zaczyna się tutaj.',
  'og.title.trial50.grad': 'teraz za darmo',
  'og.title.trial50.lead': '50 Leads B2B o wartości 100 €, ',
  'og.title.trial50.tail': '.',
  'og.trial': 'Testuj 3 dni za darmo',
  'og.trial50v2.cta': 'Zabezpiecz 50 Credits za darmo',
  'og.trial50v2.detail': 'Wystarczająco Credits, aby w pełni przetestować Leadscraper.',
  'og.trial50v2.feature.1': 'Zweryfikowane e-maile i numery telefonów',
  'og.trial50v2.feature.2': 'Targetowanie AI w naturalnym języku',
  'og.trial50v2.feature.3': 'Integracje CRM + eksport CSV/Excel',
  'og.trial50v2.feature.4': 'Zgodny z RODO · Dane w UE',
  'og.trial50v2.feature.5': 'Kontynuuje po 3 dniach, anulowanie jednym kliknięciem',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads w 3 dni',
  'og.trial50v2.planName': 'Okres próbny',
  'og.trial50v2.price': 'Za darmo',
  'og.trial50v2.priceNote':
    'Kończy się po 3 dniach lub jest kontynuowany, anulowanie jednym kliknięciem.',
  'og.trialIncl': 'w tym',
  'og.trialLeadsN': '{n} testowych Leads',
  'og.trust.beta.lock.body': 'bez ukrytych dopłat',
  'og.trust.beta.lock.title': 'Cena specjalna Beta w 1. miesiącu',
  'og.trust.cancel.body.default': 'Brak minimalnego okresu',
  'og.trust.cancel.body.trial': 'Bezpłatnie w okresie próbnym',
  'og.trust.cancel.title.default': 'Anuluj jednym kliknięciem',
  'og.trust.card.body.default': 'Bezpieczna płatność przez Stripe',
  'og.trust.card.body.trial': 'Płatność dopiero po 3 dniach',
  'og.trust.card.title.default': 'Karta wymagana',
  'og.trust.card.title.trial': 'Karta do aktywacji',
  'og.trust.gdpr.body': 'Serwery w UE · tylko publiczne źródła',
  'og.trust.gdpr.title': 'Zgodność z RODO',
  'og.welcome': 'Witaj, Janik.',

  'onb.step1Done': 'Leadscraper zna już Twoją ofertę, zobacz analizę poniżej',

  'onb.heroTitle': 'Twoja przewaga konkurencyjna zaczyna się tutaj',

  'onb.heroDesc':
    'W 3 krokach do pierwszych 10 leadów. Leadscraper naprawdę cię poznaje i wreszcie dostarcza leady, które rzeczywiście do ciebie pasują.',

  'onb.helpCardTitle': 'Nowy w Leadscraper?',
  'onb.helpCardDesc':
    'Nasz przewodnik szybkiego startu w kilka minut przeprowadzi Cię od konta i e-maila do pierwszej grupy docelowej.',
  'onb.helpCardCta': 'Przeczytaj pierwsze kroki',
  'onb.helpCardDismissAria': 'Ukryj wskazówkę',

  'onb.stepLabel': 'Krok {n}',

  'onb.b2cLead': 'Leadscraper znajduje tylko firmy, nie klientów prywatnych.',

  'onb.b2cBody':
    'Analiza twojej strony pokazuje, że sprzedajesz klientom końcowym. Dlatego poniższe sugestie celują w multiplikatorów B2B (np. deweloperów, zarządców nieruchomości) zamiast bezpośrednio w klientów prywatnych. Bez odpowiedniej warstwy B2B Leadscraper prawdopodobnie nie jest właściwym narzędziem dla twojego biznesu.',

  'onb.step2LabelDone': 'Pierwsza grupa docelowa gotowa. Leadscraper ją zapisał',

  'onb.step2LabelPending':
    'Zdefiniuj pierwszą grupę docelową: kogo dokładnie chcesz jako klientów?',

  'onb.step2Cta': 'Utwórz grupę docelową',

  'onb.step2Badge': 'Utwórz teraz',

  'onb.step2Locked': 'Czeka na krok 1',

  'onb.step3Title': 'Pierwsze wyszukiwanie',

  'onb.step3DescFull':
    'Gdy tylko twój pierwszy profil będzie gotowy, uruchamiasz wyszukiwanie bezpośrednio tutaj. Leadscraper znajduje 10 leadów w 30-90 sekund, dokładnie grupę docelową, którą właśnie utworzyłeś.',

  'onb.step3Cta': 'Uruchom wyszukiwanie',

  'onb.step3Badge': 'Uruchom teraz',

  'onb.step3Locked': 'Czeka na krok 2',
  'onb.step1Pending':
    'Opowiedz Leadscraper krótko o sobie, rzut oka na Twoją stronę wystarczy, żeby zrozumiał co sprzedajesz',
  'onb.step2Desc':
    "Opisz swoich idealnych klientów w 1-2 zdaniach, np. 'Biura rachunkowe w województwie mazowieckim, 3-15 pracowników, dyrektorzy zarządzający'. Na tej podstawie Leadscraper zbuduje zapytania wyszukiwania, będzie się uczył z każdej informacji zwrotnej, a profil będzie ostrzejszy z tygodnia na tydzień.",
  'onb.step2Title': 'Utwórz swoją pierwszą grupę docelową',
  'onb.step3Done':
    'Pierwszy suchlauf uruchomiony. Leadscraper dostarczy Ci zaraz pierwsze 10 Leads',
  'onb.step3Pending':
    'Suchlauf dla Twojej grupy docelowej: Leadscraper dostarczy 10 dopasowanych Leads',

  'pd.activeSince': 'Aktywny od {date}',
  'pd.company.analyze': 'Analizuj',
  'pd.company.analyzed': 'Leadscraper przeanalizował twoją firmę (Pewność {n}%).',
  'pd.company.analyzedAt': 'Analizowane {date}',
  'pd.company.analyzing': 'Analizowanie…',
  'pd.company.cached': 'Profil załadowany z cache.',
  'pd.company.cancel': 'Anuluj',
  'pd.company.change': 'Zmień',
  'pd.company.confidence': '{n}% pewności',
  'pd.company.costHint':
    'Koszt ~$0.015 za analizę. Re-analiza automatycznie co 30 dni, jeśli zmieni się Twoja strona.',
  'pd.company.error': 'Analiza nieudana. Spróbuj ponownie.',
  'pd.company.inputDesc1':
    'Leadscraper czyta stronę twojej firmy i zapamiętuje, co sprzedajesz, komu sprzedajesz i jakich argumentów używasz. Przy każdym Leadzie Leadscraper pisze wtedy ',
  'pd.company.inputDesc2': ' zamiast tylko "pasuje do branży".',
  'pd.company.inputDescStrong': 'twoją dostosowaną strategię pitch',
  'pd.company.inputTitle': 'Wprowadź swoją stronę internetową',
  'pd.company.knownTitle': 'Co Leadscraper wie o Twojej firmie',
  'pd.company.placeholder': 'https://moja-firma.pl',
  'pd.company.reanalyze': 'Re-analizuj teraz',
  'pd.company.reanalyzing': 'Re-analiza…',
  'pd.company.sellLabel': 'Co sprzedajesz',
  'pd.company.staleAt': 'Re-analiza wymagana {date}',
  'pd.company.targetLabel': 'Do kogo',
  'pd.company.techDetails': 'Szczegóły techniczne',
  'pd.company.valueLabel': 'Propozycje wartości',
  'pd.cortex.comingSoon': 'wkrótce dostępne',
  'pd.cortex.sub': 'Gdzie Leadscraper jest najbardziej precyzyjny w Twoim targetingu',
  'pd.cortex.title': 'Grupa docelowa Leadscraper',
  'pd.curve.coldSub': 'Cold',
  'pd.curve.currentRate': 'aktualna trafność',
  'pd.curve.highPct':
    'Leadscraper trafia z {n}% bardzo precyzyjnie, krzywa uczenia wykreśli się, gdy pojawią się dane historyczne w czasie. ',
  'pd.curve.highPctStrong': 'Wszystko według planu.',
  'pd.curve.inWeeks': 'w {n} tygodni',
  'pd.curve.learningActive': 'Leadscraper aktywnie się uczy',
  'pd.curve.liftLabel': 'Poprawa od startu',
  'pd.curve.liftSub': 'bezwzględny współczynnik trafności',
  'pd.curve.lockLabel': 'od 50 ocen',
  'pd.curve.lowPct':
    'Leadscraper zbiera z twoich {n} ocen przebieg. Z większą ilością danych linia trendu stanie się ostra.',
  'pd.curve.midPct':
    'Z twoich {n} ocen Leadscraper buduje przebieg, krzywa uczenia będzie bardziej widoczna z każdym kolejnym uruchomieniem.',
  'pd.curve.milestone200': '200 ocen',
  'pd.curve.milestone200Sub': 'model ustabilizowany',
  'pd.curve.milestone50': '50 ocen',
  'pd.curve.milestone50Sub': 'pierwsze wzorce',
  'pd.curve.mockAxisEnd': '50 ocen',
  'pd.curve.mockTitle': 'Trafność w ciągu ostatnich 50 ocen',
  'pd.curve.noData': 'Za mało danych.',
  'pd.curve.start': 'Start',
  'pd.curve.sub': 'Jak współczynnik trafności rozwijał się z każdą oceną.',
  'pd.curve.subShort': 'Jak zmienia się wskaźnik dopasowania z każdą oceną',
  'pd.curve.title': 'Krzywa uczenia',
  'pd.curve.today': 'Dzisiaj',
  'pd.curve.todaySub': '{n} ocen',
  'pd.decisions.checked': 'Sprawdzono {n} kandydatów',
  'pd.decisions.checkedSg': 'Sprawdzono {n} kandydata',
  'pd.decisions.delivered': '{n} dostarczono',
  'pd.decisions.hint':
    'Widzisz błędny wzorzec? Przeformułuj zapytanie. Leadscraper wykorzysta wszystkie te decyzje jako przykłady do nauki przy następnym uruchomieniu, gdy potwierdzisz pamięć grupy docelowej.',
  'pd.decisions.more': '+ {n} więcej…',
  'pd.decisions.rejected': '{n} odrzucono',
  'pd.decisions.showAll': 'Pokaż wszystkich odrzuconych',
  'pd.decisions.showLess': 'Pokaż mniej',
  'pd.decisions.title': 'Decyzje Leadscraper · ostatnie uruchomienie',
  'pd.empty.cta': 'Do panelu',
  'pd.empty.desc1': 'Grupa docelowa to ',
  'pd.empty.desc2':
    ': Leadscraper gromadzi w niej wszystkie wnioski z Twoich ocen. Utwórz pierwszą grupę docelową w panelu, potem znajdziesz tu wszystkie wzorce, założenia, powody odrzuceń i historię uruchomień.',
  'pd.empty.descStrong': 'kontener uczenia',
  'pd.empty.title': 'Nie utworzono jeszcze żadnej grupy docelowej',
  'pd.hex.bizModel': 'Model biznesowy',
  'pd.hex.industry': 'Branża',
  'pd.hex.location': 'Lokalizacja',
  'pd.hex.ownership': 'Własność',
  'pd.hex.role': 'Rola',
  'pd.hex.size': 'Rozmiar',
  'pd.leads.sub': 'Podgląd: pełną listę znajdziesz w zakładce Leads.',
  'pd.leads.title': 'Ostatnie Leads',
  'pd.leads.viewAll': 'Zobacz wszystkie',
  'pd.learn.calibratedHint': 'Leadscraper teraz aktywnie uwzględnia twoje wzorce w rozumowaniu.',
  'pd.learn.coldStartHint': 'Oceń więcej Leads, aby Leadscraper zaczął rozpoznawać twoje wzorce.',
  'pd.learn.earlyHint':
    'Z każdą kolejną oceną rozpoznawanie wzorców staje się bardziej precyzyjne.',
  'pd.learn.emptyDesc1': 'Gdy tylko klikniesz w liście Leads na ',
  'pd.learn.emptyDesc2': ' lub ',
  'pd.learn.emptyDesc3':
    ', Leadscraper uczy się twoich preferencji i pokazuje tutaj, co z tego wyciąga.',
  'pd.learn.emptyFit': 'pasuje',
  'pd.learn.emptyNotFit': 'nie pasuje',
  'pd.learn.emptyTitle': 'Nie podano jeszcze feedbacku',
  'pd.learn.fits': 'Pasuje',
  'pd.learn.lastRating': 'Ostatnia ocena ',
  'pd.learn.loadError': 'Błąd podczas ładowania',
  'pd.learn.loading': 'Ładowanie stanu nauki z feedbacku…',
  'pd.learn.matchRate': 'Trafność',
  'pd.learn.matchRateSub': 'pasuje / oceniono',
  'pd.learn.matureMsg':
    'Profil w pełni skalibrowany. Leadscraper traktuje twoje wzorce niemal jak reguły.',
  'pd.learn.morePrefix': 'Jeszcze ',
  'pd.learn.moreSuffix': ' ocen do poziomu ',
  'pd.learn.narrativeHide': 'Ukryj list do AI',
  'pd.learn.narrativeShow': 'Pokaż list do AI',
  'pd.learn.narrativeSub':
    'Dokładnie ten tekst zostanie przekazany Leadscraper-AI przy następnym uruchomieniu, dosłownie.',
  'pd.learn.negative': 'negatywnie',
  'pd.learn.noData': 'Brak dostępnych danych feedbacku.',
  'pd.learn.noRating': 'Brak oceny',
  'pd.learn.notFits': 'Nie pasuje',
  'pd.learn.positive': 'pozytywnie',
  'pd.learn.rated': 'Oceniono',
  'pd.learn.ratingStatus': 'Status oceny',
  'pd.learn.recentTitle': 'Ostatnie oceny',
  'pd.learn.stageCali': 'Skalibrowany',
  'pd.learn.stageEarly': 'Uczący się',
  'pd.learn.stageMature': 'Dojrzały',
  'pd.learn.stageNext': 'następny poziom',
  'pd.learn.topReasons': 'Najczęstsze powody odrzucenia',
  'pd.learn.topReasonsDesc1': 'Z twoich ',
  'pd.learn.topReasonsDesc2':
    ' odrzuceń, Leadscraper zapamiętuje te wzorce i obniża podobnych kandydatów przy następnym uruchomieniu.',
  'pd.learn.totalSub': '{n} łącznie',
  'pd.openLeads': 'Otwórz Leads',
  'pd.pat.actions': 'Akcje',
  'pd.pat.confirm': 'Potwierdź',
  'pd.pat.confirmT': 'Potwierdź, zastosuj jako regułę',
  'pd.pat.reject': 'Odrzuć',
  'pd.pat.rejectT': 'Odrzuć, usuń wzorzec',
  'pd.pat.remove': 'Usuń',
  'pd.pat.weaken': 'Osłab',
  'pd.patterns.medium': 'Średnie: prawdopodobne, obserwowane',
  'pd.patterns.strong': 'Silne: niezawodne reguły',
  'pd.patterns.sub': 'Twoje preferencje, wyodrębnione z każdej oceny Pasuje / Nie pasuje.',
  'pd.patterns.title': 'Czego nauczył się Leadscraper',
  'pd.patterns.weak': 'Słabe: wczesne sygnały',
  'pd.queries.dailyLegacy': 'Codziennie (legacy)',
  'pd.queries.daysAgo': 'rozpoczęto {n} dni temu',
  'pd.queries.emptySub': 'Gdy rozpoczniesz wyszukiwanie, pojawi się tutaj, wraz z harmonogramem.',
  'pd.queries.emptyTitle': 'Nie uruchomiono jeszcze wyszukiwania dla tej grupy docelowej.',
  'pd.queries.everyH': 'Co {n} godz.',
  'pd.queries.filterEmpty': 'Brak zapytań w tym filtrze.',
  'pd.queries.hourly': 'Co godzinę',
  'pd.queries.inDays': 'za {n} dni',
  'pd.queries.inHours': 'za {n} godz.',
  'pd.queries.inMinutes': 'za {n} min.',
  'pd.queries.leadsDelivered': 'Dostarczono {n} Leads',
  'pd.queries.manual': 'Jednorazowo',
  'pd.queries.monthlyLegacy': 'Co miesiąc (legacy)',
  'pd.queries.newSearch': 'Rozpocznij nowe wyszukiwanie',
  'pd.queries.overdue': 'przeterminowane',
  'pd.queries.paused': 'wstrzymane',
  'pd.queries.showAll': 'Pokaż wszystkie',
  'pd.queries.sub': 'Kliknij, aby otworzyć szczegóły, harmonogram i historię wyszukiwania.',
  'pd.queries.title': 'Zapytania wyszukiwania tej grupy docelowej',
  'pd.queries.tomorrow': 'jutro',
  'pd.queries.unnamed': 'Wyszukiwanie bez nazwy',
  'pd.queries.weeklyLegacy': 'Co tydzień (legacy)',
  'pd.ratings': '{n} ocen',
  'pd.rej.agency_not_operator': 'Agencja zamiast operatora',
  'pd.rej.consultant_not_operator': 'Konsultant zamiast operatora',
  'pd.rej.duplicate_previous_session': 'Już dostarczono',
  'pd.rej.insufficient_data': 'Za mało danych',
  'pd.rej.learned_rejection_pattern': 'Pasuje do Twojego wzorca odrzuceń',
  'pd.rej.low_confidence': 'Zbyt niepewny',
  'pd.rej.outside_radius': 'Poza promieniem',
  'pd.rej.wrong_company_form': 'Zła forma prawna',
  'pd.rej.wrong_industry': 'Zła branża',
  'pd.rej.wrong_region': 'Zły region',
  'pd.rej.wrong_role': 'Zła rola',
  'pd.rej.wrong_size': 'Zły rozmiar',
  'pd.runs': '{n} przebiegów wyszukiwania',
  'pd.screenLabel': 'Szczegóły grupy docelowej',
  'pd.side.accepted': '({n} pasujących)',
  'pd.side.feedbacks': 'Oceny',
  'pd.side.firstRun': 'Pierwsze uruchomienie',
  'pd.side.focus': 'Fokus wyszukiwania',
  'pd.side.lastRun': 'Ostatnie uruchomienie',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.leadsTotal': 'Leads łącznie',
  'pd.side.matchMiss': 'Pasuje / Nie pasuje',
  'pd.side.matchRate': 'Współczynnik trafności',
  'pd.side.next1.d': 'Przy {pct}% współczynniku trafności warto pozyskać 50–100 nowych Leads.',
  'pd.side.next1.t': 'Rozpocznij przebieg wyszukiwania',
  'pd.side.next2.d': 'Dzięki temu Leadscraper uczy się szybciej.',
  'pd.side.next2.t': 'Sprawdź niepotwierdzone wzorce',
  'pd.side.next3.d': 'Im więcej ocen, tym większa precyzja.',
  'pd.side.next3.t': 'Kontynuuj przekazywanie opinii',
  'pd.side.patterns': 'Wzorce',
  'pd.side.patternsSub': '{strong} silne · {medium} średnie',
  'pd.side.reasons': 'Częste powody odrzucenia',
  'pd.side.recommended': 'Zalecane',
  'pd.side.snapshot': 'Na pierwszy rzut oka',
  'pd.target.contacts': 'Kontakty',
  'pd.target.excluded': 'Wykluczone',
  'pd.target.industry': 'Branża',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Wzorce',
  'pd.target.queries': 'Zapytania',
  'pd.target.region': 'Region',
  'pd.target.size': 'Rozmiar',
  'pd.target.sub': 'To, co Leadscraper bierze pod uwagę przy każdym wyszukiwaniu.',
  'pd.target.title': 'Grupa docelowa',
  'pd.time.daysAgo': '{n} dni temu',
  'pd.time.hoursAgo': '{n} godz. temu',
  'pd.time.justNow': 'właśnie teraz',
  'pd.time.minsAgo': '{n} min temu',
  'pd.toast.confirmed': 'Wzorzec potwierdzony. Będzie teraz stosowany jako niezawodna reguła',
  'pd.toast.rejected': 'Wzorzec odrzucony',
  'pd.toast.removed': 'Wzorzec usunięty',
  'pd.toast.weakened': 'Wzorzec osłabiony. Będzie ponownie obserwowany',

  'price.afterThen': 'Potem {price} / miesiąc · anulowanie w każdej chwili',
  'price.badge.popular': 'Popularne',
  'price.badge.recommended': 'Polecane',
  'price.badge.yourPlan': 'Twój plan',
  'price.ctaStartTrial': 'Rozpocznij 3 dni za darmo',
  'price.ctaSwitchPlan': 'Zmień subskrypcję',
  'price.ctaCurrentPlan': 'Obecny plan',
  'price.ctaTopUp': 'Doładuj teraz',
  'price.heroSub': 'Więcej Leads, dokładnie wtedy, gdy ich potrzebujesz.',
  'price.heroTrial': 'Twoja nieuczciwa przewaga konkurencyjna zaczyna się tutaj.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'miesięczne anulowanie',
  'price.oneTime': 'jednorazowo',
  'price.pack.1000.tag': 'Idealny na początek',
  'price.pack.10000.tag': 'Do ciągłej generacji leadów',
  'price.pack.5000.tag': 'Do pierwszych kampanii na skalę',
  'price.pack.50000.tag': 'Do dużych wolumenów i zespołów',
  'price.perLead': '€ / Lead',
  'price.perMonth': '/miesiąc',
  'price.perMonthLong': '/ miesiąc',
  'price.plan.basic.f1': '100 wykwalifikowanych Leads miesięcznie',
  'price.plan.basic.f2': '1 aktywna grupa docelowa',
  'price.plan.basic.f3': 'Leadscraper-AI z ciągłym uczeniem się',
  'price.plan.basic.f4': 'Integracje CRM (HubSpot, Pipedrive, Salesforce …)',
  'price.plan.basic.f5': 'Wsparcie e-mailowe',
  'price.plan.basic.tag': 'Na start z jedną grupą docelową',
  'price.plan.growth.f1': '500 wykwalifikowanych Leads miesięcznie',
  'price.plan.growth.f2': 'Nieograniczone grupy docelowe',
  'price.plan.growth.f3': 'Leadscraper-AI z zespołowym Memory',
  'price.plan.growth.f4': 'Wszystkie integracje CRM + webhooks',
  'price.plan.growth.f5': 'Dedykowany menedżer konta',
  'price.plan.growth.f6': 'Dostęp do API',
  'price.plan.growth.tag': 'Dla rozwijających się zespołów sprzedażowych',
  'price.plan.starter.f1': '250 wykwalifikowanych Leads miesięcznie',
  'price.plan.starter.f2': '3 aktywne grupy docelowe',
  'price.plan.starter.f3': 'Leadscraper-AI z priorytetowym uczeniem się',
  'price.plan.starter.f4': 'Wszystkie integracje CRM',
  'price.plan.starter.f5': 'Wsparcie priorytetowe',
  'price.plan.starter.f6': 'Eksport do CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Idealne na początek',
  'price.selected': 'Wybrane:',
  'price.subOneoffDesc':
    'Dodatkowe Leads jako pakiet jednorazowy, bez zobowiązań, bez umowy. Credits nie wygasają.',
  'price.subTrialDesc':
    '3 dni bezpłatnego testu, z prawdziwymi Leads, własnymi profilami, własnym Leadscraper-Memory. Bezużyteczne Leads? Dostajesz zwrot bez pytań.',
  'price.tab.afterSub': '(po subskrypcji)',
  'price.tab.lockNote': 'Dostępne po rozpoczęciu subskrypcji',
  'price.tab.oneoff': 'Pakiety jednorazowe',
  'price.tab.sub': 'Subskrypcje',
  'price.testLeads': 'Leads testowe',
  'price.then': 'potem',
  'price.trial3days': '3 dni za darmo',
  'price.trialIncl': 'w tym',
  'price.trust.cancel.s': 'Miesięczne anulowanie, bez ukrytych opłat, bez minimalnego okresu.',
  'price.trust.cancel.t': 'Anulowanie w każdej chwili',
  'price.trust.gdpr.s':
    'Wszystkie dane hostowane w UE, szyfrowane, bez udostępniania stronom trzecim.',
  'price.trust.gdpr.t': 'Zgodność z RODO',
  'price.trust.refund.s': 'Jeśli Lead nie pasuje, natychmiast odzyskujesz Credit.',
  'price.trust.refund.t': 'Bezużyteczne Leads? Zwrot.',

  'pricing.beta.headline': 'Twój dostęp Beta do Leadscraper',
  'pricing.beta.subText':
    'Plan Growth z 55% rabatem na pierwszy miesiąc, ekskluzywnie dla testerów Beta.',
  'pricing.mai.headline': 'Twoja nieuczciwa przewaga konkurencyjna zaczyna się tutaj.',
  'pricing.mai.subText':
    'W pierwszym miesiącu oszczędzasz 74%, potem zmień lub anuluj jednym kliknięciem w każdym momencie.',
  'pricing.trial50.headline': '50 B2B Leads o wartości 100 €, teraz za darmo.',
  'pricing.trial50.subText': '50 Leads za darmo, testuj 3 dni, anuluj w każdej chwili.',

  'reject.alreadyKnown': 'Już znamy',
  'reject.alreadyKnown.hint':
    'Już w Twoim CRM lub wcześniej kontaktowany, bez sygnału uczenia i nie wpływa na wskaźnik trafień.',
  'reject.badData': 'Błędne dane',
  'reject.badData.hint': 'Adres, nazwa lub informacje kontaktowe są nieprawidłowe',
  'reject.noBuyingSignal': 'Brak rozpoznawalnego zapotrzebowania',
  'reject.noBuyingSignal.hint': 'Brak wydarzeń wyzwalających, otwartych stanowisk, sygnału wzrostu',
  'reject.notOperator': 'Nie operator',
  'reject.notOperator.hint': 'Agencja, pośrednik lub deweloper zamiast operacyjnego dostawcy',
  'reject.other': 'Inny powód',
  'reject.other.hint': 'Napisz krótko dlaczego poniżej (tekst dowolny)',
  'reject.wrongIndustry': 'Zła branża',
  'reject.wrongIndustry.hint': 'Leadscraper błędnie rozpoznał obszar działalności',
  'reject.wrongOwnership': 'Zła struktura własnościowa',
  'reject.wrongOwnership.hint':
    'Spółka zależna koncernu zamiast firmy rodzinnej, zła forma prawna itp.',
  'reject.wrongRegion': 'Zła lokalizacja',
  'reject.wrongRegion.hint': 'Siedziba / województwo nie pasuje do wyszukiwania',
  'reject.wrongRole': 'Zła osoba kontaktowa',
  'reject.wrongRole.hint': 'Osoba lub rola to nie decydent',
  'reject.wrongSize': 'Zły rozmiar firmy',
  'reject.wrongSize.hint': 'Za mała, za duża lub korporacja zamiast średniego biznesu',

  'rel.daysAgo': '{n} dni temu',
  'rel.hAgo': '{n} godz. temu',
  'rel.minAgo': '{n} min temu',
  'rel.now': 'teraz',
  'rel.weeksAgo': '{n} tyg. temu',
  'rel.yesterday': 'wczoraj',

  'repeat.amountHint': 'Więcej Leads = szerszy zasięg, mniej Leads = wyższa jakość na Lead.',
  'repeat.amountLabel': 'Ile Leads chcesz otrzymać?',
  'repeat.cancel': 'Anuluj',
  'repeat.paramsLabel': 'Parametry tego uruchomienia',
  'repeat.prediction.basedOn': 'na podstawie twojej aktualnej trafności',
  'repeat.prediction.credits': 'Credits',
  'repeat.prediction.matches': 'oczekiwane trafienia',
  'repeat.prediction.time': 'szacowany czas',
  'repeat.prediction.title': 'Oczekiwany wynik',
  'repeat.preset': 'Sugestie',
  'repeat.start': 'Uruchom wyszukiwanie',
  'repeat.sub': 'Parametry są wstępnie wypełnione, dostosuj je lub uruchom bezpośrednio.',
  'repeat.title': 'Powtórz wyszukiwanie',
  'repeat.toast': 'Wyszukiwanie uruchomione, wyniki za kilka minut.',

  'res.acceptedNote': 'Leadscraper uczy się z tej akceptacji.',
  'res.breadcrumb': 'Wyniki wyszukiwania · {profile}',
  'res.cancel': 'Anuluj',
  'res.density.comfortable': 'Komfortowy',
  'res.density.compact': 'Kompaktowy',
  'res.employees': 'Pracownicy',
  'res.fb.all': 'Wszystkie',
  'res.fb.new': 'Nowe dla ciebie',
  'res.fb.status': 'Status opinii',
  'res.filter': 'Filtr',
  'res.fit': 'Pasuje',
  'res.footer':
    'Leadscraper przeanalizował kolejne 406 wpisów. Pokazane tu {count} to te, które najlepiej pasują do twojej dotychczasowej opinii.',
  'res.fromMem': 'z twojej pamięci: „{text}"',
  'res.learning.body':
    'Nowy sygnał z ostatnich dwóch tygodni: akceptujesz częściej firmy z własną technologią druku lub tłoczenia niż czyste firmy konfekcionujące.',
  'res.learning.title': 'Czego obecnie uczy się Leadscraper',
  'res.location': 'Lokalizacja',
  'res.new': 'Nowy',
  'res.notFit': 'Nie pasuje',
  'res.openDetails': 'Otwórz szczegóły →',
  'res.pickReason': 'Wybierz powód →',
  'res.reasonHint': 'Wystarczy jedno kliknięcie, twój powód wpływa na to, co zobaczysz jutro.',
  'res.rejectedNote': 'Powód zapisany. To wzmacnia twoją pamięć.',
  'res.sector': 'Branża',
  'res.summary':
    '{count} Leads z 412 przejrzanych. Każdy zawiera zdanie, dlaczego do ciebie pasuje, twoje „Pasuje / Nie pasuje" kształtuje to, co zobaczysz jutro.',
  'res.title': 'Leads: {profile}',
  'res.toast.accepted':
    '„{company}" zapisano jako Pasuje. Leadscraper doostrza Twoją grupę docelową.',
  'res.toast.rejected': 'Powód „{reason}" zapisany. Podobne leads będą rzadsze.',
  'res.uncertainty': 'Leadscraper jest tutaj {score}: {text}.',
  'res.whyNotTitle': 'Dlaczego ten lead nie pasuje?',

  'run.complete': 'Suchlauf ukończony: {count} Leads dostarczonych.',
  'run.completeEmpty':
    'Suchlauf ukończony. Nie znaleziono pasujących firm. Sprecyzuj swoją grupę docelową lub spróbuj inny region.',
  'run.cta.broaden_query': 'Sformułuj zapytanie szerzej',
  'run.cta.edit_query': 'Dostosuj zapytanie',
  'run.cta.retry': 'Spróbuj ponownie',
  'run.failed.body':
    'Usterka techniczna podczas ostatniego suchlafu. Poczekaj 1-2 minuty i spróbuj ponownie. Jeśli znów się zawiesi, daj nam znać.',
  'run.failed.title': 'Leadscraper się zawiesił',
  'run.no_leads_delivered': 'Nie dostarczono pasujących Leads',
  'run.no_results.body':
    'Twoje słowa kluczowe nie zwracają na Google pasujących polskich firm B2B. Spróbuj bardziej powszechnych określeń, np. "stolarnia" zamiast "manufaktura mebli", lub rozszerz region.',
  'run.no_results.title': 'Nie znaleziono trafień w sieci dla Twojego zapytania',
  'run.partial_yield.body':
    'Leadscraper znalazł mniej niż 10 trafień. Aby zwiększyć liczbę: sformułuj opis szerzej lub rozszerz region.',
  'run.partial_yield.title': '{delivered}/{total} Leads dostarczonych',
  'run.searching': '🧠 Leadscraper szuka dla Ciebie…',
  'run.too_strict.body':
    'Leadscraper znalazł firmy, ale żadna z nich nie pasuje dobrze do Twojej grupy docelowej. Może Twój opis jest za wąski, weź np. większy region, rozluźnij liczbę pracowników lub pomiń szczegóły.',
  'run.too_strict.title':
    'Oceniono {reasoned} kandydatów, żaden nie pasował do Twojej grupy docelowej',

  'runs.delivered': '{n} Leads dostarczonych',
  'runs.deliveredOne': '1 Lead dostarczony',
  'runs.empty': 'Brak uruchomień dla tego wyszukiwania.',
  'runs.evaluated': '{n} ocenionych',
  'runs.failed': 'nieudane',
  'runs.harvested.body':
    'Poprzednie wyszukiwania już dostarczyły {n} pasujących firm. Leadscraper zna już te znalezione trafienia. Nowe trafienia powstają, gdy nowe firmy z Twojej grupy docelowej stają się widoczne online. Harmonogram automatycznie je wyłapie.',
  'runs.harvested.title': 'Grupa docelowa na razie wyczerpana',
  'runs.last': 'ostatni',
  'runs.loadError': 'Błąd podczas ładowania',
  'runs.loadFailed': 'Nie można załadować historii: {err}',
  'runs.loading': 'Ładowanie historii…',
  'runs.noHits': 'brak trafień',
  'runs.running': 'działa teraz',
  'runs.unfeasible': 'nierealizowalne',

  'sched.autoPush': 'Automatycznie wysyłaj nowe Leads do CRM',
  'sched.autoPushNoCRM':
    'Musisz najpierw połączyć CRM w ustawieniach konta, aby korzystać z automatycznego wysyłania.',
  'sched.autoPushSub':
    'Po zakończeniu zaplanowanego uruchomienia przez Leadscraper, wszystkie znalezione Leads zostaną automatycznie wysłane do połączonego CRM.',
  'sched.daily': 'Codziennie',
  'sched.dailySub': 'Codziennie o tej samej porze',
  'sched.day.fri': 'Piątek',
  'sched.day.fri.short': 'Pt',
  'sched.day.mon': 'Poniedziałek',
  'sched.day.mon.short': 'Pon',
  'sched.day.sat': 'Sobota',
  'sched.day.sat.short': 'Sob',
  'sched.day.sun': 'Niedziela',
  'sched.day.sun.short': 'Nie',
  'sched.day.thu': 'Czwartek',
  'sched.day.thu.short': 'Czw',
  'sched.day.tue': 'Wtorek',
  'sched.day.tue.short': 'Wt',
  'sched.day.wed': 'Środa',
  'sched.day.wed.short': 'Śr',
  'sched.dayOfMonth': 'Dzień miesiąca',
  'sched.monthly': 'Co miesiąc',
  'sched.monthlySub': 'Co miesiąc w wybranym dniu',
  'sched.nextRun': 'Następne uruchomienie',
  'sched.once': 'Jednorazowo',
  'sched.onceSub': 'Wykonaj teraz jeden raz',
  'sched.rel.inDays': 'za {n} dni',
  'sched.rel.overdue': 'przeterminowane',
  'sched.rel.soon': 'wkrótce',
  'sched.rel.tomorrow': 'jutro',
  'sched.section': 'Powtarzanie',
  'sched.sectionSub': 'Pozwól Leadscraper automatycznie wykonywać to wyszukiwanie regularnie.',
  'sched.time': 'Czas startu',
  'sched.toast.created': 'Zaplanowane wyszukiwanie utworzone. Będzie działać automatycznie.',
  'sched.toast.deleted': 'Zaplanowany przebieg usunięty.',
  'sched.toast.paused': 'Zaplanowane uruchomienie wstrzymane.',
  'sched.toast.resumed': 'Zaplanowany przebieg reaktywowany.',
  'sched.weekday': 'Dzień tygodnia',
  'sched.weekly': 'Co tydzień',
  'sched.weeklySub': 'Co tydzień w wybranym dniu',

  'schedCard.creditsHint':
    'maks. {n} Credits / dzień, gdy tylko nie będą już znajdowane nowe Leads w twojej grupie docelowej, Leadscraper będzie działać bez zużycia na jałowo.',
  'schedCard.errorToast': 'Zapisywanie nieudane: {err}',
  'schedCard.freq.every': 'Co {n} godzin',
  'schedCard.freq.everyShort': 'co {n} h',
  'schedCard.freq.hourly': 'Co godzinę',
  'schedCard.freq.everyMinute': 'Co minutę (test)',
  'schedCard.minuteTestHint':
    'Tryb testowy: uruchamia się ~co minutę, gdy działa tick harmonogramu. Tylko staging.',
  'schedCard.freq.hourlyShort': 'co godzinę',
  'schedCard.leadsPerDay': '~{n} Leads / dzień',
  'schedCard.nextLabel': 'następne uruchomienie {when}',
  'schedCard.nextRun.days': 'za {n} dni',
  'schedCard.nextRun.hours': 'za {n} h',
  'schedCard.nextRun.min': 'za {n} min',
  'schedCard.nextRun.overdue': 'zaległe',
  'schedCard.nextRun.tomorrow': 'jutro',
  'schedCard.noRepeat': 'Bez powtarzania',
  'schedCard.offBody': 'Jednorazowo, sam uruchamiasz, kiedy chcesz.',
  'schedCard.onBody': 'Działa w tle. Nowe trafienia automatycznie trafiają do twojej listy Leads.',
  'schedCard.perWeek': '≈ {n} / tydzień',
  'schedCard.repeat': 'Powtórz to wyszukiwanie',
  'schedCard.save': 'Zapisz',
  'schedCard.savedToast': 'Harmonogram zapisany.',
  'schedCard.saving': 'Zapisywanie…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'Przesył CRM',
  'schedRuns.col.frequency': 'Częstotliwość',
  'schedRuns.col.leads': 'Leads/przebieg',
  'schedRuns.col.nextRun': 'Następny przebieg',
  'schedRuns.col.params': 'Parametry',
  'schedRuns.count': 'aktywny',
  'schedRuns.crm.no': 'Wyłączony',
  'schedRuns.crm.yes': 'Aktywny',
  'schedRuns.delete': 'Usuń',
  'schedRuns.empty.sub':
    'Aktywuj "Powtarzanie" podczas następnego wyszukiwania, aby regularnie otrzymywać nowe Leads.',
  'schedRuns.empty.title': 'Brak zaplanowanych przebiegów',
  'schedRuns.freq.daily': 'Codziennie · {time}',
  'schedRuns.freq.monthly': '{day}. dnia miesiąca · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Wstrzymaj',
  'schedRuns.resume': 'Wznów',
  'schedRuns.status.paused': 'Wstrzymany',
  'schedRuns.sub':
    'Cykliczne uruchomienia, które automatycznie dodają nowe leady do tej grupy docelowej.',
  'schedRuns.title': 'Zaplanowane wyszukiwania',

  'so.close.btn': 'Pozwól działać w tle',
  'so.close.hint': 'Możesz kontynuować pracę, Leadscraper da znać, gdy nowe leady będą gotowe.',
  'so.funnel.analyzed': 'Dogłębnie przeanalizowane',
  'so.close.trust': 'Tylko publiczne źródła · każda informacja jest udokumentowana w Leadzie.',
  'so.funnel.evaluated': 'Ocenione',
  'so.funnel.identified': 'Zidentyfikowane',
  'so.funnel.ready': 'Gotowe',
  'so.hero.elapsed': 'Czas od rozpoczęcia:',
  'so.hero.inFocus': 'Firmy w centrum uwagi',
  'so.hero.preparing': 'Leadscraper sprawdza Twoje zapytanie',
  'so.hero.reflecting': 'Leadscraper obmyśla nowy plan',
  'so.hero.round': '(Runda {n})',
  'so.hero.searching': 'Leadscraper wyszukuje dla Ciebie',
  'so.live.title': 'Leadscraper pracuje na żywo',
  'so.query.title': 'Twoje zapytanie wyszukiwania',
  'so.reflector.title': 'Leadscraper odrzucił pierwsze podejście',
  'so.step.delivery.sub': 'Najlepsze dopasowania są sortowane i dostarczane dla Ciebie',
  'so.step.delivery.title': 'Zestawianie leadów',
  'so.step.discovery.sub': 'Najlepsi kandydaci z niemieckich źródeł internetowych',
  'so.step.discovery.title': 'Identyfikacja firm',
  'so.step.done.sub': 'Wyszukiwanie zakończone',
  'so.step.done.title': 'Gotowe',
  'so.step.enriching.sub': 'Plan akwizycji, oceny + szczegółowe badania 10 Leads',
  'so.step.enriching.title': 'Cortex wzbogaca jeszcze',
  'so.step.enriching.title.light': 'Weryfikacja danych podstawowych',
  'so.step.hydration.sub': 'Strony internetowe + stopka + kariera + zespół + aktualności',
  'so.step.hydration.title': 'Dogłębna analiza firm',
  'so.step.planning.sub': 'Analiza Twoich wniosków + planowanie strategii wyszukiwania',
  'so.step.planning.title': 'Leadscraper pamięta',
  'so.step.reasoning.sub': 'Leadscraper ocenia każdego kandydata względem Twojej grupy docelowej',
  'so.step.reasoning.title': 'Leadscraper ocenia',

  'src.derived': 'Od Leadscraper',
  'src.directory': 'Katalog',
  'src.news': 'Prasa branżowa',
  'src.official': 'Urzędowy',
  'src.web': 'Strona firmy',

  'trial.afterNote':
    'Po tym okresie automatycznie aktywuje się Twoja subskrypcja {plan}, możesz anulować w każdej chwili.',
  'trial.day1': 'Jeszcze 1 dzień',
  'trial.daysN': 'Jeszcze {n} dni',
  'trial.freeTest': 'przetestuj za darmo.',
  'trial.leadsLeft': '{left} / {total} testowych leadów pozostało',
  'trial.phase': 'Faza testowa',
  'trial.secureSub': 'Zabezpiecz subskrypcję',
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Przetwarzanie płatności',
  'bill.sepaProcessing.title':
    'Twoja płatność SEPA jest przetwarzana. Dostęp jest już odblokowany.',
  'bill.sepaProcessing.note':
    'Obciążenie może potrwać 2–5 dni roboczych. Możesz już teraz w pełni korzystać z Leadscraper.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: machine-translated from de.ts/en.ts. Informal capitalised "Ty"
  // register to match existing app strings. Native-speaker review pending
  // before production rollout (see staging-verification runbook).
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Założyciel, Leadscraper',
  'email.shared.reply_note': 'Pytania? Po prostu odpowiedz na tę wiadomość.',
  'email.sepa-payment-failed.subject': 'Twoja płatność SEPA nie powiodła się',
  'email.sepa-payment-failed.preheader':
    'Polecenie zapłaty na {{amount_formatted}} zostało odrzucone.',
  'email.sepa-payment-failed.badge': 'Płatność nieudana',
  'email.sepa-payment-failed.hero': 'Twoje polecenie zapłaty<br>zostało odrzucone.',
  'email.sepa-payment-failed.greeting': 'Cześć {{first_name}},',
  'email.sepa-payment-failed.intro':
    'polecenie zapłaty SEPA za Twój pakiet kredytów nie zostało zrealizowane przez bank.',
  'email.sepa-payment-failed.credits_line':
    'Dlatego odjęliśmy {{credits_revoked}} kredytów z Twojego konta.',
  'email.sepa-payment-failed.retry_line':
    'Jeśli potrzebujesz kredytów, możesz po prostu ponownie kupić pakiet na swoim koncie.',
  'email.sepa-payment-failed.button': 'Otwórz Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Pakiet',
  'email.sepa-payment-failed.detail.amount_label': 'Kwota',
  'email.shared.footer.transactional':
    'Otrzymujesz tę wiadomość, ponieważ zarejestrowałeś się na konto Leadscraper. Ta wiadomość transakcyjna jest częścią stosunku umownego i nie można jej anulować.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hamburg &middot; Niemcy<br />Dyrektor Zarządzający: Janik Deimann &middot; HRB 164162 (AG Hamburg) &middot; NIP DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome ───────────────────────────────────────
  'email.welcome.subject': 'Witaj w Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Witaj w Leadscraper',
  'email.welcome.preheader': 'Witaj na pokładzie, Twoje pierwsze leady w 5 minut.',
  'email.welcome.badge': 'Konto gotowe',
  'email.welcome.hero': 'Cieszę się, że tu jesteś,<br>{{first_name}}.',
  'email.welcome.subhead':
    'Twoje konto jest skonfigurowane, a pierwsze kredyty czekają, zaczynamy!',
  'email.welcome.steps.title': 'Zacznij w 5 krokach',
  'email.welcome.steps.1.title': 'Dodaj swoją stronę internetową',
  'email.welcome.steps.1.body':
    'Żeby agent rozumiał, dokąd zmierza Twój biznes, i na co zwracać uwagę.',
  'email.welcome.steps.2.title': 'Określ swoją grupę docelową',
  'email.welcome.steps.2.body':
    'Branża, region, wielkość firmy, stanowisko, im precyzyjniej, tym lepsze trafienia.',
  'email.welcome.steps.3.title': 'Uruchom pierwsze wyszukiwanie leadów',
  'email.welcome.steps.3.body':
    'Agent bada, wzbogaca i dostarcza pierwsze firmy bezpośrednio do Twojego dashboardu.',
  'email.welcome.steps.4.title': 'Oceń leady',
  'email.welcome.steps.4.body':
    'Kciuk w górę lub w dół, agent uczy się z każdej oceny, co do Ciebie pasuje.',
  'email.welcome.steps.5.title': 'Uruchom kolejne wyszukiwanie',
  'email.welcome.steps.5.body':
    'Z każdym uruchomieniem wyniki stają się zauważalnie ostrzejsze, aż do 100 % dopasowania.',
  'email.welcome.cta.primary': 'Do dashboardu',
  'email.welcome.signoff.line': 'Pytania? Po prostu odpowiedz na tę wiadomość, czytam.',

  // ─── Transactional email — subscription-cancelled ────────────────────────
  'email.subscription-cancelled.subject':
    'Szkoda, że odchodzisz, {{first_name}}: anulowanie potwierdzone',
  'email.subscription-cancelled.title': 'Twoja subskrypcja została anulowana',
  'email.subscription-cancelled.preheader': 'Otrzymaliśmy Twoje anulowanie.',
  'email.subscription-cancelled.badge': 'Anulowanie potwierdzone',
  'email.subscription-cancelled.hero': 'Szkoda, że odchodzisz,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    'Otrzymaliśmy Twoje anulowanie. Twój dostęp do planu {{plan_name}} pozostaje aktywny do {{access_until}}.',
  'email.subscription-cancelled.subhead_trial':
    'Otrzymaliśmy Twoje anulowanie. Okres próbny został zakończony i nic nie zostanie pobrane.',
  'email.subscription-cancelled.note_trial':
    'Jeśli później zechcesz kontynuować, możesz ponownie aktywować subskrypcję na swoim koncie.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': 'Dostęp do',
  'email.subscription-cancelled.note':
    'Do tego czasu zachowujesz pełny dostęp. Później Twoje dane zostaną usunięte zgodnie z naszą polityką prywatności.',
  'email.subscription-cancelled.signoff.line':
    'Co mogliśmy zrobić lepiej? Po prostu odpowiedz na tę wiadomość, czytam.',
  'email.subscription-cancelled.cta.primary': 'Wróć do produktu &amp; reaktywuj',
  'email.subscription-cancelled.cta.note':
    'Wylądujesz bezpośrednio w dashboardzie, gdzie możesz reaktywować swoją subskrypcję.',
  'email.subscription-cancelled.footer.transactional':
    'Otrzymujesz tę wiadomość jako potwierdzenie anulowania. Ta wiadomość transakcyjna jest częścią stosunku umownego i nie można jej anulować.',

  // ─── Transactional email — payment-failed / dunning (LEA-304, AI-translated from DE master) ─────
  'email.payment-failed.subject': 'Twoja płatność nie powiodła się, zaktualizuj dane',
  'email.payment-failed.title': 'Płatność nieudana, zaktualizuj dane',
  'email.payment-failed.preheader':
    'Nie udało nam się pobrać {{amount_formatted}} za Twój plan {{plan_name}}. Zaktualizuj swoje dane płatności.',
  'email.payment-failed.badge': 'Płatność nieudana',
  'email.payment-failed.hero': 'Twoja płatność nie przeszła, {{first_name}}.',
  'email.payment-failed.subhead':
    'Nie udało nam się pobrać <strong style="color:#0B0F19;">{{amount_formatted}}</strong> za Twój plan {{plan_name}}. Zaktualizuj swoje dane płatności, aby uniknąć przerwy w dostarczaniu Leadów.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Kwota do zapłaty',
  'email.payment-failed.summary.attempt_label': 'Próba',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} z 3',
  'email.payment-failed.summary.next_label': 'Następna próba',
  'email.payment-failed.cta.primary': 'Zaktualizuj dane płatności',
  'email.payment-failed.reassurance':
    'To zajmie mniej niż minutę, potem wszystko działa jak zwykle. Masz pytania? Po prostu odpowiedz na tę wiadomość.',
  'email.payment-failed.footer.transactional':
    'Otrzymujesz tę wiadomość, ponieważ płatność za Twoją subskrypcję Leadscraper nie powiodła się. Ta wiadomość transakcyjna jest częścią stosunku umownego i nie można jej anulować.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'Jeśli chodziło tylko o strach przed obciążeniem …',
  'email.trial-winback.badge': 'Twoje konto wciąż czeka',
  'email.trial-winback.hero': '30% rabatu, jeśli<br>chcesz kontynuować.',
  'email.trial-winback.preheader':
    'Wróć — 30% zniżki przez 3 miesiące, Twoje konto wciąż istnieje.',
  'email.trial-winback.greeting': 'Cześć {{first_name}},',
  'email.trial-winback.intro':
    'wczoraj od razu zakończyłeś swój okres próbny — w porządku, po to jest ten przycisk. Ale jeśli chodziło tylko o uniknięcie niechcianego obciążenia: Twoje konto wciąż istnieje, ze wszystkim, co skonfigurowałeś.',
  'email.trial-winback.offer':
    'Jeśli chcesz kontynuować: {{plan_name}} z 30% zniżką przez 3 miesiące. Bez nowych formularzy — Twoja karta jest już zapisana.',
  'email.trial-winback.button': 'Zobacz ofertę i reaktywuj',
  'email.trial-winback.transparency':
    'Kliknięcie niczego nie pobiera — najpierw widzisz cenę i datę obciążenia, potem sam potwierdzasz. Link: {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    'Nie chcesz kontynuować? Zrezygnuj jednym kliknięciem, przed pierwszym obciążeniem: {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': 'Zrezygnuj z okresu próbnego',
  'email.trial-ending-soon.subject': 'Twój okres próbny wkrótce się kończy',
  'email.trial-ending-soon.preheader':
    'Okres próbny kończy się {{trial_ends_at}}, wybierz plan już teraz.',
  'email.trial-ending-soon.greeting': 'Cześć {{first_name}},',
  'email.trial-ending-soon.intro':
    'Twój okres próbny {{plan_name}} kończy się {{trial_ends_at}}. Pozostało Ci {{credits_remaining}} Credits.',
  'email.trial-ending-soon.why':
    'Gdy okres próbny się zakończy, Twoje konto przejdzie w tryb tylko do odczytu, nadal zobaczysz dotychczasowe Leady, ale nie uruchomisz nowych wyszukiwań.',
  'email.trial-ending-soon.cta':
    'Jeśli wyniki Ci odpowiadają: wybierz plan już teraz, aby wszystko działało bez przerw.',
  'email.trial-ending-soon.button': 'Wybierz plan',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Twój okres próbny się zakończył',
  'email.trial-ended.badge': 'Okres próbny zakończony',
  'email.trial-ended.hero': 'Okres próbny<br>dobiegł końca.',
  'email.trial-ended.preheader': 'Twój okres próbny się zakończył, konto tylko do odczytu.',
  'email.trial-ended.greeting': 'Cześć {{first_name}},',
  'email.trial-ended.intro':
    'Twój okres próbny {{plan_name}} właśnie się zakończył. Twoje konto jest teraz tylko do odczytu, nadal widzisz wszystkie dotychczasowe leady, ale nowe wyszukiwania są wstrzymane.',
  'email.trial-ended.cta':
    'Wybierz plan, aby kontynuować od razu. Twoje dane i pamięć uczenia pozostają nienaruszone.',
  'email.trial-ended.button': 'Wybierz plan',
  'email.trial-ended.signoff': 'Do zobaczenia.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Potwierdź swój adres e-mail',
  'email.verify-email.badge': 'Prawie gotowe',
  'email.verify-email.hero': 'Potwierdź swój<br>adres e-mail.',
  'email.verify-email.preheader': 'Potwierdź swój e-mail, aby aktywować Leadscraper.',
  'email.verify-email.greeting': 'Cześć {{first_name}},',
  'email.verify-email.body':
    'kliknij przycisk poniżej, aby potwierdzić swój e-mail i aktywować konto Leadscraper.',
  'email.verify-email.button': 'Potwierdź e-mail',
  'email.verify-email.fallback_note': 'Jeśli przycisk nie działa, wklej ten link w przeglądarce:',
  'email.verify-email.ttl_note': 'Link wygasa za {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 godziny',
  'email.verify-email.ignore_note':
    'Nie zakładałeś konta Leadscraper? Po prostu zignoruj tę wiadomość.',

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Zwrot potwierdzony',
  'email.refund-confirmation.preheader': 'Zwrot: {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Cześć {{first_name}},',
  'email.refund-confirmation.intro': 'zwróciliśmy Ci {{amount_formatted}}.',
  'email.refund-confirmation.refunded_line':
    'Zaksięgowano {{refunded_at}} na Twoją pierwotną metodę płatności. W zależności od banku środki pojawią się w ciągu 3-10 dni roboczych.',
  'email.refund-confirmation.clawback_yes':
    'Ponieważ zwrot anuluje powiązane Credits, z Twojego konta odjęto {{credits_clawed_back}} Credits.',
  'email.refund-confirmation.clawback_no': 'Twoje Credits pozostają nienaruszone.',
  'email.refund-confirmation.reason_line': 'Powód: {{reason}}.',
  'email.refund-confirmation.outro': 'Masz pytania? Po prostu odpowiedz na tę wiadomość.',
  'email.refund-confirmation.footer':
    'Otrzymujesz tę wiadomość, ponieważ dla Twojego konta Leadscraper wykonano zwrot.',

  // ─── Transactional email — password-reset ────────────────────────────────
  'email.password-reset.subject': 'Resetowanie hasła: link ważny przez {{expires_in}}',
  'email.password-reset.title': 'Resetowanie hasła',
  'email.password-reset.preheader': 'Bezpiecznie zresetuj hasło. Link wygasa za {{expires_in}}.',
  'email.password-reset.badge': 'Resetowanie hasła',
  'email.password-reset.hero': 'Ustaw nowe<br>hasło.',
  'email.password-reset.body':
    'Ktoś poprosił o zresetowanie Twojego hasła. Jeśli to byłeś Ty, po prostu kliknij przycisk. Jeśli nie, zignoruj tę wiadomość, Twoje hasło pozostanie niezmienione.',
  'email.password-reset.expires': 'Link wygasa za {{expires_in}}.',
  'email.password-reset.cta.primary': 'Zresetuj hasło',
  'email.password-reset.signoff.line':
    'Pytania o bezpieczeństwo konta? Po prostu odpowiedz na tę wiadomość.',
  'email.password-reset.footer.transactional':
    'Ze względów bezpieczeństwa ta wiadomość zawiera informacje o żądaniu. Nie udostępniaj jej nikomu. To powiadomienie bezpieczeństwa jest częścią stosunku umownego i nie można go anulować.',

  // ─── Transactional email — security-alert ────────────────────────────────
  'email.security-alert.subject': 'Alert bezpieczeństwa: {{event}}',
  'email.security-alert.title': 'Alert bezpieczeństwa',
  'email.security-alert.preheader':
    'Alert bezpieczeństwa: {{event}}. Jeśli to nie byłeś Ty, zresetuj teraz hasło.',
  'email.security-alert.badge': 'Alert bezpieczeństwa',
  'email.security-alert.hero': 'Coś się zmieniło na<br>Twoim koncie.',
  'email.security-alert.subhead':
    'Cześć {{first_name}}, właśnie wykryliśmy działanie związane z bezpieczeństwem: <strong style="color:#0B0F19;">{{event}}</strong>. Jeśli to byłeś Ty, wszystko jest w porządku, możesz zignorować tę wiadomość.',
  'email.security-alert.detail.time_label': 'Czas (UTC)',
  'email.security-alert.detail.ip_label': 'Adres IP',
  'email.security-alert.detail.browser_label': 'Przeglądarka',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">To nie byłeś Ty?</strong> Natychmiast zresetuj hasło i sprawdź aktywność konta.',
  'email.security-alert.cta.primary': 'Zresetuj hasło teraz',
  'email.security-alert.signoff.line':
    'Pytania o bezpieczeństwo konta? Po prostu odpowiedz na tę wiadomość, czytam każdą.',
  'email.security-alert.footer.transactional':
    'Ze względów bezpieczeństwa ta wiadomość zawiera informacje o działaniu. Nie udostępniaj jej nikomu. To powiadomienie bezpieczeństwa jest częścią naszych warunków świadczenia usług i nie można go anulować.',
  // LEA-295 bug-fix: see note in de.ts. Machine-translated, pending native review.
  'email.security-alert.event.password_reset': 'Hasło zresetowane',
  'email.security-alert.event.account_deletion_requested':
    'Żądanie usunięcia konta (30-dniowy okres karencji)',
  'email.security-alert.event.password_changed': 'Hasło zmienione',
  'email.security-alert.firstname_fallback': 'tam',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'kredyt',
  'phase.creditMany': 'kredyty',
  'phase.retry': 'Spróbuj ponownie',
  'phase.cancel': 'Anuluj',
  'phase.confirm': 'Potwierdź',
  'phase.running': 'Trwa …',
  'phase.btn.running': 'trwa …',
  'phase.unknownError': 'Nieznany błąd',
  'phase.errorLabel': 'Błąd:',
  'phase.gate.loadingConnect': 'Wyszukiwanie kontaktów …',
  'phase.gate.loadingPitch': 'Generowanie pełnych informacji …',
  'phase.gate.loadingHint':
    'Zwykle trwa to 30-60 sekund. Możesz opuścić stronę, powiadomimy Cię, gdy będzie gotowe.',
  'phase.gate.failConnect': 'Wyszukiwanie nie powiodło się',
  'phase.gate.failPitch': 'Generowanie informacji nie powiodło się',
  'phase.gate.failHint': 'Spróbuj ponownie, nie zostanie pobrany dodatkowy kredyt.',
  'phase.connect.title': 'Odblokuj kontakty i dane bezpośrednie',
  'phase.connect.desc':
    'Wyszukujemy do 3 decydentów z bezpośrednim e-mailem, bezpośrednim telefonem i adresem LinkedIn. Źródła są dołączone (ślad audytowy RODO).',
  'phase.connect.cta': 'Znajdź kontakty',
  'phase.connect.runtime': 'Czas: ~30-60 sekund',
  'phase.pitch.title': 'Odblokuj pełne informacje i plan akwizycji',
  'phase.pitch.desc':
    'Spersonalizowany 6-sekcyjny plan akwizycji: czym zajmuje się firma, dlaczego akurat ten lead, aktualność (zdarzenia wyzwalające), referencje klientów, haczyki do Twojego e-maila sprzedażowego.',
  'phase.pitch.cta': 'Generuj pełne informacje',
  'phase.pitch.runtime': 'Czas: ~20-40 sekund',
  'phase.locked.confirmQuestion': 'Potwierdzenie: pobrać {credits} za "{action}"?',
  'phase.deepen.title': 'Pogłęb tego leada',
  'phase.deepen.descConnectDone':
    'Kontakty są załadowane. Teraz załaduj pełne informacje dla planu akwizycji + stacku technologicznego.',
  'phase.deepen.descDefault':
    'Zidentyfikowano. Załaduj kontakty lub przejdź od razu do pełnych informacji, rozliczane za kliknięcie.',
  'phase.deepen.pricingError': 'Nie udało się załadować katalogu cen, powrót do cen standardowych.',
  'phase.deepen.directPitch': 'Załaduj pełne informacje bezpośrednio (bez kontaktów)',
  'phase.btn.connect': '+ Znajdź kontakty ({credits})',
  'phase.btn.pitch': '+ Pełne informacje ({credits})',
  'phase.toast.connectLoading': 'Kontakty się ładują.',
  'phase.toast.pitchLoading': 'Pełne informacje się ładują.',
  'phase.toast.noCredits': 'Brak kredytów. Doładuj lub ulepsz swój plan.',
  'phase.toast.connectSoon': 'Wyszukiwanie kontaktów już wkrótce, odblokowane w fali F2.2.',
  'phase.toast.pitchSoon': 'Pełne informacje już wkrótce, odblokowane w fali F2.3.',
  'phase.toast.error': 'Błąd: {msg}',
  'phase.toast.unexpected': 'Nieoczekiwany błąd. Spróbuj ponownie.',
  'phase.dialog.connectTitle': 'Znaleźć kontakty?',
  'phase.dialog.pitchTitle': 'Załadować pełne informacje?',
  'phase.dialog.connectDesc':
    'Wyszukujemy decydentów (e-mail, telefon, LinkedIn) dla tego leada. Wynik jest zwykle dostępny w ciągu 1-2 minut.',
  'phase.dialog.pitchDesc':
    'Generujemy plan akwizycji, stack technologiczny, frazy wyzwalające i pola Sparkle dla tego leada. Wynik jest zwykle dostępny w ciągu 1-2 minut.',
  'phase.dialog.close': 'Zamknij okno dialogowe',
  'phase.dialog.costNote':
    'Ta akcja kosztuje {credits}. Po wykorzystaniu kredyt nie jest automatycznie zwracany.',
  'phase.dialog.confirmDeduct': 'Tak, pobierz {credits}',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Nota prawna',
  'det.src.handelsregister': 'Rejestr handlowy',
  'det.src.subPage': 'Strona zespołu',
  'det.src.dorkEnrich': 'Wyszukiwanie w sieci',
  'det.src.geminiGrounding': 'Badanie AI',
  'det.confReason.deepResearchConfirmed': 'potwierdzone badaniem',
  'det.confReason.handelsregisterOnly': 'tylko rejestr handlowy',
  'det.confReason.nameMatch': 'dopasowanie nazwy',
  'det.confReason.multiSource': 'wiele źródeł',
  'det.confReason.rankFallback': 'Ranking discovery (pominięto pogłębione badanie)',
  'det.confReason.rankFallbackLowConf': 'Ranking discovery (pogłębione badanie bez wyników)',
  'det.trust.authoritative': 'Zweryfikowane ze źródła oficjalnego (nota prawna/rejestr handlowy)',
  'det.trust.semiAuth': 'Z własnej strony firmy (np. /team)',
  'det.trust.llm': 'Wyodrębnione przez AI z treści strony',
  'det.trust.derived': 'Wywnioskowane z innych danych (niska pewność)',
  'det.trust.sourceGeneric': 'Źródło: {source}',
  'det.trust.confidence': 'pewność',
  'det.pReject.duplicate': 'Duplikat',
  'det.pReject.duplicateHint':
    'Osoba jest już na liście lub nazwa się nie zgadza ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Zła rola',
  'det.pReject.wrongRoleHint': 'Osoba nie ma uprawnień decyzyjnych, których szukamy',
  'det.pReject.inactive': 'Już nieaktywny',
  'det.pReject.inactiveHint': 'Osoba zmieniła stanowisko, na emeryturze itp.',
  'det.pReject.wrongData': 'Nieprawidłowe dane',
  'det.pReject.wrongDataHint': 'E-mail/telefon błędny lub nieosiągalny',
  'det.pReject.betterContact': 'Inna osoba jest lepsza',
  'det.pReject.betterContactHint': 'W tej firmie jest bardziej odpowiedni kontakt',
  'det.pReject.private': 'Nie kontaktować',
  'det.pReject.privateHint': 'Nie chcę kontaktować tej osoby (bez uczenia)',
  'det.toast.personFeedbackRealOnly': 'Opinie o osobach są dostępne tylko dla prawdziwych leadów.',
  'det.toast.removeFailed': 'Nie udało się usunąć. Spróbuj ponownie.',
  'det.toast.backendUnavailable': 'Backend niedostępny. Przeładuj aplikację.',
  'det.toast.planRegenerating': 'Plan akwizycji jest generowany ponownie z bieżącym briefingiem …',
  'det.toast.phaseAlreadyRunning': '{phase} już trwa, chwila cierpliwości.',
  'det.available': 'dostępne',
  'det.unavailable': 'niedostępne',
  'det.primary': 'Główny',
  'det.sourcePrefix': 'Źródło:',
  'det.dataViaWebResearch': 'Dane z publicznego wyszukiwania w sieci',
  'det.openLink': 'Otwórz {label}',
  'det.openLinkedin': 'Otwórz profil LinkedIn: {name}',
  'det.openXing': 'Otwórz profil XING: {name}',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts': 'Nie udało się znaleźć kontaktów. Nie pobrano kredytu.',
  'lt.trigErr.insufficientCredits': 'Za mało kredytów. Doładuj.',
  'lt.trigErr.phaseRunning': 'Ta faza już trwa, zaczekaj.',
  'lt.trigErr.phaseCompleted': 'Ta faza jest już zakończona.',
  'lt.trigErr.triggerFailed': 'Uruchomienie nie powiodło się: {msg}',
  'lt.cta.findContacts': 'Znajdź kontakty · 1 kredyt',
  'lt.cta.createPlan': 'Utwórz plan akwizycji · 1 kredyt',
  'lt.cta.openOutreach': 'Otwórz wiadomość',
  'lt.verifyStuck': 'Weryfikacja utknęła. Przeładuj stronę i spróbuj ponownie.',
  'lt.verifyFailed': 'Weryfikacja osób kontaktowych nie powiodła się.',
  'lt.planFailed': 'Nie udało się utworzyć planu akwizycji.',
  'lt.softKeepAria': 'Możliwe, kliknij po szczegóły',
  'lt.manual.toast.backendUnavailable': 'Backend niedostępny. Spróbuj później.',
  'lt.manual.toast.added': 'Dodano: {name}',
  'lt.manual.toast.alreadyExists': '{name} już istnieje, otwieram.',
  'lt.manual.toast.switchProfile': 'Może trzeba zmienić grupę docelową, lead może być w innej.',
  'lt.manual.toast.addFailed': 'Nie udało się dodać.',
  'lt.manual.companyFallback': 'Firma',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested': 'Zażądano anulowania, zadziała przy następnym punkcie kontrolnym.',
  'dash.cancel.failed': 'Anulowanie nie powiodło się',
  'dash.cancel.titleNoRun': 'Identyfikator uruchomienia jeszcze niedostępny',
  'dash.cancel.titleCancel': 'Anuluj wyszukiwanie',
  'dash.cancel.inFlight': 'Anulowanie …',
  'dash.cancel.confirm': 'Na pewno anulować?',
  'dash.refreshing': 'Odświeżanie …',
  'dash.run.noCredits': 'Brak kredytów, wykup subskrypcję.',
  'dash.run.startSub': 'Rozpocznij subskrypcję',
  'dash.sugg.region': 'Region:',
  'dash.sugg.contact': 'Kontakt:',
  'dash.sugg.extra': 'Dodatek:',
  'dash.sugg.why': 'Dlaczego:',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Wyklucz obecnych klientów',
  'acct.exclude.desc':
    'Dodaj domeny, które już znasz (np. eksport z CRM). Są odfiltrowywane z wyników WSZYSTKICH wyszukiwań, jedna domena w wierszu.',
  'acct.exclude.placeholder': 'firma.pl\nprzyklad-sp.pl\nklient.com',
  'acct.exclude.count': '{n} domen wykluczonych ze wszystkich wyszukiwań',
  'acct.exclude.save': 'Zapisz listę',
  'acct.exclude.saved': 'Lista wykluczeń zapisana ({n} domen)',
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Asystent',
  'agent.tab.chat': 'Czat',
  'agent.tab.workspace': 'Obszar roboczy',
  'agent.boot': 'Chwileczkę — Twój asystent się uruchamia …',
  'agent.thinking': 'Myślę …',
  'agent.turnError': 'Coś poszło nie tak — spróbuj ponownie za chwilę.',
  'agent.budgetExhausted':
    'Limit czatu na dziś został wyczerpany. Jutro odnowi się automatycznie — Twoje kredyty i leady pozostają nienaruszone.',
  'agent.artifact.eyebrow': 'Grupa docelowa',
  'agent.artifact.draftBadge': 'Szkic',
  'agent.artifact.createdBadge': 'Właśnie utworzono',
  'agent.artifact.industry': 'Branża',
  'agent.artifact.region': 'Region',
  'agent.artifact.size': 'Wielkość',
  'agent.artifact.exclusions': 'Wykluczenia',
  'agent.artifact.any': 'dowolna',
  'agent.bootError': 'Asystent jest chwilowo niedostępny. Odśwież stronę.',
  'agent.empty.title': '{greeting} — w czym mogę pomóc?',
  'agent.greet.morning': 'Dzień dobry',
  'agent.greet.day': 'Cześć',
  'agent.greet.evening': 'Dobry wieczór',
  'agent.empty.sub':
    'Opisz, jakich klientów szukasz — zbuduję wyszukiwanie, poproszę o Twoją zgodę i wspólnie omówimy wyniki.',
  'agent.starter.find': 'Szukam nowych klientów — pomóż mi zdefiniować grupę docelową',
  'agent.starter.describe': 'Przeanalizuj moją stronę i zaproponuj pasujące grupy docelowe',
  'agent.starter.review': 'Pokaż moje ostatnie leady i przejdźmy przez nie razem',
  'agent.composer.placeholder': 'Wiadomość do asystenta …',
  'agent.composer.send': 'Wyślij',
  'agent.composer.stop': 'Stop',
  'agent.composer.hint': 'Enter, aby wysłać · Shift+Enter — nowa linia',
  'agent.scroll.end': 'Przejdź na koniec',
  'agent.confirm.title': 'Zgoda: {action}',
  'agent.confirm.approve': 'Zatwierdź',
  'agent.confirm.deny': 'Odrzuć',
  'agent.tool.analyze': 'Analiza strony',
  'agent.tool.analyzeReference': 'Sprawdź stronę referencyjną',
  'agent.tool.draft': 'Szkic grupy docelowej',
  'agent.tool.createProfile': 'Utwórz profil',
  'agent.tool.startRun': 'Rozpocznij wyszukiwanie',
  'agent.tool.runStatus': 'Status wyszukiwania',
  'agent.tool.listLeads': 'Wczytaj leady',
  'agent.tool.getLead': 'Szczegóły leada',
  'agent.tool.connect': 'Znajdź kontakty',
  'agent.tool.pitch': 'Utwórz plan kontaktu',
  'agent.tool.feedback': 'Zapisz opinię',
  'agent.tool.credits': 'Saldo kredytów',
  'agent.tool.exclude': 'Wyklucz firmy',
  'agent.tool.cancelApproval': 'Wycofaj zatwierdzenie',
  'agent.tool.cancelPlan': 'Zatrzymaj plan wyszukiwań',
  'agent.support.open': 'Pomoc',
  'agent.support.title': 'Otwórz czat pomocy — odpowiada człowiek',
  'agent.ws.title': 'Twoje grupy docelowe',
  'agent.ws.new': 'Nowe',
  'agent.ws.empty': 'Tutaj pojawią się profile grup docelowych utworzone wspólnie na czacie.',
  'agent.ws.openLeads': 'Zobacz leady',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Kopiuj',
  'agent.msg.copied': 'Skopiowano',
  'agent.sessions.rename': 'Kliknij dwukrotnie, aby zmienić nazwę',
  'agent.composer.attach': 'Dołącz listę klientów (CSV/XLSX)',
  'agent.attach.none': 'W pliku nie wykryto domen firm.',
  'agent.attach.xlsxFailed': 'Nie udało się odczytać pliku Excel. Spróbuj użyć pliku CSV.',
  'agent.attach.saved':
    'Przesłałem listę klientów: {n} domen firm jest teraz wykluczonych ze wszystkich przyszłych wyszukiwań (np. {examples}).',
  'agent.attach.saveFailed':
    'Przesłałem listę klientów ({n} domen firm), ale zapisanie jej jako listy wykluczeń nie powiodło się.',
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Nowy czat',
  'agent.sessions.empty': 'Brak rozmów.',
  'agent.sessions.untitled': 'Nowa rozmowa',
  'agent.sessions.delete': 'Usuń',
  // LEA-448
  'agent.sessions.deleteConfirm': 'Usunąć tę rozmowę? Tej operacji nie można cofnąć.',
  'agent.artifact.radius': 'promień {n} km',
  'agent.leads.companyContactHint': 'Kontakt firmowy z impressum — nie osobisty przedstawiciel.',
  'agent.run.stalled': 'Trwa dłużej niż zwykle…',
  'agent.run.interrupted': '{n} firm dostarczonych — wyszukiwanie zakończone przedwcześnie',
  'agent.run.qualifierDown':
    'Nasz etap kwalifikacji był chwilowo niedostępny — to nasza wina, nie Twoich kryteriów. Warto uruchomić nowe wyszukiwanie.',
  'agent.run.recheck': 'Sprawdź ponownie',
  // LEA-448 round-4
  'agent.cost.startRun':
    'do {n} kredytów — liczą się tylko faktycznie dostarczone firmy; odrzucone nigdy nie są naliczane',
  'agent.cost.startRunRescue':
    'druga próba po słabym wyniku — nie liczy się jako kolejne wyszukiwanie; jak zawsze naliczane są tylko dostarczone firmy (do {n} kredytów)',
  'agent.cost.connect':
    '{n} kredyt — osoby kontaktowe (imię, stanowisko, e-mail, telefon) tej firmy ze źródeł publicznych',
  'agent.cost.pitch':
    '{n} kredyt — plan pozyskania (analiza + gotowa pierwsza wiadomość) dla tej firmy',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    'bezpłatnie — wyszukiwanie nic nie kosztuje, płacisz dopiero za odblokowanie osoby kontaktowej',
  'agent.cost.scheduleReveal':
    'bezpłatnie — każde wyszukiwanie · {cadence} · wstrzymuje się sam po {k} wyszukiwaniach z rzędu bez nowych firm lub gdy saldo jest puste · możesz go zatrzymać w każdej chwili',
  'agent.cost.connectReveal':
    'bezpłatnie — osoby kontaktowe są wyszukiwane i widoczne po odblokowaniu',
  'agent.cost.pitchReveal': 'bezpłatnie — plan pozyskania jest w cenie odblokowania',
  'agent.cost.startRunPlan':
    '{runs} wyszukiwania jedno po drugim, każde do {per} kredytów — łącznie do {n} kredytów za maksymalnie {leads} firm; liczą się tylko faktycznie dostarczone firmy, plan zatrzymuje się po słabym wyniku',
  'agent.cost.connectBatch':
    'do {n} kredytów — osoby kontaktowe (imię, stanowisko, e-mail, telefon) {count} firm ze źródeł publicznych; firma bez osiągalnego kontaktu nie jest naliczana',
  'agent.cost.pitchBatch':
    'do {n} kredytów — plany pozyskania (analiza + gotowa pierwsza wiadomość) dla {count} firm',
  'agent.sessions.history': 'Historia',
  'agent.sessions.close': 'Zamknij',
  'agent.time.now': 'przed chwilą',
  'agent.time.min': '{n} min temu',
  'agent.time.hour': '{n} godz. temu',
  'agent.time.day': '{n} dni temu',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Wyszukiwanie trwa',
  'agent.run.finalizing': 'Kończenie — już prawie …',
  'agent.run.preparing': 'Przygotowywanie wyszukiwania …',
  'agent.run.done': 'Wyszukiwanie zakończone',
  'agent.run.failed': 'Wyszukiwanie nie powiodło się',
  'agent.run.cancelled': 'Wyszukiwanie anulowane',
  'agent.run.delivered': '{n} / {total} firm dostarczonych',
  'agent.run.reviewCta': 'Przejrzyj leady',
  'agent.run.dismiss': 'Ukryj',
  'agent.run.step.planning': 'Planowanie',
  'agent.run.step.discovery': 'Odkrywanie',
  'agent.run.step.hydration': 'Wzbogacanie',
  'agent.run.step.reasoning': 'Ocena',
  'agent.run.step.delivery': 'Dostawa',
  'agent.run.won': '{n} świeżych leadów dla Ciebie!',
  'agent.run.empty': 'Nie znaleziono pasujących firm',
  'agent.rescue.head.zero': 'To wyszukiwanie nie znalazło pasujących firm.',
  'agent.rescue.head.lowOne':
    'To wyszukiwanie znalazło tylko 1 pasującą firmę — możesz już ją przejrzeć.',
  'agent.rescue.head.low':
    'To wyszukiwanie znalazło tylko {n} pasujące firmy — możesz już je przejrzeć.',
  'agent.rescue.cause.ours':
    'To nasza wina, nie Twojej grupy docelowej: wyszukiwanie nie przebiegło prawidłowo z przyczyn technicznych.',
  'agent.rescue.cause.oursQualifier':
    'To nasza wina, nie Twojej grupy docelowej: nasz etap weryfikacji był niedostępny podczas wyszukiwania, więc znalezione firmy w ogóle nie zostały ocenione.',
  'agent.rescue.cause.fewFound':
    'W obszarze wyszukiwania ({area}) znaleźliśmy tylko kilka firm pasujących do Twojego opisu. To mówi więcej o naszym zasięgu tam niż o Twoim rynku.',
  'agent.rescue.cause.harvested':
    'Znalezione firmy już znasz: zostały Ci dostarczone przy wcześniejszych wyszukiwaniach albo są na Twojej liście znanych firm.',
  'agent.rescue.cause.harvestedLow':
    'Pozostałe znalezione firmy już znasz: zostały Ci dostarczone przy wcześniejszych wyszukiwaniach albo są na Twojej liście znanych firm.',
  'agent.rescue.cause.tooBroad':
    'Twoja grupa docelowa nie wskazuje konkretnej branży. Bez branży wyszukiwanie nie wie, które firmy sprawdzić.',
  'agent.rescue.cause.filtered':
    'Znaleźliśmy firmy, ale żadna nie spełniła Twoich kryteriów (branża, wielkość lub region).',
  'agent.rescue.cause.filteredLow':
    'Pozostałe znalezione firmy nie spełniły Twoich kryteriów (branża, wielkość lub region).',
  'agent.rescue.cause.unknown': 'Nie udało nam się ustalić na pewno, dlaczego tak się stało.',
  'agent.rescue.freeRule':
    'Nieudane wyszukiwania nigdy nic nie kosztują: bez dostarczonej firmy nic nie jest naliczane. A nowa próba nie liczy się jako kolejne wyszukiwanie.',
  'agent.rescue.pick': 'Moja propozycja — jedno kliknięcie uruchamia nowe wyszukiwanie:',
  'agent.rescue.noOption.tooBroad':
    'Podaj mi konkretną branżę lub zawód, a razem doprecyzujemy grupę docelową.',
  'agent.rescue.noOption.wide':
    'Obszar wyszukiwania jest już tak szeroki, jak to ma sens — kolejna próba z tymi samymi kryteriami najpewniej nie przyniesie nic nowego.',
  'agent.rescue.thin.zero':
    'Druga próba również nie znalazła pasujących firm. To wskazuje, że dla tej kombinacji istnieje bardzo mało publicznie dostępnych firm — kolejna próba z tymi samymi kryteriami niczego by nie zmieniła.',
  'agent.rescue.thin.low':
    'Druga próba również prawie nic nie znalazła (dostarczono: {n}). To wskazuje, że dla tej kombinacji istnieje niewiele publicznie dostępnych firm — kolejna próba z tymi samymi kryteriami niczego by nie zmieniła.',
  'agent.rescue.thin.next': 'Lepszy będzie inny kąt — na przykład pokrewna branża lub inny region.',
  'agent.rescue.opt.same': 'Uruchom to samo wyszukiwanie ponownie',
  'agent.rescue.opt.widen': 'Rozszerz obszar: {area} (zamiast tylko: {from})',
  'agent.rescue.opt.dach': 'Rozszerz obszar: Niemcy, Austria i Szwajcaria',
  'agent.rescue.opt.dachFrom':
    'Rozszerz obszar: Niemcy, Austria i Szwajcaria (zamiast tylko: {from})',
  'agent.rescue.opt.industry': 'Szukaj ponownie z branżą „{industry}”',
  'agent.rescue.chip.market': 'Spróbujmy „{market}” jako grupy docelowej',
  'agent.rescue.chip.rethink': 'Pomóż mi przemyśleć grupę docelową',
  'agent.rescue.unavailable': 'Ta druga próba nie jest już dostępna',
  'agent.rescue.card.note':
    'Nie liczy się jako kolejne wyszukiwanie — jak zawsze naliczane są tylko dostarczone firmy',
  'agent.rescue.card.noteFree': 'Bezpłatna druga próba — nie liczy się jako kolejne wyszukiwanie',
  'agent.rescue.oursRetryLater':
    'Spróbuj ponownie za kilka minut — niedostarczone firmy nigdy nie są naliczane.',
  'agent.rescue.card.used': 'Uruchomiono',
  'agent.rescue.card.aria': 'Propozycje drugiej próby',
  'agent.rescue.preparing': 'Sprawdzam, co poszło nie tak …',
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Twoja passa',
  'agent.momentum.audiences': 'Grupy docelowe',
  'agent.momentum.searches': 'Wyszukiwania',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Kontakty',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Twoje leady — które pasują?',
  'agent.leads.rated': '{done}/{total} ocenionych',
  'agent.leads.accept': 'Pasuje',
  'agent.leads.reject': 'Nie pasuje',
  'agent.leads.accepted': 'Pasuje',
  'agent.leads.rejected': 'Nie pasuje',
  'agent.leads.contacts': '{n} kontaktów',
  'agent.leads.openAll': 'Zobacz wszystkie szczegółowo',
  'agent.leads.done': 'Super — wszystkie ocenione! To wyostrza kolejne wyszukiwanie.',
  'agent.leads.chainConnect': '→ Znajdź decydentów dla Twoich trafień ({n})',
  'agent.leads.chainMsg': 'Znajdź osoby kontaktowe dla: {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Wskaźnik trafień {pct}%',
  'agent.pulse.rising': 'rośnie',
  'agent.pulse.detail': '{accepted} z {rated} leadów pasuje · {profiles} grup docelowych',
  'agent.pulse.nudge':
    'Oceniaj swoje leady 👍/👎 — dzięki temu poznam Twój wskaźnik trafień i z każdym wyszukiwaniem będę lepszy.',
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Tak, utwórz tak',
  'agent.chip.adjustDraft': 'Dostosuj grupę docelową',
  'agent.chip.startRun': 'Rozpocznij wyszukiwanie',
  'agent.chip.reviewLeads': 'Przejrzyj leady',
  'agent.chip.msg.confirmDraft': 'Tak, utwórz profil dokładnie w ten sposób.',
  'agent.chip.msg.adjustDraft': 'Chcę jeszcze dostosować grupę docelową.',
  'agent.chip.msg.startRun': 'Rozpocznij teraz wyszukiwanie dla tego profilu.',
  'agent.chip.msg.startRunNamed': 'Rozpocznij teraz wyszukiwanie dla grupy docelowej „{name}”.',
  'agent.chip.msg.reviewLeads': 'Przejrzyjmy dostarczone leady.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Usuń',
  'dash.cortex.editHint':
    'Usuń chipy przez × lub dodaj pasujące, dzięki temu Leadscraper trafniej oddaje Twoją ofertę (maks. 8 na kolumnę).',
  'dash.cortex.descLabel': 'Opis',
  'dash.cortex.changeUrl': 'Przeanalizuj inną stronę',
  'dash.cortex.editSaved': 'Profil firmy zaktualizowany',
  'dash.cortex.addPlaceholder': 'dodaj…',
  'dash.cortex.capReached': 'Osiągnięto maks. 8',
  'pd.target.edit': 'Opisz na nowo',
  'pd.target.editHint':
    'Opisz idealnych klientów w 1–2 zdaniach. Leadscraper na nowo wywnioskuje branżę, region i osobę kontaktową.',
  'pd.target.editPlaceholder': 'np. producenci opakowań, w całym kraju, 50–250 pracowników, zarząd',
  'pd.target.reparsing': 'Leadscraper myśli …',
  'pd.target.saved': 'Grupa docelowa zaktualizowana',
  'pd.target.saveError': 'Nie udało się zaktualizować. Spróbuj ponownie.',

  // W21/W22 Dossier — strona grupy docelowej jako samopisząca się dokumentacja
  // (Claude design handover 2026-07-03). Obszar 1: karta dossier.
  'dos.eyebrow': 'Twoja grupa docelowa · pisana przez Ciebie i Leadscraper',
  'dos.maturity.coldStart': 'Poznaje Cię',
  'dos.maturity.early': 'Wstępny obraz',
  'dos.maturity.calibrated': 'Skalibrowana',
  'dos.maturity.mature': 'Dojrzała',
  'dos.ratings': '{n} ocen',
  'dos.matchRate': '{pct}% trafności',
  'dos.weak': 'słabe',
  'dos.edit.cta': 'Edytuj grupę docelową',
  'dos.weave.youSearch': 'Szukasz',
  'dos.weave.vorgabeLabel': 'Twoje ustawienie · z Twojego briefu',
  'dos.weave.withSize': 'z {size} pracownikami',
  'dos.weave.sizeValue': '{range} pracowników',
  'dos.weave.inRegion': 'w {region}',
  'dos.weave.contact': 'osoba kontaktowa',
  'dos.weave.prefers': 'preferuje',
  'dos.weave.and': 'i',
  'dos.weave.weakHint': 'pierwsza wskazówka:',
  'dos.legend.you': 'Twoje ustawienie',
  'dos.legend.learned': 'wyuczone: liczba = dowody, klikalne',
  'dos.legend.weak': 'słabe (1–2 dowody)',
  'dos.emptyLearned':
    'Jeszcze nic się nie nauczył, oceń poniżej swoje pierwsze leady, a to dossier zacznie pisać się samo.',
  'dos.heartbeat.active': 'Aktywnie się uczy',
  'dos.heartbeat.waiting': 'Czeka na Twoje pierwsze oceny',
  'dos.heartbeat.since': 'od {date}',
  'dos.heartbeat.next': 'kolejna analiza przy {n} ocenach',
  'dos.proof.title': 'Twoje {n} zaakceptowane firmy',
  'dos.proof.openAll': 'Zobacz wszystkie w boardzie',
  'dos.error.learn': 'Dane uczenia są chwilowo niedostępne.',
  'dos.error.retry': 'Załaduj ponownie',
  'dos.details.show': 'Wszystkie {n} wzorców w szczegółach ↓',
  'dos.details.hide': 'Ukryj szczegóły',
  'dos.aside.patterns': 'Wzorce w szczegółach',
  'dos.kpi.title': 'Twoja grupa w liczbach',
  'dos.kpi.match': 'Trafność',
  'dos.kpi.reachable': 'Osiągalni',
  'dos.kpi.reachableSub': '{n} z {m} zapytań',
  'dos.kpi.reachableTeaser': 'Po pierwszym zapytaniu o kontakt',
  'dos.kpi.yield': 'Na zapytanie',
  'dos.kpi.yieldSub': '{n} wyszukiwań',
  'dos.kpi.matchTeaser': 'od {p} ocen',
  'dos.journey.eyebrow': 'Tak powstaje twój dossier',
  'dos.journey.s1': 'Grupa docelowa opisana',
  'dos.journey.s1Sub': 'Zapisana poprawnie. Leadscraper wie, czego szukać.',
  'dos.journey.s2': 'Odbierz pierwsze leady',
  'dos.journey.s2Sub': 'Uruchom pierwsze wyszukiwanie, pierwsze firmy pojawią się w kilka minut.',
  'dos.journey.s2Done': '{n} leadów gotowych.',
  'dos.journey.s2Running': 'Twoje wyszukiwanie trwa, pierwsze firmy pojawią się tu za chwilę.',
  'dos.journey.s2RunningBadge': 'Wyszukiwanie trwa · zwykle 5–12 min',
  'dos.journey.s3': 'Oceń pierwsze {p} leadów',
  'dos.journey.s3Progress': '{n} z {p} leadów ocenionych',
  'dos.journey.s3Sub':
    'Po {p} ocenach Leadscraper napisze tu pierwszą ocenę, od {a} twój feedback kieruje każdym wyszukiwaniem.',
  'dos.voice.preview':
    'Po pierwszych {p} ocenach Leadscraper napisze tutaj swoją ocenę twojej grupy docelowej.',
  'dos.voice.more': 'Czytaj dalej',
  'dos.voice.less': 'Zwiń',
  'dos.analysis.pending':
    'Leadscraper analizuje twoje {n} ocen, pierwsza ocena pojawi się tu wkrótce.',
  'dos.heartbeat.analysing': 'Analizuje twoje oceny …',
  // Dossier — popover z dowodami
  'dos.popover.close': 'Zamknij',
  'dos.popover.evidence': '{n} dowodów',
  'dos.popover.weakChip': 'słabe · {n} dowodów',
  'dos.popover.view': 'zobacz ↗',
  'dos.popover.noExamples':
    'Dla tego wzorca nie zapisano pojedynczych leadów jako dowodów, liczba zlicza Twoje oceny.',
  'dos.popover.weakNote': 'Dopiero {n} dowodów, na razie ostrożnie wpływa na wyszukiwanie.',
  // Dossier — obszar 2: oceń teraz
  'dos.rate.eyebrow': 'Oceń teraz',
  'dos.rate.waiting': '{n} leadów czeka na Twoją ocenę',
  'dos.rate.waitingOne': '1 lead czeka na Twoją ocenę',
  'dos.rate.openBoard': 'Otwórz wszystkie w tablicy →',
  'dos.rate.sub': 'Każda ocena doprecyzowuje dossier, od razu tutaj, bez opuszczania strony.',
  'dos.rate.fits': 'Pasuje do mojej grupy docelowej',
  'dos.rate.fitsNot': 'Nie pasuje',
  'dos.rate.view': 'zobacz',
  'dos.rate.acceptedCheck': '✓ Zaakceptowano',
  'dos.rate.learned': 'dossier nauczyło się:',
  'dos.rate.flowsIn': 'wpływa na kolejną analizę.',
  'dos.rate.undo': 'Cofnij',
  'dos.rate.whyQuestion':
    'Co było nie tak? Wystarczy jedno kliknięcie, Leadscraper się na tym uczy.',
  'dos.rate.noReason': 'Kontynuuj bez podania powodu',
  'dos.rate.allDone':
    'Wszystko ocenione, nowe leady pojawią się tutaj, gdy tylko wyszukiwanie coś dostarczy.',
  'dos.rate.rejectedCheck': '✗ Odrzucono',
  'dos.rate.avoidedLearned': ', dossier od teraz unika:',
  'dos.reason.industry': 'Zła branża',
  'dos.reason.tooBig': 'Za duża',
  'dos.reason.tooSmall': 'Za mała',
  'dos.reason.region': 'Zły region',
  'dos.reason.role': 'Zła rola',
  'dos.reason.other': 'Inne',
  // Dossier — obszar 3: kolejne wyszukiwania
  'dos.sug.eyebrow': 'Wywnioskowane z Twoich wzorców',
  'dos.sug.title': 'Twoje kolejne wyszukiwania',
  'dos.sug.basis.expansion': 'Rozszerzenie',
  'dos.sug.basis.crossSell': 'Cross-sell',
  'dos.sug.basis.zoomOut': 'Zoom-out',
  'dos.sug.basis.patternHint': 'Wskazówka ze wzorca',
  'dos.sug.basis.salesFit': 'Dopasowanie sprzedażowe',
  'dos.sug.tier.veryStrong': 'bardzo silne',
  'dos.sug.tier.strong': 'silne',
  'dos.sug.tier.solid': 'solidne',
  'dos.sug.tier.hypothesis': 'słabe',
  'dos.sug.fitLabel': 'oczekiwana trafność',
  'dos.sug.start': 'Rozpocznij wyszukiwanie',
  'dos.sug.history': '{n} poprzednich wyszukiwań',
  'dos.sug.historyOne': '1 poprzednie wyszukiwanie',
  'dos.sug.showHistory': 'Zobacz historię →',

  'common.close': 'Zamknij',
  'common.selected': 'Wybrano',
  'credit.balanceTitle': 'Twój stan kredytów',
  'credit.available': 'dostępne',
  'det.trigger.cat.serviceRadius': 'Obszar usług',
  'det.trigger.cat.specialization': 'Specjalizacja',
  'det.trigger.cat.capacity': 'Wydajność',
  'det.trigger.cat.history': 'Historia',
  'det.trigger.cat.partnership': 'Partnerstwo',
  'det.trigger.cat.certification': 'Certyfikacja',
  'det.trigger.cat.other': 'Inne',
  'lead.removeContactTitle': 'Dlaczego usunąć?',
  'lead.actionNeedPlan': 'Najpierw wygeneruj plan akwizycji',
  'lead.actionNoEmail': 'Brak adresu e-mail dla priorytetowego kontaktu',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Ładowanie twojego profilu + poprzednich ocen …',
  'scraper.act.firstFeedbacks':
    'Zbieranie pierwszych ocen, od 10 Cortex uczy się twoich wzorców akceptacji/odrzucenia.',
  'scraper.act.feedbacksCollected':
    '{seen} ocen zebranych, personalizacja zostanie aktywowana przy {activeAt} ocenach na profil. Ten przebieg nadal działa bez nadpisania wzorców.',
  'scraper.act.patternsActive':
    '{seen} ocen · {accepted} wzorców akceptacji · {rejected} wzorców odrzucenia aktywnych w analizie',
  'scraper.act.planning':
    'Planowanie strategii wyszukiwania: które źródła wyszukiwania + zapytania najlepiej pokrywają twoje zapytanie?',
  'scraper.act.aiSearchTempError':
    'Wyszukiwanie AI miało problem tymczasowy (sieć/timeout). Spróbuj ponownie.',
  'scraper.act.aiSearchUnavailable':
    'Wyszukiwanie AI obecnie niedostępne (problem konfiguracji). Skontaktuj się z pomocą techniczną.',
  'scraper.act.aiSearchBadFormat':
    'Wyszukiwanie AI zwróciło nieprawidłowy format. Spróbuj ponownie.',
  'scraper.act.aiSearchFailed': 'Wyszukiwanie AI nie powiodło się ({reason}). Spróbuj ponownie.',
  'scraper.act.reasonUnknown': 'nieznany',
  'scraper.act.researcherAnalyzing': 'AI-Researcher analizuje Twoje zapytanie…',
  'scraper.act.researcherFound': 'AI-Researcher: zidentyfikowano {n} zweryfikowanych firm',
  'scraper.act.goal': 'Cel: {goal}',
  'scraper.act.strategy': 'Strategia: {strategy}',
  'scraper.act.reasoning': 'Uzasadnienie: {reasoning}',
  'scraper.act.srcCurated': '⭐ Kurowane źródło',
  'scraper.act.srcOwn': '💡 Własna propozycja',
  'scraper.act.srcKindRegister': 'Rejestr',
  'scraper.act.srcKindDirectory': 'Verzeichnis',
  'scraper.act.srcKindPortal': 'Portal',
  'scraper.act.source': '{tag}: {label} [{kind}]',
  'scraper.act.googleSearch': 'Google-Suche: „{q}"',
  'scraper.act.googleMaps': 'Google Maps: „{q}"{location}',
  'scraper.act.googleNews': 'Google News: „{q}"',
  'scraper.act.researcherEnough':
    'AI-Researcher wystarczy ({n} firm), pomijanie dodatkowych wyszukiwań Google',
  'scraper.act.researcherIdentified':
    'AI-Researcher zidentyfikował {n} firm, pomijanie wyszukiwań Google',
  'scraper.act.researcherNone':
    'AI-Researcher nie znalazł odpowiednich firm. Zapytanie jest bardzo niszowe. Spróbuj szerszego profilu lub mniej specyficznego regionu.',
  'scraper.act.companyIdentified': 'Firma zidentyfikowana: {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Wzbogacanie {n} firm o dane podstawowe (adres, rozmiar, stos technologiczny)...',
  'scraper.act.enrichCompany': 'Wzbogacanie firmy {idx}/{total}: {domain}',
  'scraper.act.phase1Light':
    'Faza-1-Light: {n} firm zidentyfikowanych w {secs}s. Adres/rozmiar/szczegóły będą przeskanowane w razie potrzeby.',
  'scraper.act.serperExhausted':
    '⚠ Credits Serper wyczerpane. Discovery ograniczone. Doładuj na serper.dev/dashboard.',
  'scraper.act.mapsHits': '{n} trafień w Maps dla „{query}"',
  'scraper.act.searchHitsCollected': '{n} wyników z wyszukiwania Google zebranych',
  'scraper.act.directoriesFound':
    '{n} katalogów branżowych znalezionych, wyodrębniam wymienione firmy …',
  'scraper.act.searchingPortal': 'Przeszukuję {host} w poszukiwaniu wymienionych firm …',
  'scraper.act.minedCompanies': '{n} firm wyodrębnionych z {portal}',
  'scraper.act.onlyPortals': 'Nie zidentyfikowano firm operacyjnych: wszystkie wyniki to portale',
  'scraper.act.queryInfeasible': 'Cortex uznaje zapytanie za niewykonalne: {reason}',
  'scraper.act.rethinking': 'Cortex myśli ponownie (runda {round}): {reason}',
  'scraper.act.searchingPortalNew': 'Przeszukiwanie {host} (nowy krok planu) …',
  'scraper.act.minedPortalRound': '{n} firm z {host} (runda Reflektora {round})',
  'scraper.act.backlogResumed': 'Wznowiono {n} kandydatów z backlogu z poprzednich uruchomień',
  'scraper.act.companiesIdentifiedAgg':
    'Zidentyfikowano {n} firm, uratowano {rescued}/{attempted} z portali agregatorów, rozpoczęcie analizy szczegółowej',
  'scraper.act.companiesIdentified': 'Zidentyfikowano {n} firm, rozpoczęcie analizy szczegółowej',
  'scraper.act.handelsregisterChecked': 'Sprawdzono wpis w rejestrze handlowym: {hrb}',
  'scraper.act.scanningWebsite': 'Analiza strony internetowej: {domain}',
  'scraper.act.relatedPages': 'Przeanalizowano {n} dodatkowych stron: {domain}',
  'scraper.act.deepAnalysis': 'Dogłębna analiza firmy: {name}',
  'scraper.act.pipelineStarted':
    'Pipeline uruchomiony, {n} kandydatów przechodzi równolegle przez hydrację + ocenę',
  'scraper.act.allDroppedPrefilter':
    'Wszystkie {n} znalezione firmy zostały odrzucone jako niepasujące (branża/region). Sprecyzuj swoją grupę docelową lub spróbuj innego regionu.',
  'scraper.act.noCompaniesFound':
    'Discovery nie znalazło firm dla tego wyszukiwania. Sprecyzuj swoją grupę docelową.',
  'scraper.act.phase1OnlyRun':
    'Uruchomienie tylko Fazy 1: {n} Leads zidentyfikowanych. Faza 2 + 3 zostały pominięte.',
  'scraper.act.leadsDeliveredEnriching':
    '{n} Leads dostarczonych, Cortex wciąż wzbogaca (plan akwizycji, wyniki, dogłębne badania)',
  'scraper.act.deeperResearch': 'Dogłębne badania: {name}, {findings} z {sources} źródeł',
  'scraper.act.coldStart': 'Cold-Start (brak wcześniejszych uruchomień)',
  'scraper.act.runHistory':
    '{runs} wcześniejszych uruchomień · {delivered} już dostarczonych · {dropped} już odrzuconych',
  'scraper.act.buyerProfile': 'Profil nabywcy: {narrative} (Pewność: {confidence})',
  'scraper.act.confHigh': 'wysoka',
  'scraper.act.confMid': 'średnia',
  'scraper.act.confLow': 'niska',
  'scraper.act.subsidiary':
    'Rozpoznano oddział DACH: {domain} ({src}), będzie wykorzystany do wyszukiwania kontaktów.',
  'scraper.act.subsidiarySrcDirect': 'sprawdzone bezpośrednio',
  'scraper.act.subsidiarySrcGoogle': 'poprzez wyszukiwanie Google',
  'scraper.rq.harvestedMsg':
    'Grupa docelowa na razie wyczerpana: wcześniejsze wyszukiwania już dostarczyły {prior} pasujących firm.',
  'scraper.rq.harvestedRec':
    'Cortex już znalazł znane firmy. Nowe trafienia pojawią się, gdy nowe firmy w twojej grupie docelowej będą widoczne online, harmonogram automatycznie je wyłapie.',
  'scraper.rq.noMarketMsg':
    'Znaleziono tylko {n} firm w całej sieci dla tego wyszukiwania. Ta grupa docelowa wydaje się nie być publicznie dostępna, być może zbyt specjalistyczna lub to wewnętrzne dane firmowe.',
  'scraper.rq.noMarketRec':
    'Spróbuj sformułować szerzej lub połącz z podobnymi branżami. Harmonogram nie opłaca się dla tego zapytania.',
  'scraper.rq.tooNicheMsg':
    'Tylko {n} potencjalnych firm na rynku, twoja grupa docelowa jest bardzo niszowa.',
  'scraper.rq.tooNicheRec':
    'Schedule opłaca się tylko przy grupach docelowych z 50+ firmami. Rozważ szerszy region lub więcej wariantów branżowych.',
  'scraper.rq.qualifierDownMsg':
    'Ocena przez AI była niedostępna podczas tego wyszukiwania, więc {n} znalezionych firm nie mogło zostać ocenionych — to problem techniczny po naszej stronie, a nie werdykt o Twoim rynku.',
  'scraper.rq.qualifierDownRec':
    'Uruchom wyszukiwanie ponownie za kilka minut. Nie musisz zmieniać kryteriów — tym razem żadna firma nie została faktycznie oceniona.',
  'scraper.rq.unmatchedMsg':
    '{n} firm przeanalizowanych, żadna nie odpowiadała twoim kryteriom (branża, wielkość, region).',
  'scraper.rq.unmatchedRec':
    'Sprawdź opis: zbyt surowe kryteria? Akceptacja look-alike nie pomoże, bo żadne look-alike nie były prawdopodobne.',
  'scraper.sum.delivered':
    '{n} Leads dostarczonych ({hard} pewnych{softFrag}) z {total} przeanalizowanych firm.',
  'scraper.sum.softFragment': ', {soft} potencjalnie istotnych',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads dostarczonych, grupa docelowa jest niszowa (zidentyfikowano tylko {total} firm na rynku).',
  'scraper.sum.nicheRec':
    'Przy powtarzającym się Schedule jest to normalne, nowe trafienia powstają z czasem. Jeśli potrzebujesz więcej wolumenu: rozważ szerszy region lub powiązane branże.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads dostarczonych, Cortex odrzucił {dropped} kolejnych kandydatów jako niepasujących.',
  'scraper.sum.droppedRec':
    'Jeśli chcesz więcej wolumenu: sformułuj opis bardziej swobodnie lub zaakceptuj look-alikes/Soft-Keeps.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads dostarczonych, mieszany wynik z {total} firm.',
  'scraper.sum.mixedRec':
    'Przy powtarzającym się Schedule jest to normalne, Cortex zbiera więcej trafień z czasem.',
  'scraper.sum.noneMatched':
    '{total} firm przeanalizowanych, żadna nie odpowiadała twoim kryteriom.',
  'scraper.sum.noneMatchedRec': 'Sprawdź opis: zbyt surowe kryteria lub spróbuj inny region.',
  'scraper.mem.active': 'Aktywnie spersonalizowany · {n} ocen',
  'scraper.mem.analyzing': 'Obecnie ponownie analizowany · {n} ocen',
  'scraper.mem.firstImpression': 'Pierwsze wrażenie · {n}/{active} do aktywacji',
  'scraper.mem.learning': 'Uczy się z tobą · {n}/{preview} do podglądu',
  'scraper.reflector.fallback':
    'Reflektor niedostępny, zapytanie zgłoszone jako niewykonalne, żeby użytkownik nie czekał w nieskończoność.',
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper znajduje firmy i decydentów w nich — nie dostarczamy osób prywatnych.',
  'apierr.b2cPivot': 'Możliwa alternatywa: {pivot}',
  'apierr.junkQuery':
    'Opisz konkretnie KOGO szukasz: np. "piekarnie w Warszawie" lub "księgowi Mazowieckie 5-50 pracowników". Ogólne pojęcia jak "B2B", "test", "profil" lub teksty z błędami nie są akceptowane.',
  'apierr.invalidWebsite': 'Podaj prawidłową stronę internetową (np. moja-firma.pl)',
  'apierr.noUserCompanyStep1': 'Najpierw przeanalizuj stronę internetową (Krok 1).',
  'apierr.noUserCompany': 'Najpierw przeanalizuj stronę internetową.',
  'apierr.insufficientPhase': 'Potrzebujesz {cost} Credit(s) do tej fazy. Aktualnie: {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    'Najpierw odblokuj kontakty tej firmy — plan pozyskania jest w cenie.',
  'apierr.planGenFailed': 'Plan akwizycji nie mógł zostać wygenerowany. Nie zużyto Credits.',
  'apierr.urlParse': 'URL nie mógł zostać przeanalizowany.',
  'apierr.urlIncomplete': 'Podaj pełny URL.',
  'apierr.dupCompany': 'Tę firmę już utworzyłeś{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    'Strona internetowa była niedostępna podczas tworzenia, dane nie mogły zostać pobrane.',
  'apierr.manualPhase1Failed':
    'Faza 1 nie powiodła się (strona internetowa niedostępna). Spróbuj ponownie przez "Aktualizuj dane".',
  'apierr.cancelRequested': 'Zażądano anulowania. Zostanie zastosowane przy następnym checkpoint.',
  'apierr.noCredits': 'Brak dostępnych Credits. Wykup abonament lub dokup Credits.',
  'apierr.rescueNotAvailable':
    'Bezpłatna druga próba dla tego wyszukiwania nie jest (już) dostępna.',
  'apierr.intentParse':
    'Nie udało się wyodrębnić konkretnej branży z twojego opisu "{desc}". Sprecyzuj: np. zamiast "Warszawa" → "piekarnie w Warszawie" lub "księgowi w Warszawie".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': 'Plan pozyskiwania',
  'det.creatingPlan': 'Cortex tworzy Twój plan pozyskiwania…',
  'det.planLoadTime': 'Zwykle 30-60 sekund, bez przeładowania, pojawia się automatycznie',
  'det.planUncertaintyWarning': 'Uwaga: tekst planu zawiera niepewności',
  'det.companyClassification': 'Klasyfikacja firmy',
  'det.opportunities': 'Szanse',
  'det.risksAndDealbreakers': 'Ryzyka / przeszkody',
  'det.channelMix': 'Miks kanałów · sekwencja 7-dniowa',
  'ld.sparkle.sampleMessageLabel': 'Przykładowa wiadomość do pierwszego kontaktu',
  'ld.sparkle.sampleMessageCopied': 'Skopiowano przykładową wiadomość.',
  'common.copy': 'kopiuj',
  'ld.sparkle.messageSubject': 'Temat: ',
  'ld.lean.urteil': 'Dlaczego ten lead',
  'ld.lean.winkel': 'Twój punkt zaczepienia',
  'ld.lean.kontakte': 'Kto pierwszy',
  'ld.lean.nachricht': 'Pierwszy kontakt, gotowy do wysłania',
  'ld.lean.nachrichtShort': 'Szkic pierwszego kontaktu',
  'ld.lean.telefon': 'Otwarcie telefoniczne',
  'ld.lean.check': 'Przed wysłaniem',
  'ld.lean.copyAI': 'Kopiuj dla AI',
  'ld.lean.copyAITitle':
    'Kopiuje plan, publicznie zweryfikowane dane firmy i kontaktów oraz Twój profil oferty jako handover dla ChatGPT, Claude i innych.',
  'ld.lean.copiedAI': 'Handover skopiowany, wklej go do swojego narzędzia AI',
  'ld.lean.varMain': 'Polecana',
  'ld.lean.sendMail': 'Wyślij jako e-mail',
  'ld.lean.sendMailTitle': 'Otwiera Twój program pocztowy z {addr}, tematem i treścią wypełnionymi',
  'ld.lean.zentrale': 'Centrala',
  'ld.lean.nameNotPublic': 'nazwisko niepubliczne',
  'ld.lean.verifiziert': 'zweryfikowany',
  'ld.lean.chEmail': 'E-mail',
  'ld.lean.chTelefon': 'Telefon',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Jesteś moim copilotem sprzedażowym dla dokładnie tego jednego leada. Poniżej znajdują się wszystkie dane, które moje narzędzie (Leadscraper) zebrało z publicznych źródeł i przygotowało jako plan akwizycji, korzystaj z nich bezpośrednio, nie pytaj o nie najpierw.\n\nOznaczenia: ✓ = publicznie potwierdzone (strona, stopka, LinkedIn, rejestr), ~ = założenie bez twardego źródła. Zachowaj to rozróżnienie i niczego nie wymyślaj o firmie ani osobie kontaktowej.\n\nMożesz pomóc mi dopracować pierwszą wiadomość, zbudować skrypt rozmowy, przećwiczyć obiekcje lub przygotować follow-up.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Dostępne dane',
  'ld.ai.secContacts': 'Kontakty',
  'ld.ai.secCompany': 'Moja firma',
  'ld.ai.secPlan': 'Plan akwizycji',
  'ld.ai.secUncertain': 'Niepewności i do weryfikacji',
  'ld.ai.secTask': 'Czego od Ciebie potrzebuję',
  'ld.ai.taskBody':
    'Zacznij od razu: dopracuj powyższą wiadomość pierwszego kontaktu w moim tonie i zaproponuj JEDNĄ konkretną poprawkę, która zwiększy moją szansę na odpowiedź.',
  'ld.ai.company': 'Firma',
  'ld.ai.industry': 'Branża',
  'ld.ai.size': 'Wielkość',
  'ld.ai.region': 'Region',
  'ld.ai.dataAsOf': 'Stan danych: zbadano {date}',
  'det.recommendedNextStep': 'Zalecany następny krok',
  'det.botProtectionWarning':
    'Ta strona miała aktywną ochronę przed botami: nie mogliśmy bezpośrednio pobrać strony impressum/kontaktowej. Pokazane tu dane zebraliśmy ze źródeł publicznych (Google, katalogi branżowe) i mogą być mniej dokładne niż dane bezpośrednio z impressum.',
  'det.possibleNotVerified': 'Możliwe: nie w 100% weryfikowalne',
  'det.noJustificationYet':
    'Brak uzasadnienia: dla tego leada nie udało się wykonać dopasowania kupującego (niekompletny profil użytkownika lub strona była nieosiągalna). Uruchomienie faz 2/3 pobierze więcej danych.',
  'det.offering': 'Oferta',
  'det.nicheSignals': 'Sygnały niszowe',
  'det.niche.signalsOne': '1 sygnał',
  'det.niche.signalsMany': '{n} sygnałów',
  'det.vatId': 'NIP: ',
  'det.revenue': 'Przychód ',
  'det.agency': 'Agencja',
  'det.distributor': 'Dystrybutor',
  'det.stack': 'Stack:',
  'det.webDesign': 'Projekt strony:',
  'det.masteryBusiness': 'Zakład mistrzowski',
  'det.guild': 'Cech: ',
  'det.imprintVerified': '✓ Impressum zweryfikowane',
  'det.sealsOfQuality': 'Znaki jakości:',
  'det.social': 'Social:',
  'det.verifyingContacts': 'Weryfikowanie kontaktów…',
  'det.inferringPattern': 'Wnioskowanie wzorca…',
  'det.emailPatternPlaceholder': '{imie}.{nazwisko}@firma.de',
  'det.sales': 'Sprzedaż',
  'det.marketing': 'Marketing',
  'det.engineering': 'Technika',
  'det.finance': 'Finanse',
  'det.management': 'Zarząd',
  'det.procurist': 'Prokurent',
  'det.contactRemoved': 'usunięto: nie będzie już dostarczany.',
  'det.percentSure': '% pewności',
  'det.foundIn': 'znaleziono w:',
  'det.recommendedChannel': 'Zalecany kanał',
  'det.tier1': 'Poziom 1 · bezpośrednio osiągalny',
  'det.tier2': 'Poziom 2 · kanał profilowy',
  'det.tier3': 'Poziom 3 · przez centralę',
  'det.tier4': 'Poziom 4 · kontakt zapasowy',
  'det.tier5': 'Poziom 5 · tylko routing firmowy',
  'det.inferred': '⚠ przypuszczalny',
  'det.companyCentral': '(Centrala firmy)',
  'det.quality.title': 'Jakość leada',
  'det.quality.company': 'Firma',
  'det.quality.contact': 'Kontakt',
  'det.quality.noContacts':
    'Brak publicznie weryfikowalnych decydentów dla tej firmy. Leadscraper nie wymyśla kontaktów.',
  'det.quality.companyFitPlain': 'Branża, region i wielkość pasują do Twojego wyszukiwania.',
  'det.quality.companyFitSoft':
    'Branża i region pasują, jeszcze nie w pełni jednoznacznie w każdym kryterium.',
  'det.quality.noContactsCentral': 'Firma pozostaje osiągalna przez centralę (zob. kontakt).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': 'Najpierw zweryfikuj kontakt',
  'det.quality.lockedPlanCreate': 'Najpierw utwórz plan pozyskiwania',
  'ld.sparkle.conversationOpener': 'Otwarcie rozmowy',
  'ld.sparkle.openerCopied': 'Skopiowano otwarcie.',
  'lt.next.contactVerificationStarted': 'Rozpoczęto weryfikację kontaktu …',
  'lt.next.contactVerificationLabel': 'Weryfikacja kontaktu',
  'lt.next.planGenerationStarted': 'Rozpoczęto generowanie planu pozyskiwania …',
  'lt.next.planGenerationLabel': 'Generowanie planu pozyskiwania',
  'lt.next.verifiedNoContacts': 'Zweryfikowano, nie znaleziono kontaktów',
  'det.size.employees': 'pracowników',
  'det.since': 'od ',

  // ── Lejek Prism (ekstrakcja i18n Stage C, /dev/prism-demo) ────────────────
  // Ogólne / nagłówek
  'prism.kicker.account': 'Konto utworzone',
  'prism.kicker.waiting': 'Twoi pierwsi klienci czekają',
  'prism.audienceFallback': 'Twojej grupy docelowej',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper: Pakiet startowy 50 leadów',
  'billing.tripwire.lineItem.desc': '50 zweryfikowanych leadów, gotowych do kontaktu.',
  'prism.a11y.close': 'Zamknij',
  // Krok 1 — Grupa docelowa
  'prism.target.eyebrow': 'Krok 1 z 3 · Grupa docelowa',
  'prism.target.title': 'Do kogo chcesz dotrzeć?',
  'prism.target.titleGrad': 'Znajdziemy ich od razu.',
  'prism.target.sub':
    'Opisz swoją grupę docelową jednym zdaniem, Twoje wyszukiwanie na żywo dopasuje się dokładnie do niej.',
  'prism.target.label': 'Twoja grupa docelowa',
  'prism.target.placeholder': 'np. właściciele biur rachunkowych w Warszawie',
  'prism.target.chip.steuer': 'Biura rachunkowe w Warszawie',
  'prism.target.chip.agentur': 'Agencje marketingowe w Krakowie',
  'prism.target.chip.handwerk': 'Firmy budowlane w Gdańsku',
  'prism.target.chipQuery.steuer': 'Właściciele biur rachunkowych w Warszawie',
  'prism.target.chipQuery.agentur': 'Założyciele agencji marketingowych w Krakowie',
  'prism.target.chipQuery.handwerk': 'Firmy budowlane w Gdańsku',
  'prism.target.tip':
    '💡 Najlepiej działa: branża + region, np. „stomatolodzy we Wrocławiu". Rozumiemy też role, np. „prezesi firm z sektora MŚP".',
  'prism.target.suggestion': 'Masz na myśli np. „{suggestion}"?',
  'prism.target.validating': 'Sprawdzamy Twoją grupę docelową…',
  'prism.target.cta': 'Znajdź grupę docelową',
  'prism.target.foot': 'Za darmo · nie potrzebujemy danych płatniczych',
  'prism.target.errFallback': 'To jeszcze nie wygląda na grupę docelową.',
  // Krok 2 — Strona WWW
  'prism.website.eyebrow': 'Krok 2 z 3 · Strona WWW',
  'prism.website.title': 'Twoja strona,',
  'prism.website.titleGrad': 'żeby AI Cię zrozumiała',
  'prism.website.sub':
    'Strona twojej firmy, żebyśmy zrozumieli, co sprzedajesz i jacy klienci do ciebie pasują.',
  'prism.website.label': 'Adres strony',
  'prism.website.placeholder': 'https://twoja-firma.pl',
  'prism.website.hint':
    'Nie masz jeszcze własnej strony? Pomiń ten krok. Wyszukiwanie ruszy wtedy tylko na podstawie grupy docelowej.',
  'prism.website.errInvalid': 'To jeszcze nie wygląda na adres strony: np. „twoja-firma.pl".',
  'prism.website.cta': 'Analizuj stronę',
  'prism.website.foot': 'Tylko analiza · nic nie zostanie opublikowane',
  // Faza analizy
  'prism.analyzing.reading': 'AI czyta Twoją stronę…',
  'prism.analyzing.wait': 'Doprecyzowujemy Twoją grupę docelową…',
  'prism.analyze.step1': 'Strona załadowana i odczytana na żywo',
  'prism.analyze.step2': 'Model biznesowy rozpoznany',
  'prism.analyze.step3': 'Oferta i propozycja wartości przeanalizowane',
  'prism.analyze.step4': 'Idealna grupa docelowa wyznaczona',
  // Krok 3 — Pytania
  'prism.questions.eyebrow': 'Ostatni krok · Doprecyzowanie',
  'prism.questions.back': '← Wstecz',
  'prism.questions.title': 'Krótkie potwierdzenie:',
  'prism.questions.titleGrad': 'pytanie {num} z {total}',
  'prism.questions.q1': 'Jak duże mają być firmy?',
  'prism.questions.q1o1': 'Do 50 pracowników',
  'prism.questions.q1o2': 'Powyżej 50',
  'prism.questions.q1o3': 'Bez znaczenia',
  'prism.questions.q2': 'Czy firmy mają być wyspecjalizowane?',
  'prism.questions.q2o1': 'Tak, jeden segment',
  'prism.questions.q2o2': 'Szeroki profil',
  'prism.questions.q2o3': 'Bez znaczenia',
  'prism.questions.q3': 'Gdzie mają działać firmy?',
  'prism.questions.q3o1': 'Tylko mój region',
  'prism.questions.q3o2': 'W całym kraju',
  'prism.questions.q3o3': 'Bez znaczenia',
  'prism.questions.yes': 'Tak, dokładnie',
  'prism.questions.no': 'Raczej nie',
  'prism.questions.foot': 'Im precyzyjniejsza odpowiedź, tym trafniejsze Twoje pierwsze leady.',
  // Faza wyszukiwania
  'prism.searching.label': 'Znalezione firmy z Twojej grupy docelowej…',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Sprawdzamy dopasowanie wyników…',
  'prism.searching.wait2': 'Odrzucamy słabe trafienia…',
  'prism.searching.wait3': 'Wykrywamy duplikaty…',
  'prism.searching.wait4': 'Sprawdzamy dostępność stron internetowych…',
  'prism.searching.wait5': 'Porównujemy lokalizacje…',
  'prism.searching.wait6': 'Łączymy profile firm…',
  'prism.search.step1': 'Zaplanowane wyszukiwania dla Twojej grupy docelowej',
  'prism.search.step2': 'Zebrane firmy z wyszukiwania w sieci i na mapach',
  'prism.search.step3': 'Usunięte portale, katalogi i duplikaty',
  'prism.search.step4': 'Oceniono dopasowanie najlepszych wyników do Twojej grupy',
  'prism.search.step5': 'Sprawdzone na żywo strony najmocniejszych wyników',
  'prism.search.step6': 'Sprawdzono region i typ firmy najmocniejszych wyników',
  'prism.search.step7': 'Usunięte słabe wyniki',
  'prism.search.step8': 'Sprawdzona wiarygodność wyniku',
  'prism.search.step9': 'Zestawione najlepsze wyniki',
  'prism.search.n.companies': '{count} firm',
  'prism.search.n.ap': '{count} kontaktów',
  'prism.search.n.valid': '{count} ważnych',
  'prism.search.n.revenue': '~{count} mln €',
  'prism.search.n.top': 'Top 50',
  // Etykiety dopasowania
  'prism.score.perfect': 'Idealne dopasowanie',
  'prism.score.outstanding': 'Znakomite dopasowanie',
  'prism.score.veryStrong': 'Bardzo mocne dopasowanie',
  'prism.score.good': 'Dobre dopasowanie',
  'prism.score.titleAttr': 'Wynik dopasowania {score}/100',
  // Ekran doprecyzowania (słabe wyniki)
  'prism.refine.title': 'Jeszcze za mało trafień, doprecyzujmy razem.',
  'prism.refine.body': 'Dla {audience} nie znaleźliśmy jeszcze wystarczająco przekonujących firm.',
  'prism.refine.hint1': 'Doprecyzuj grupę docelową, najlepiej',
  'prism.refine.hintStrong': 'branża + region',
  'prism.refine.hint2':
    '(np. „biura rachunkowe w Warszawie", „gabinety stomatologiczne w Krakowie", „firmy budowlane w Gdańsku"). Im konkretniej, tym więcej prawdziwych firm znajdziemy dla Ciebie.',
  'prism.refine.try': 'Te już dobrze działają, wystarczy jedno kliknięcie:',
  // F9: ekran 429 — dzienny limit, nazwany uczciwie (to nie refine jakości).
  'prism.rateLimit.title': 'Osiągnięto dzienny limit wyszukiwań na żywo.',
  'prism.rateLimit.body':
    'To nie ma nic wspólnego z Twoją grupą docelową — ograniczamy liczbę bezpłatnych wyszukiwań na żywo dziennie. Twoja grupa docelowa i strona pozostają zapisane.',
  'prism.rateLimit.reset': 'Twój limit odnowi się o {time}.',
  'prism.rateLimit.cta': 'Wróć na początek',
  // D2 (LEA-430): wznowienie „witaj z powrotem" + uczciwa alternatywa dla licznika.
  'prism.resume.title': 'Witaj z powrotem!',
  'prism.resume.body': 'Twoje wyszukiwanie dla {audience} jest gotowe — wynik został zapisany.',
  'prism.resume.cta': 'Zobacz wynik',
  'prism.resume.dismiss': 'Rozpocznij nowe wyszukiwanie',
  'prism.resume.saved': 'Twój wybór został zapisany — bez presji czasu.',
  'prism.understood.title': 'Rozumiemy Twoją firmę',
  'prism.understood.opps': 'Szanse',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Dlaczego teraz:',
  // DEPRECATED (Wave 2): "Na co uważać" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'Na co uważać',
  'prism.understood.demoModel': 'Usługa B2B pomagająca MŚP zdobywać nowych klientów.',
  'prism.understood.demoOpp1': 'Wyraźnie określona nisza o wysokiej wartości klienta',
  'prism.understood.demoOpp2': 'Niewielka wyspecjalizowana konkurencja w regionie',
  'prism.understood.demoOpp3': 'Decydenci bezpośrednio dostępni (małe zespoły)',
  'prism.understood.demoRisk1': 'Długie cykle decyzyjne w MŚP',
  'prism.understood.demoRisk2': 'Pierwszy kontakt wymaga konkretnego zaczepienia',
  'prism.seed.badge': 'Pakiet startowy',
  'prism.seed.working': 'Dostarczono {delivered}/{total} leadów',
  'prism.seed.workingSub':
    'To trwa od 10 do 30 minut. Nowe leady pojawiają się automatycznie. Eksportuj najlepiej dopiero, gdy będą wszystkie.',
  'prism.seed.creditsNote':
    'Twoje {total} kredyty startowe są wykorzystywane na bieżąco: 1 kredyt za gotowy lead.',
  'prism.seed.done': 'Wszystkie {delivered} leady są już w Twoim koncie.',
  'prism.seed.donePartial':
    'Dostarczono {delivered} leadów, pozostałe kredyty zostają na Twoim koncie.',
  'prism.refine.cta': 'Doprecyzuj grupę docelową teraz',
  // Wynik (efekt wow)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'firm znalezionych w Twojej grupie docelowej',
  // #4 (Quickwins): wariant spersonalizowany — {audience} przychodzi jako gotowy
  // »cytat« z klienta (nigdy nie odmieniać, gate po stronie klienta).
  'prism.results.foundSuffixAud': 'firm znalezionych dla {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} pasujących do Twojej grupy docelowej',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Poniżej: Twoje najmocniejsze wyniki według dopasowania.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "zweryfikowanych na żywo" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'z czego zweryfikowanych na żywo, Twoje najmocniejsze',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': '{count} z nich już zweryfikowaliśmy na żywo',
  'prism.results.unlockHint': 'Odblokuj',
  'prism.results.unlockOffer': 'pasujące firmy ({n}) za 49 €',
  'prism.results.disclaimer':
    'Szacunek potencjału rynku na podstawie Twojej analizy na żywo, dokładnie takie firmy znajdziemy dla Ciebie.',
  'prism.results.stat.checked': 'znalezionych firm',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'pasujących do Twojej grupy docelowej',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'firm na Twoim rynku (szacunek)',
  'prism.results.stat.avgFit': 'Śr. wynik dopasowania Twoich najmocniejszych trafień',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'możliwych do znalezienia kontaktów',
  'prism.results.stat.revenue': 'potencjał przychodów grupy',
  'prism.results.chart.sizeTitle': 'Firmy według wielkości',
  'prism.results.chart.sizeMuted': 'w Twojej grupie docelowej',
  'prism.results.chart.emp1': '1–9 os.',
  'prism.results.chart.emp2': '10–49 os.',
  'prism.results.chart.emp3': '50–199 os.',
  'prism.results.chart.emp4': '200+ os.',
  'prism.results.chart.qualityTitle': 'Jakość danych Twoich leadów',
  'prism.results.chart.qualityMuted': 'sprawdzona dzisiaj',
  'prism.results.chart.mail': 'Zweryf. e-mail',
  'prism.results.chart.dial': 'Numer bezpośredni',
  'prism.results.chart.decider': 'Osoby decyzyjne',
  'prism.results.insights.title': 'Potencjał i timing Twojej grupy docelowej',
  'prism.results.insights.openRate': 'Śr. wskaźnik otwarć zweryfikowanych maili B2B',
  'prism.results.insights.bestTimeValue': 'wt–czw · 9–11',
  'prism.results.insights.bestTime': 'Najlepszy czas kontaktu w tej branży',
  'prism.results.insights.dealValue': 'Śr. wartość zamówienia na pozyskanego klienta',
  'prism.results.insights.competitionValue': 'niska',
  'prism.results.insights.competition': 'Konkurencja w cold outreach w Twoim regionie',
  'prism.results.why.title': 'Dobry moment:',
  'prism.results.why.p1': 'W Twojej grupie docelowej ostatnio pojawiło się',
  'prism.results.why.strong': 'o 18% więcej nowych osób decyzyjnych',
  'prism.results.why.p2': ', idealna faza na pierwszy kontakt, zanim konkurencja zrobi to samo.',
  'prism.results.timing.title': 'Dlaczego to właśnie teraz jest najlepszy moment',
  'prism.results.timing.legend': 'Najlepsza faza kontaktu w Twojej grupie: teraz',
  'prism.timing.text':
    'W {month} osiągalność w grupie {who} jest z doświadczenia najwyższa: budżety na kolejny kwartał są właśnie planowane, a osoby decyzyjne odbierają telefony. Kto odezwie się teraz, będzie pierwszy, zanim w {next} ruszy konkurencja.',
  // Miesiące (wykres sezonowości + tekst o timingu)
  'prism.month.now': 'Teraz',
  'prism.month.short.1': 'sty',
  'prism.month.short.2': 'lut',
  'prism.month.short.3': 'mar',
  'prism.month.short.4': 'kwi',
  'prism.month.short.5': 'maj',
  'prism.month.short.6': 'cze',
  'prism.month.short.7': 'lip',
  'prism.month.short.8': 'sie',
  'prism.month.short.9': 'wrz',
  'prism.month.short.10': 'paź',
  'prism.month.short.11': 'lis',
  'prism.month.short.12': 'gru',
  'prism.month.long.1': 'styczniu',
  'prism.month.long.2': 'lutym',
  'prism.month.long.3': 'marcu',
  'prism.month.long.4': 'kwietniu',
  'prism.month.long.5': 'maju',
  'prism.month.long.6': 'czerwcu',
  'prism.month.long.7': 'lipcu',
  'prism.month.long.8': 'sierpniu',
  'prism.month.long.9': 'wrześniu',
  'prism.month.long.10': 'październiku',
  'prism.month.long.11': 'listopadzie',
  'prism.month.long.12': 'grudniu',
  // Darmowy lead
  'prism.freelead.tag': 'Twój pierwszy lead, na nasz koszt',
  'prism.freelead.verified': 'zweryfikowany',
  'prism.freelead.lockedChip': '🔒 Osoba kontaktowa i dane kontaktowe po odblokowaniu',
  'prism.freelead.note1': 'Tak wygląda',
  'prism.freelead.noteStrong': 'każda',
  'prism.freelead.note2':
    'z Twoich pasujących firm ({n}): prawdziwa osoba kontaktowa z e-mailem lub telefonem. Pozostałe firmy odblokujesz w następnym kroku.',
  'prism.freelead.alt1': 'Ta firma pasuje do Twojej grupy docelowej. Po odblokowaniu dodajemy',
  'prism.freelead.altStrong': 'prawdziwe osoby kontaktowe z e-mailem lub telefonem',
  'prism.freelead.alt2': ', dla każdej z nich.',
  // Wiersze leadów
  'prism.lead.ap': 'Osoby kontaktowe',
  'prism.lead.inclDeciders': 'po odblokowaniu',
  'prism.results.moreStrong': '≈{count} kolejnych',
  'prism.results.moreRest': 'znalezionych. Kontakty wyszukujemy po odblokowaniu.',
  'prism.results.planTitle': 'Twój startowy plan akwizycji:',
  'prism.results.planBody':
    'najpierw najmocniejsze firmy ({n}), osoby kontaktowe z e-mailem lub telefonem, do eksportu jako CSV lub Excel.',
  'prism.results.cta': 'Odblokuj pasujące firmy: {n}',
  'prism.results.detailsLink': 'Co dokładnie zawiera oferta?',
  'prism.results.foot':
    '49 € dzisiaj · pasujące firmy: {n} · od 4. dnia: 290 €/mies., rezygnacja w każdej chwili',
  // Paywall
  'prism.paywall.step2': 'Odblokuj',
  'prism.paywall.step3': 'Do dzieła',
  'prism.paywall.resPrefix': 'Twoje',
  'prism.paywall.resStrong': '50 leadów',
  'prism.paywall.resSuffix': 'jest dla Ciebie zarezerwowane',
  'prism.paywall.resExpired':
    'Rezerwacja wygasła, jeszcze przez chwilę trzymamy Twoje wyszukiwanie.',
  'prism.paywall.eyebrow': '{count} znalezionych firm, gotowych do odblokowania',
  'prism.paywall.title1': 'Odblokuj',
  'prism.paywall.titleGrad': 'pasujące firmy ({n})',
  'prism.paywall.title2': 'już teraz.',
  // #4 (Quickwins): spersonalizowany wariant H1 ({audience} = gotowy »cytat«).
  'prism.paywall.title2Aud': 'dla {audience} już teraz.',
  'prism.paywall.sub1': 'Znaleźliśmy',
  'prism.paywall.subStrong1': '{count} firm',
  'prism.paywall.sub2': 'dla {audience}.',
  'prism.paywall.subStrong2': 'Najmocniejsze ({n})',
  'prism.paywall.sub3':
    'czekają na Ciebie. Osoby kontaktowe i dane kontaktowe wyszukujemy po odblokowaniu.',
  // Sejf z leadami
  'prism.vault.title': 'Twoje najmocniejsze firmy ({n}) są gotowe',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (zweryfikowane na żywo), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'Z {count} znalezionych firm dla {audience}, oto Twoje najmocniejsze ({n}). Osoby kontaktowe i dane kontaktowe wyszukujemy po odblokowaniu.',
  'prism.vault.locked': 'zablokowane',
  'prism.vault.blurEmail': 'kontakt@firma.pl',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ {count} kolejnych znalezionych firm, zablokowane',
  'prism.vault.cta': 'Odblokuj pasujące firmy ({n}): 49 €',
  'prism.vault.reassure': '49 € dzisiaj · od 4. dnia: 290 €/mies. · rezygnacja w każdej chwili',
  // Karta założyciela + wideo
  'prism.founder.head': 'Osobista wiadomość od założyciela',
  'prism.founder.quote':
    '„Cześć, jestem Janik. Przez cały okres testowy opiekuję się Tobą osobiście, a start celowo oferujemy w niskiej cenie, żebyś mógł spokojnie wypróbować Leadscraper. Daj nam szansę: jestem pewien, że do siebie pasujemy."',
  'prism.founder.role': 'Założyciel · Leadscraper',
  'prism.video.playAria': 'Odtwórz wideo demo',
  'prism.video.chip': 'Demo na żywo · 10:04',
  'prism.video.title': 'Zobacz, jak Janik znajduje Twoje pierwsze leady',
  'prism.video.cta': 'Obejrzyj demo: prawdziwe wyszukiwanie, prawdziwy panel',
  'prism.video.iframeTitle': 'Demo na żywo · Leadscraper',
  // Oś czasu (jak przebiega test)
  'prism.timeline.title': 'Tak przebiega Twój 3-dniowy test',
  'prism.timeline.today': 'Dzisiaj',
  'prism.timeline.todayStrong': '49 € dzisiaj',
  'prism.timeline.todayRest': ': pasujące firmy ({n}) odblokowane, na Twoim koncie w ciągu 10–30 minut.',
  'prism.timeline.days13': 'Dni 1–3',
  'prism.timeline.testP1': 'Testujesz na prawdziwych leadach.',
  'prism.timeline.testStrong': '3 dni czasu',
  'prism.timeline.testP2': ', jeśli nie pasuje, rezygnujesz jednym kliknięciem, ani centa więcej.',
  'prism.timeline.day4': 'Od 4. dnia',
  'prism.timeline.aboP1': 'Potem Twój plan działa dalej z',
  'prism.timeline.aboStrong': '250 kredytami za 290 €/mies.',
  'prism.timeline.aboP2': ' — rezygnacja w każdej chwili.',
  // Blok porównawczy
  'prism.versus.title': 'Dlaczego Leadscraper, a nie zwykła droga',
  'prism.versus.oldTitle': 'Zwykła droga',
  'prism.versus.old1': 'Godziny ręcznego googlowania albo kupowanie przestarzałych list',
  'prism.versus.old2': 'Wysoki bounce rate, szara strefa RODO',
  'prism.versus.old3': 'Mozolne samodzielne szukanie osób kontaktowych',
  'prism.versus.old4': '1 000–1 500 €/mies. + umowa roczna (Cognism, Dealfront)',
  'prism.versus.old5': 'Tygodnie do pierwszej odpowiedzi',
  'prism.versus.newTitle': 'Z Leadscraperem',
  'prism.versus.new1': 'Pasujące firmy ({n}) w ciągu 10–30 minut, dobrane do Twojej grupy docelowej',
  'prism.versus.new2': 'E-maile sprawdzone technicznie, telefon jeśli dostępny',
  'prism.versus.new3': 'Osoby kontaktowe dostarczone od razu',
  'prism.versus.new4': 'Test za 49 € · rezygnacja co miesiąc · bez umowy rocznej',
  'prism.versus.new5': 'Dziś eksportujesz, jutro piszesz',
  'prism.versus.foot1': 'Ta sama praca, za którą inni płacą',
  'prism.versus.footStrong1': 'tygodniami',
  'prism.versus.foot2': 'i',
  'prism.versus.footStrong2': 'ponad 1 000 €/mies.',
  'prism.versus.foot3': ', u Ciebie dzisiaj, na próbę za',
  'prism.versus.footStrong3': '49 €',
  // Panel ROI
  'prism.roi.title': 'Co dają Ci Twoje pasujące firmy ({n})',
  'prism.roi.row1': 'Leady z osobami kontaktowymi, gotowe w ciągu 10–30 minut',
  'prism.roi.row2': 'Twój koszt dziś',
  'prism.roi.row3': 'Już 1 pozyskany klient zwraca',
  'prism.roi.row3v': 'wielokrotność stawki',
  'prism.roi.hl1': 'Jeden',
  'prism.roi.hlStrong': 'jedyny',
  'prism.roi.hl2':
    'klient z Twoich pasujących firm ({n}) zwraca te 49 € wielokrotnie, wszystko dalej to czysta przewaga.',
  'prism.roi.perLead': 'za gotowy lead',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'zamiast tygodni researchu',
  'prism.roi.stat3v': '3 dni',
  'prism.roi.stat3': 'testu przed startem abonamentu',
  // Karta cenowa
  'prism.plan.badge': 'Oferta startowa · 3 dni testu',
  'prism.plan.leadsUnit': '– liczba pasujących firm · osoby kontaktowe w ciągu 10–30 minut',
  'prism.plan.anchor': 'Własny research: ~10 godz. ręcznej pracy',
  'prism.plan.priceSuffix': 'dzisiaj',
  'prism.price.netVat': 'plus VAT',
  'prism.plan.perLeadStrong': 'poniżej 1 €',
  'prism.plan.f1': 'E-maile sprawdzone technicznie, telefon jeśli dostępny',
  'prism.plan.f2': 'Osoby kontaktowe dla każdej firmy, jeśli są publicznie dostępne',
  'prism.plan.f3': 'Eksport do CSV lub Excel, możliwe połączenie z CRM',
  'prism.plan.cta': 'Odblokuj teraz: 49 €',
  'prism.plan.secure': 'Bezpieczna płatność przez Stripe · szyfrowanie SSL',
  'prism.plan.subnote': 'Rezygnacja w każdej chwili jednym kliknięciem na koncie.',
  'prism.plan.gbCondition': 'Warunki gwarancji: zob. § 7',
  'prism.guarantee.title': 'Gwarancja zwrotu pieniędzy',
  'prism.guarantee.sub':
    'W ciągu 3 dni testu zwracamy Ci 49 €: napisz na support@leadscraper.eu, wypełnij nasz krótki formularz opinii, a wraz ze zwrotem zakończymy Twój abonament. Tylko dla tej oferty startowej.',
  'prism.legal.agb': 'Regulamin',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/pl/regulamin',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/pl/polityka-prywatnosci',
  'prism.legal.privacy': 'Polityka prywatności',
  // Pasek opinii (cytaty klientów celowo pozostają nieprzetłumaczone)
  'prism.reviews.title': 'Zespoły sprzedaży, które już się przesiadły',
  // Pasek zaufania
  'prism.trust.payStrong': '49 € dzisiaj',
  'prism.trust.payRest': '· karta, PayPal, Apple & Google Pay · bezpiecznie przez Stripe',
  'prism.trust.cancelStrong': 'Rezygnacja w każdej chwili',
  'prism.trust.cancelRest': '· jednym kliknięciem na koncie, bez okresu wypowiedzenia, bez pytań',
  'prism.trust.dataStrong': 'Tylko dane publiczne',
  'prism.trust.dataRest': '· RODO by design · serwery w UE',
  // FAQ
  'prism.faq.title': 'Najczęstsze pytania',
  'prism.faq.q1': 'Co się dzieje po 3 dniach?',
  'prism.faq.a1':
    'Od 4. dnia Twój plan działa dalej z 250 kredytami za 290 €/mies., rezygnacja w każdej chwili jednym kliknięciem. Decydujesz więc spokojnie w ciągu 3 dni.',
  'prism.faq.q2': 'Czy mogę zrezygnować w każdej chwili?',
  'prism.faq.a2':
    'Tak, co miesiąc: wystarczy jedno kliknięcie na koncie, bez okresu wypowiedzenia i bez pytań. Jeśli zrezygnujesz w ciągu 3 dni testu, płacisz tylko 49 €. Później dostęp działa do końca opłaconego miesiąca.',
  'prism.faq.q3': 'Skąd pochodzą leady, czy to zgodne z RODO?',
  'prism.faq.a3':
    'Wyłącznie z publicznie dostępnych danych firmowych. RODO by design: przetwarzanie i serwery wyłącznie w UE.',
  'prism.faq.q4': 'Co, jeśli leady nie będą pasować?',
  'prism.faq.a4':
    'W ciągu 3 dni testu zwracamy Ci 49 €, jeśli wypełnisz nasz krótki formularz opinii (regulamin § 7). Napisz na support@leadscraper.eu; wraz ze zwrotem zakończymy Twój abonament. Potem zwrot nie jest już możliwy, ale abonament możesz anulować w każdej chwili.',
  'prism.faq.q5': 'Czy dostanę prawdziwe osoby kontaktowe?',
  'prism.faq.a5':
    'Tak: dla każdej firmy wyszukane osoby kontaktowe z adresem e-mail lub numerem telefonu. Adresy e-mail są sprawdzane technicznie; nie możemy zagwarantować, że każda skrzynka istnieje. Jeśli dla firmy nie uda się znaleźć osiągalnego kontaktu, nic za nią nie naliczamy.',
  // Linia założyciela
  'prism.founderline.strong': 'Firma prowadzona przez właściciela, z Hamburga',
  'prism.founderline.rest': ', Janik Deimann, założyciel',
  'prism.founderline.sub': 'Deimann Com GmbH · U nas rozmawiasz z ludźmi, nie z kolejką ticketów.',
  'prism.founderline.ask': 'Masz wątpliwości? Napisz: support@leadscraper.eu, odpowiada człowiek.',
  // Stały pasek zakupu
  'prism.sticky.leads': 'Pasujące firmy: {n} ·',
  'prism.sticky.today': 'dzisiaj · od 4. dnia: 290 €/mies.',
  'prism.sticky.cta': 'Odblokuj teraz',
  // Wbudowana płatność
  'prism.checkout.eyebrow': 'Oferta startowa · 49 € dzisiaj',
  'prism.checkout.title': 'Pasujące firmy: {n} · odblokuj teraz',
  'prism.checkout.sumPrice': '49 € dzisiaj',
  'prism.checkout.sumDesc': 'Pasujące firmy ({n}) odblokowane, 3 dni testu',
  'prism.checkout.after': 'od 4. dnia',
  'prism.checkout.monthly': '290 € / mies.',
  'prism.checkout.reassure3d':
    'Jeśli zrezygnujesz w ciągu 3 dni, zapłacisz tylko 49 €. Leady zostają u Ciebie: także później możesz je przeglądać i eksportować.',
  'prism.checkout.deliverNote':
    'W tym wyszukiwaniu czeka {count} pasujących firm. Kredyt liczy się tylko wtedy, gdy znajdziemy osobę kontaktową; resztę z 50 kredytów wykorzystasz na kolejne wyszukiwania.',
  'prism.checkout.cancelNote': 'Subskrypcję anulujesz w każdej chwili, jednym kliknięciem.',
  'prism.checkout.invite':
    'Zapraszamy: 50 leadów jednorazowo po kosztach, tylko na start, żebyś mógł przetestować Leadscraper bez ryzyka.',
  'prism.checkout.or': 'albo kartą',
  'prism.checkout.tabCard': 'Karta',
  'prism.checkout.tabSepa': 'Polecenie zapłaty SEPA',
  'prism.checkout.cardholder': 'Właściciel karty',
  'prism.checkout.cardholderPh': 'Jan Kowalski',
  'prism.checkout.cardNumber': 'Numer karty',
  'prism.checkout.expiry': 'Ważność',
  'prism.checkout.expiryPh': 'MM / RR',
  'prism.checkout.country': 'Kraj',
  'prism.checkout.countryDe': 'Niemcy',
  'prism.checkout.countryAt': 'Austria',
  'prism.checkout.countryCh': 'Szwajcaria',
  'prism.checkout.paying': 'Aktywuję…',
  'prism.checkout.embedLoading': 'Ładowanie bezpiecznej płatności …',
  'prism.checkout.payCta': 'Odblokuj pasujące firmy ({n}): 49 €',
  'prism.checkout.securePrefix': 'Bezpieczna płatność przez',
  'prism.checkout.secureSuffix': '· szyfrowanie SSL',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Przejdź do płatności", not "Odblokuj 50 leadów".
  'prism.checkout.fine1': 'Klikając przycisk powyżej, akceptujesz',
  'prism.checkout.fine2':
    'oraz automatyczne przedłużenie na abonament Starter (250 kredytów / 290 € miesięcznie) od 4. dnia, rezygnacja w każdej chwili jednym kliknięciem. Oferta skierowana wyłącznie do przedsiębiorców (B2B, § 14 niemieckiego kodeksu cywilnego). Wszystkie ceny netto plus ustawowy VAT. Gwarancja zwrotu pieniędzy: tylko dla tej oferty startowej, tylko w ciągu 3 dni testu i po wypełnieniu formularza opinii (regulamin § 7).',
  // Ekran sukcesu
  'prism.success.title': 'Pasujące firmy ({n}) odblokowane',
  'prism.success.body':
    'Twoje pasujące firmy ({n}) są odblokowane. Osoby kontaktowe dojdą w ciągu 10–30 minut, do eksportu jako CSV/CRM. Od 4. dnia działa abonament Starter (250 kredytów/mies.), z rezygnacją co miesiąc.',
  'prism.success.cta': 'Do dzieła',

  // --- LEA-379 i18n backfill (2026-07-06): keys that previously fell back to
  //     German (packages/i18n index.ts fallback). Machine-translated from EN/DE,
  //     billing/cancel copy pending Janik wording review. ---
  'acct.plan.downgradeScheduled': 'Zaplanowano zmianę planu',
  'acct.plan.downgradeScheduledDetail':
    '{date} przejdziesz na plan {plan}. Do tego czasu zachowujesz obecny plan, a Twoje Credits pozostają.',
  'acct.plan.downgradeCancel': 'Anuluj zmianę planu',
  'acct.plan.downgradeCanceling': 'Anulowanie …',
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-558 — VIP-Einrichtung (990-€-Vergleichswert nur in der Copy).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'Twoja oferta powrotna',
  'acct.winback.body':
    '{plan} z 30% zniżką przez 3 miesiące. W checkoucie zobaczysz cenę i datę obciążenia, zanim cokolwiek się stanie.',
  'acct.winback.cta': 'Przejdź do checkoutu',
  'acct.winback.starting': 'Otwieranie …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle': 'Zanim zrezygnujesz — może któraś z tych opcji pasuje lepiej',
  'acct.cancel.save.offerSub': 'Bez presji. Rezygnacja wciąż jest o jedno kliknięcie.',
  'acct.cancel.pauseMonthsLabel': 'Wstrzymaj na',
  'acct.cancel.pauseMonths1': '1 miesiąc',
  'acct.cancel.pauseMonths': '{n} mies.',
  'acct.cancel.pauseResumeHint':
    'Twoja subskrypcja wznowi się automatycznie {date} — od tego dnia znów pobieramy płatność.',
  'acct.cancel.pausedDetailUntil':
    'Nie pobieramy żadnych opłat. Zachowujesz dostęp i pozostałe kredyty. Subskrypcja wznowi się automatycznie {date}; możesz wznowić ją wcześniej w dowolnym momencie.',
  'acct.cancel.pausedNoteUntil':
    'Wstrzymana do {date}, bez opłat. Twoje kredyty pozostają dostępne.',

  'acct.cancel.trial.vipTitle': 'Janik osobiście skonfiguruje Twoje konto',
  'acct.cancel.trial.vipBody':
    'Grupy docelowe, profile wyszukiwania, pierwsze wyszukiwania — założyciel osobiście skonfiguruje z Tobą konto. Usługa o wartości 990 € — dla Ciebie bezpłatnie, jeśli kontynuujesz test.',
  'acct.cancel.trial.vipCta': 'Poproś o osobistą konfigurację',
  'acct.cancel.trial.vipRequesting': 'Wysyłanie …',
  'acct.cancel.trial.vipDoneTitle': 'Prośba wysłana',
  'acct.cancel.trial.vipDoneBody':
    'Janik odezwie się osobiście w ciągu 24 godzin. Twój okres próbny trwa normalnie — nic nie zostało anulowane ani pobrane.',

  'acct.cancel.save.discountTitle': '30% zniżki przez najbliższe 3 miesiące',
  'acct.cancel.save.discountBody':
    'Zostań i płać 30% mniej przez trzy miesiące — zniżka jest nakładana bezpośrednio na Twoją subskrypcję, karta zostaje bez zmian, bez nowego checkoutu.',
  'acct.cancel.save.discountCta': 'Aktywuj 30% zniżki',
  'acct.cancel.save.discounting': 'Aktywowanie …',
  'acct.cancel.save.discountDoneTitle': 'Zniżka aktywna',
  'acct.cancel.save.discountDoneBody':
    'Twoje najbliższe trzy miesięczne faktury będą niższe o 30%. Potem plan działa w normalnej cenie — nadal możesz zrezygnować w każdej chwili jednym kliknięciem.',

  'acct.cancel.trial.interceptTitle': 'Zaczekaj — Twój okres próbny trwa do {date}.',
  'acct.cancel.trial.interceptTitleNoDate': 'Zaczekaj — Twój okres próbny wciąż trwa.',
  'acct.cancel.trial.interceptSub': 'Do tego czasu nic nie zostanie pobrane.',
  'acct.cancel.trial.reminderTitle': 'Przypomnimy Ci w porę',
  'acct.cancel.trial.reminderBody':
    'Nie musisz nic notować ani pamiętać. Napiszemy do Ciebie 24 godziny przed końcem — a jeśli nie zechcesz kontynuować, zrezygnujesz bezpośrednio z tego e-maila.',
  'acct.cancel.trial.reminderPointMail': 'Link do rezygnacji jest bezpośrednio w e-mailu.',
  'acct.cancel.trial.reminderPointNoCharge': 'Wcześniej nic nie zostanie pobrane.',
  'acct.cancel.trial.reminderCta': 'Testuj dalej i przypomnij mi',
  'acct.cancel.trial.keepTestingCta': 'Testuj dalej',
  'acct.cancel.trial.reminderSaving': 'Aktywowanie …',
  'acct.cancel.trial.reminderDoneTitle': 'Przypomnienie jest włączone',
  'acct.cancel.trial.reminderDoneBody':
    'Napiszemy do Ciebie {date} — 24 godziny przed końcem okresu próbnego, z linkiem do rezygnacji bezpośrednio w e-mailu.',
  'acct.cancel.trial.reminderDoneBodyNoDate':
    'Napiszemy do Ciebie 24 godziny przed końcem okresu próbnego, z linkiem do rezygnacji bezpośrednio w e-mailu.',
  'acct.cancel.trial.cancelNowLink': 'Zrezygnuj ostatecznie',
  'acct.cancel.trial.confirm.endsNow':
    'Dostęp próbny kończy się natychmiast — nie w dniu wygaśnięcia.',
  'acct.cancel.trial.confirm.forfeits':
    'Twoje profile wyszukiwania i pozostałe kredyty przepadają.',
  'acct.cancel.trial.confirm.noCharge': 'Nic nie zostanie pobrane.',
  'acct.cancel.trial.done.title': 'Okres próbny zakończony',
  'acct.cancel.trial.done.body':
    'Twój okres próbny dobiegł końca i nic nie zostało pobrane. Jeśli zmienisz zdanie, w każdej chwili możesz wykupić abonament.',

  'acct.cancel.trigger': 'Anuluj subskrypcję',
  'acct.cancel.manageHint': 'Zarządzaj subskrypcją',
  'acct.cancel.scheduledTitle': 'Zaplanowano anulowanie',
  'acct.cancel.scheduledDetail':
    'Twoja subskrypcja kończy się {date}. Do tego czasu zachowujesz pełny dostęp.',
  'acct.cancel.reactivate': 'Cofnij anulowanie',
  'acct.cancel.reactivating': 'Cofanie …',
  'acct.cancel.restored': 'Subskrypcja przywrócona. Twój plan działa dalej.',
  'acct.cancel.title': 'Anuluj subskrypcję',
  'acct.cancel.stepOf': 'Krok {n} z {total}',
  'acct.cancel.reasonTitle': 'Dlaczego chcesz anulować?',
  'acct.cancel.reasonSub': 'Opcjonalnie: Twoja odpowiedź pomaga nam ulepszać Leadscraper.',
  'acct.cancel.reason.too_expensive': 'Zbyt drogo',
  'acct.cancel.reason.too_few_leads': 'Za mało (dobrych) Leads',
  'acct.cancel.reason.wrong_contacts': 'Niewłaściwe osoby kontaktowe',
  'acct.cancel.reason.unreliable_data': 'Niewiarygodne maile/dane kontaktowe',
  'acct.cancel.reason.too_complicated': 'Zbyt skomplikowane',
  'acct.cancel.reason.missing_feature': 'Brakuje funkcji',
  'acct.cancel.reason.temporary_only': 'Potrzebne tylko tymczasowo',
  'acct.cancel.reason.switched_tool': 'Przechodzę na inne narzędzie',
  'acct.cancel.reason.other': 'Inne',
  'acct.cancel.freeTextPlaceholder': 'Napisz nam więcej (opcjonalnie) …',
  'acct.cancel.save.downgradeTitle': 'Może pasuje mniejszy plan?',
  'acct.cancel.save.downgradeBody':
    'Zamiast anulować, możesz przejść na tańszy plan, zachowujesz swoje Credits i płacisz mniej od następnego cyklu.',
  'acct.cancel.save.downgradeCta': 'Zobacz tańsze plany',
  'acct.cancel.save.downgradeOffer':
    'Przejdź na {plan} · {price}\u00A0€/miesiąc · {leads} Leads/miesiąc. Zachowujesz swoje Credits i płacisz mniej od następnego cyklu.',
  'acct.cancel.save.downgradeCtaPlan': 'Przejdź na {plan}',
  'acct.cancel.save.downgrading': 'Zmienianie …',
  'acct.cancel.save.seeAllPlans': 'Zobacz wszystkie plany',
  'acct.cancel.save.helpTitle': 'Naprawmy to razem',
  'acct.cancel.save.helpBody':
    'Wiele z tego właśnie aktywnie ulepszamy. Napisz nam krótko, czego zabrakło, często potrafimy szybko dostroić Twoje wyszukiwanie.',
  'acct.cancel.confirm.accessUntil': 'Zachowujesz pełny dostęp do {date}.',
  'acct.cancel.confirm.noCharge': 'Po tym terminie nie będziemy pobierać żadnych opłat.',
  'acct.cancel.confirm.reactivate': 'Możesz cofnąć anulowanie w każdej chwili przed tym terminem.',
  'acct.cancel.audit.title': 'Jeszcze jedna rzecz (opcjonalnie)',
  'acct.cancel.audit.sub': 'Co zadziałało, a co nie? To bezpośrednio wpływa na nasze ulepszenia.',
  'acct.cancel.audit.rightCompanies': 'Właściwe firmy?',
  'acct.cancel.audit.rightContacts': 'Właściwe osoby kontaktowe?',
  'acct.cancel.audit.contactDataUsable': 'E-mail/telefon/LinkedIn użyteczne?',
  'acct.cancel.audit.enoughLeads': 'Wystarczająco Leads?',
  'acct.cancel.audit.helpedWin': 'Czy pomogło Ci to pozyskać klientów?',
  'acct.cancel.audit.good': 'Dobrze',
  'acct.cancel.audit.bad': 'Słabo',
  'acct.cancel.lead.title': 'Który lead Cię rozczarował? (opcjonalnie)',
  'acct.cancel.lead.sub': 'Jeśli konkretny lead nie pasował, wskazanie go pomoże nam najbardziej.',
  'acct.cancel.lead.pick': 'Wybierz lead',
  'acct.cancel.lead.loading': 'Ładowanie …',
  'acct.cancel.lead.none': 'Nie znaleziono dostarczonych Leads.',
  'acct.cancel.cf.title': 'Pomóż nam być lepszymi (opcjonalnie)',
  'acct.cancel.cf.gapPlaceholder': 'Czego potrzebowałeś, a czego nie mogliśmy dostarczyć?',
  'acct.cancel.cf.toolPlaceholder': 'Przechodzisz na inne narzędzie? Na jakie?',
  'acct.cancel.cf.betterPlaceholder': 'Co robi lepiej?',
  'acct.cancel.justCancel': 'Anuluj teraz',
  'acct.cancel.keep': 'Jednak zostaję',
  'acct.cancel.next': 'Dalej',
  'acct.cancel.back': 'Wstecz',
  'acct.cancel.stillCancel': 'Mimo to anuluj',
  'acct.cancel.confirmBtn': 'Potwierdź anulowanie',
  'acct.cancel.confirming': 'Anulowanie …',
  'acct.cancel.done.title': 'Anulowanie potwierdzone',
  'acct.cancel.done.body':
    'Twoja subskrypcja kończy się {date}. Do tego czasu zachowujesz pełny dostęp, i możesz cofnąć anulowanie w każdej chwili przed tym terminem.',
  'acct.cancel.done.close': 'Zamknij',
  'acct.cancel.save.pauseTitle': 'Wolisz wstrzymać niż anulować?',
  'acct.cancel.save.pauseBody':
    'Zamroź subskrypcję zamiast ją anulować, bez opłat, Twoje Credits i dane pozostają, a wznowisz w każdej chwili jednym kliknięciem.',
  'acct.cancel.save.pauseCta': 'Wstrzymaj subskrypcję',
  'acct.cancel.save.pausing': 'Wstrzymywanie …',
  'acct.cancel.pauseTrigger': 'Wstrzymaj',
  'acct.cancel.pausing': 'Wstrzymywanie …',
  'acct.cancel.pausedBadge': 'Wstrzymane',
  'acct.cancel.pausedNote':
    'Subskrypcja wstrzymana, bez opłat. Twoje Credits pozostają do wykorzystania.',
  'acct.cancel.pausedTitle': 'Subskrypcja wstrzymana',
  'acct.cancel.pausedDetail':
    'Nie pobieramy żadnych opłat. Zachowujesz dostęp i pozostałe Credits. Wznów w każdej chwili.',
  'acct.cancel.resume': 'Wznów subskrypcję',
  'acct.cancel.resuming': 'Wznawianie …',
  'billing.errorRetry': 'Spróbuj ponownie',
  'billing.transientError': 'Chwilowo niedostępne. Spróbuj ponownie za moment.',
  'billing.downgradeScheduled':
    'Zaplanowano zmianę planu: {date} przejdziesz na plan {plan}. Twoje Credits pozostają.',
  'billing.downgradeAlready': 'Zmiana na plan {plan} jest już zaplanowana na {date}.',
  'crm.section.available': 'Dostępne',
  'crm.section.comingNext': 'Wkrótce',
  'crm.section.comingNextLabel': 'Wkrótce',
  'crm.section.connected': 'Połączone',
  'dash.run.suggHeading': 'Przykładowe wyszukiwania dla Twojej firmy',
  'dash.run.intent.broad': 'Klasyczne',
  'dash.run.intent.growth': 'Sygnał wzrostu',
  'dash.run.intent.tool': 'Sygnał narzędzia',
  'dash.run.intent.default': 'Propozycja',
  'dash.run.costPreview': 'do {n} Credits',
  'det.sourcesPending':
    'Dowody źródłowe dla tego leada są wciąż zestawiane, pojawią się tutaj, gdy tylko zostaną zweryfikowane.',
  'ld.contactPhoneUnknown': 'Numer bezpośredni nie jest publiczny',
  'ld.contact.emailCopied': 'Adres e-mail skopiowany.',
  'ld.contact.phoneCopied': 'Numer telefonu skopiowany.',
  'ld.contact.copy': 'Kopiuj',
  'ld.contact.copied': 'Skopiowano.',
  'ld.contact.tagCentral': 'Centrala',
  'ld.contact.tagUnconfirmed': 'niepotwierdzone',
  'ld.contact.tagPattern': 'Wzorzec',
  'ld.contact.centralTooltip': 'Numer bezpośredni nie jest publiczny, zadzwoń i poproś o {name}.',
  'ld.contact.centralTooltipNoName':
    'Numer bezpośredni nie jest publiczny, tak dodzwonisz się do centrali.',
  'ld.contact.verifiedSmtp': 'Skrzynka e-mail potwierdzona (SMTP).',
  'ld.contact.unverifiedHint': 'Pobrane z publicznego źródła, jeszcze nie sprawdzone przez SMTP.',
  'ld.contact.patternTooltip':
    'Prawdopodobny adres na podstawie firmowego wzorca e-mail, niepotwierdzony.',
  'ld.contact.derivePattern': 'Wyprowadź e-mail z firmowego wzorca',
  'ld.contact.bestRoute': 'Najlepsza droga:',
  'ld.contact.route.central': 'Zadzwoń przez centralę',
  'ld.contact.route.centralEmail': 'Napisz e-mail do centrali',
  'ld.contact.route.linkedin': 'Wiadomość na LinkedIn',
  'ld.contact.route.xing': 'Wiadomość na Xing',
  'ld.contact.route.phone': 'Zadzwoń (numer bezpośredni)',
  'ld.contact.route.email': 'E-mail',
  'ld.contact.route.pattern': 'E-mail według firmowego wzorca',
  'ld.contact.provMailbox': 'Skrzynka potwierdzona',
  'ld.contact.provImpressum': 'Wymieniony w Impressum',
  'ld.contact.provFound': 'Znaleziony w publicznych źródłach',
  'ld.contact.provVia': 'potwierdzony przez',
  'ld.contact.confHigh': 'Wysoka',
  'ld.contact.confMid': 'Średnia',
  'ld.contact.confLow': 'Niska',
  'ld.contact.photoVia': 'Zdjęcie: {src} ↗',
  'ld.contact.roleProof': 'Rola potwierdzona publicznie ↗',
  'ld.section.roleFallback':
    'Wybrana rola ({roles}) nie jest publicznie potwierdzona, pokazujemy kolejne najlepsze osoby kontaktowe.',
  'ld.section.noDirect': 'Kontakty bezpośrednie nie są tu publiczne, osiągalne przez centralę.',
  'ld.toast.accepted': '„{company}" zapisano jako pasujący.',
  'ld.toast.feedbackErr': 'Nie udało się zapisać opinii. Spróbuj ponownie.',
  'ld.toast.rejected': '„{company}" oznaczono jako niepasujący.',
  'ld.unverified.body':
    'Ogólne dopasowanie branżowe: specjalizacja nie została wspomniana w treści strony. Jeśli jest bezwzględnie potrzebna, doprecyzuj zapytanie (np. „sklep specjalistyczny {token}").',
  'ld.unverified.title': 'Leadscraper nie mógł zweryfikować „{token}" dla tej firmy',
  'ld.viaCentralPhone': 'Przez centralę',
  'leads.col.phase': 'Faza',
  'lt.expH.legalForm': 'Forma prawna',
  'lt.expH.street': 'Ulica',
  'lt.expH.zip': 'Kod pocztowy',
  'lt.expH.website': 'Strona internetowa',
  'lt.expH.vatId': 'NIP',
  'lt.expH.hr': 'Rejestr handlowy',
  'lt.expH.founded': 'Założona',
  'lt.expH.size': 'Pracownicy',
  'lt.expH.revenue': 'Zakres przychodów',
  'lt.expH.description': 'Opis',
  'lt.expH.techStack': 'Stos technologiczny',
  'lt.expH.triggers': 'Sygnały/Triggery',
  'lt.expH.scoreCompany': 'Score dopasowania firmy',
  'lt.expH.scoreData': 'Jakość danych',
  'lt.expH.seniority': 'Poziom stanowiska',
  'lt.expH.department': 'Dział',
  'lt.expH.phone': 'Telefon',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Kwalifikacja',
  'lt.expH.confidence': 'Pewność',
  'lt.expH.channel': 'Zalecany kanał',
  'lt.filter.all': 'Wszystkie',
  'lt.filter.torate': 'Do oceny',
  'lt.filter.identified': 'Firma dodana',
  'lt.filter.connected': 'Z kontaktami',
  'lt.filter.planned': 'Plan gotowy',
  'lt.filter.archived': 'Zarchiwizowane',
  'lt.view.list': 'Lista',
  'lt.view.listSubheader': 'Tabela: wszystkie kolumny widoczne',
  'lt.funnel.subheader': 'Funnel: Leads pogrupowane według fazy',
  'lt.funnel.addCompany': 'Dodaj firmę',
  'lt.funnel.add': 'Dodaj',
  'lt.funnel.addTooltip': 'Dodaj firmę przez URL · 1 Credit',
  'lt.funnel.pullAllContacts': 'Pobierz wszystkie kontakty',
  'lt.funnel.empty': 'Brak Leads w tej fazie',
  'lt.funnel.dropHint': 'Upuść tutaj, aby rozpocząć fazę',
  'lt.col.planned': 'Plan akwizycji gotowy',
  'lt.card.new': 'Nowe',
  'lt.card.viewPlan': 'Zobacz plan',
  'lt.card.findContacts': 'Znajdź osoby kontaktowe',
  'lt.card.createPlan': 'Utwórz plan akwizycji',
  'lt.card.contactsCount': '{n} osób kontaktowych',
  'lt.card.fitTooltip':
    'Dopasowanie {score}%: jak dobrze ta firma pasuje do Twojej grupy docelowej',
  'lt.card.noContacts': 'Brak osób kontaktowych',
  'lt.card.noJustification':
    'Brak uzasadnienia Cortex: lead zostanie wzbogacony przy następnym uruchomieniu.',
  'lt.card.rejectTitle': 'Oznacz jako niepasujący',
  'lt.card.rejectAria': 'Oznacz {company} jako niepasujący',
  'lt.card.openWebsite': 'Otwórz {website}',
  'lt.loading.connecting': 'Szukanie osób kontaktowych …',
  'lt.loading.planning': 'Generowanie planu akwizycji …',
  'lt.loading.adding': 'Dodawanie …',
  'lt.loading.verifying': 'Weryfikowanie …',
  'lt.loading.connectingLive': 'Weryfikowanie osób kontaktowych …',
  'lt.loading.planningLive': 'Tworzenie planu akwizycji …',
  'lt.manual.verifyingDesc': 'Weryfikowanie strony, ekstrakcja danych podstawowych …',
  'lt.manual.addedDesc':
    'Dodano przez URL, branża, adres i dane kontaktowe są uzupełniane podczas weryfikacji.',
  'lt.phaseChip.identified': 'Dodane',
  'lt.phaseChip.connected': 'Kontakty',
  'lt.phaseChip.planned': 'Plan gotowy',
  'nav.deleteProfileCta': 'Usuń na stałe',
  'nav.matchRateMin': 'Trafność jest pokazywana od 5 ocen',
  'notif.review.bodyAll': '{n} nieocenionych Leads w {m} grupach docelowych.',
  'np.briefingHelpFooter': 'To nie są pola obowiązkowe, jedynie wskazówka do pola tekstowego.',
  'price.ctaDowngradeScheduled': 'Zmiana już zaplanowana',
  'run.startFailed': 'Nie udało się uruchomić wyszukiwania. Spróbuj ponownie.',
  'email.subscription-paused.subject': 'Twoja subskrypcja jest wstrzymana',
  'email.subscription-paused.badge': 'Subskrypcja wstrzymana',
  'email.subscription-paused.hero': 'Twoja subskrypcja<br>jest wstrzymana.',
  'email.subscription-paused.detail.plan_label': 'Plan',
  'email.subscription-paused.detail.until_label': 'Wstrzymana do',
  'email.subscription-paused.preheader': 'Bez opłat do {{pause_ends_at}}.',
  'email.subscription-paused.greeting': 'Cześć {{first_name}},',
  'email.subscription-paused.intro':
    'Twoja subskrypcja {{plan_name}} jest teraz wstrzymana. Do {{pause_ends_at}} nie pobierzemy żadnej opłaty.',
  'email.subscription-paused.access':
    'Zachowujesz pełny dostęp i pozostałe Credits, po prostu nie otrzymasz nowych miesięcznych Credits.',
  'email.subscription-paused.resume_note':
    '{{pause_ends_at}} Twoja subskrypcja zostanie automatycznie wznowiona. W każdej chwili przed tym terminem możesz ją sam wznowić lub anulować.',
  'email.subscription-paused.button': 'Zarządzaj subskrypcją',
  'email.subscription-paused.signoff': 'Do zobaczenia wkrótce, zespół Leadscraper',
  'email.subscription-pause-ending.subject': 'Twoja subskrypcja wkrótce zostanie wznowiona',
  'email.subscription-pause-ending.preheader': 'Twoja pauza kończy się {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Cześć {{first_name}},',
  'email.subscription-pause-ending.intro':
    'krótkie przypomnienie: Twoja pauza kończy się {{resumes_at}}. Twoja subskrypcja {{plan_name}} zostanie wtedy automatycznie wznowiona.',
  'email.subscription-pause-ending.charge_note':
    'Od tego momentu rozliczenia wracają do normy. Jeśli wolisz nie wznawiać, możesz anulować przed tą datą.',
  'email.subscription-pause-ending.button': 'Zarządzaj subskrypcją',
  'email.subscription-pause-ending.signoff': 'Zespół Leadscraper',
  'scraper.sum.recallUnverified':
    'Dostarczono {n}/10 Leads, badacz AI wystarczył, dlatego pominięto szerokie wyszukiwanie w sieci. Rynek może być znacznie większy niż {total} znalezionych dotąd firm.',
  'scraper.sum.recallUnverifiedRec':
    'To nie jest wąski rynek, to pominięte wyszukiwanie. Poszerzamy odkrywanie, aby zmierzyć rzeczywistą wielkość rynku.',
  'scraper.sum.supplyExhausted':
    'Dostarczono {n}/10 Leads, {dropped} kolejnych trafień otrzymałeś już w poprzednich wyszukiwaniach i zostały odfiltrowane jako duplikaty. Rynek nie jest wąski; po prostu otrzymałeś już większość firm, jakie obecnie potrafimy znaleźć.',
  'scraper.sum.supplyExhaustedRec':
    'Przy powtarzalnych wyszukiwaniach to normalne, nowe firmy pojawiają się z czasem. Aby uzyskać więcej świeżego wolumenu: wybierz szerszy region lub pokrewne branże.',
  'det.emailPatternExampleTag': 'Przykład',
  'det.emailPatternLockedHint': 'Ustalane dla tej firmy, gdy weryfikujesz osoby kontaktowe.',
  'det.email.verified': 'zweryfikowany',
  'det.email.unverified': 'niezweryfikowany',
  'det.linkedinProfile': 'Profil LinkedIn',
  'det.xingProfile': 'Profil Xing',
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Ostatnio się wydarzyło',
  'autopilot.appr.action': 'Zatwierdź',
  'autopilot.appr.givenShort': 'Zatwierdzone',
  'autopilot.appr.opsShort': 'Zatwierdzone przez nas',
  'autopilot.appr.opsFeedback':
    'Sprawdziliśmy to i zatwierdziliśmy, nie musisz nic robić. Jeśli ci odpowiada, możesz to tutaj potwierdzić. Zmiany zgłaszaj bezpośrednio swojej osobie kontaktowej.',
  'autopilot.appr.opsNoAction':
    'Sprawdziliśmy to i zatwierdziliśmy, nie musisz nic robić. Zmiany zgłaszaj bezpośrednio swojej osobie kontaktowej.',
  'autopilot.appr.opsChanged':
    'Treść zmieniła się od twojej opinii z {date}. Sprawdziliśmy i zatwierdziliśmy aktualną wersję.',
  'autopilot.appr.opsConfirm': 'Pasuje mi',
  'autopilot.appr.opsConfirmAsk': 'Zapisać opinię?',
  'autopilot.appr.opsDone': 'Dziękujemy, twoja opinia została zapisana.',
  'autopilot.appr.opsAllDone': 'Wszystko zatwierdzone. Jeśli coś zauważysz, daj nam znać.',
  'autopilot.appr.launchHintOps':
    'Start zatwierdzamy, gdy grupa docelowa, wiadomości i obsługa odpowiedzi zostaną sprawdzone.',
  'autopilot.camp.readonlyOps':
    'Chcesz coś zmienić? Daj znać swojej osobie kontaktowej, a my to poprawimy.',
  'autopilot.appr.pvShow': 'Zobacz',
  'autopilot.appr.pvHide': 'Zwiń',
  'autopilot.appr.pvShowFirst': 'Najpierw sprawdź, co zatwierdzasz',
  'autopilot.appr.pvHeading': 'To zatwierdzasz',
  'autopilot.appr.pvSampleTitle': 'Próbka firm docelowych',
  'autopilot.appr.pvSampleFoot':
    'Próbka Twojej grupy docelowej — pełną listę zobaczysz podczas działania.',
  'autopilot.appr.pvEmpty': 'Przygotowujemy dla Ciebie treść.',
  'autopilot.appr.pvFirms': '{n} firm',
  'autopilot.appr.pvPace': '{n}/dzień',
  'autopilot.appr.pvStart': 'Natychmiast',
  'autopilot.appr.pvWait': '+{d} dni',
  'autopilot.appr.pvSubject': 'Temat:',
  'autopilot.appr.pvAb': 'Wariant A/B:',
  'autopilot.appr.pvLaunchReady':
    'Cała treść jest zatwierdzona — po starcie wychodzi pierwszy e-mail.',
  'autopilot.appr.pvLaunchWait': 'Start odblokuje się, gdy będą trzy powyższe zatwierdzenia.',
  'autopilot.appr.allDone':
    'Wszystko zatwierdzone — uruchamiamy Twoją kampanię i odezwiemy się, gdy tylko ruszy.',
  'autopilot.appr.confirmAsk': 'Zatwierdzić wiążąco?',
  'autopilot.appr.copy': 'Treść wiadomości i sekwencja',
  'autopilot.appr.copyHint':
    'Twoje maile, gotowe do wysyłki — widzisz prawdziwe przykłady, nie szablony.',
  'autopilot.appr.done': 'Zatwierdzenie zarejestrowane — ze znacznikiem czasu i sumą kontrolną.',
  'autopilot.appr.error': 'Zatwierdzenie nie powiodło się — spróbuj ponownie.',
  'autopilot.appr.given': 'Zatwierdzono {date}',
  'autopilot.appr.hash': 'Suma kontrolna',
  'autopilot.appr.icp': 'Grupa docelowa i segment',
  'autopilot.appr.icpHint': 'Do kogo dociera Twój silnik — branże, regiony, decydenci.',
  'autopilot.appr.intro':
    'Ty zatwierdzasz, my realizujemy. Każde zatwierdzenie jest dokumentowane — zachowujesz pełną kontrolę nad grupą docelową, treścią i startem.',
  'autopilot.appr.launch': 'Start kampanii',
  'autopilot.appr.launchHint':
    'Twoja ostateczna zgoda — dopiero po niej pierwszy mail opuszcza system.',
  'autopilot.appr.locked': 'Odblokuje się, gdy pozostałe zgody zostaną udzielone',
  'autopilot.appr.logIntro':
    'Każde zatwierdzenie jest rejestrowane ze znacznikiem czasu; zatwierdzona treść zostaje zablokowana i zabezpieczona sumą kontrolną.',
  'autopilot.appr.logTitle': 'Rejestr zatwierdzeń',
  'autopilot.appr.pending': 'Czeka na Ciebie',
  'autopilot.appr.preparingShort': 'W przygotowaniu',
  'autopilot.appr.preparing':
    'Przygotowujemy treść — powiadomimy Cię, gdy będzie można ją zatwierdzić.',
  'autopilot.appr.playbook': 'Playbook odpowiedzi',
  'autopilot.appr.playbookHint':
    'Jak odpowiadamy na pytania w Twoim imieniu, zanim przekażemy dalej.',
  'autopilot.appr.soon': 'Treść jest właśnie dla Ciebie przygotowywana',
  'autopilot.appr.title': 'Twoje zatwierdzenia',
  'autopilot.camp.approvedAt': 'Zatwierdzone przez Ciebie {date}',
  'autopilot.camp.approvedShort': 'Zatwierdzona — start wkrótce',
  'autopilot.camp.audience': 'Grupa docelowa',
  'autopilot.camp.audienceN': '{n} firm w segmencie',
  'autopilot.camp.awaitApproval': 'Czeka na Twoją zgodę na uruchomienie',
  'autopilot.camp.back': 'Wszystkie kampanie',
  'autopilot.camp.chip.paused': 'Wstrzymana',
  'autopilot.camp.chip.running': 'Aktywna',
  'autopilot.camp.chip.scheduled': 'Zaplanowana',
  'autopilot.camp.hideMail': 'Zwiń',
  'autopilot.camp.nextSend': 'Następna wysyłka {when}',
  'autopilot.camp.open': 'Zobacz',
  'autopilot.camp.pace': 'do {n} maili dziennie przez Twoje skrzynki',
  'autopilot.camp.progress': 'Skontaktowano {done} z {total} firm',
  'autopilot.camp.queue': '{n} sprawdzonych firm w zapasie',
  'autopilot.camp.readonly':
    'Chcesz coś zmienić? Poinformuj swojego opiekuna — każda zmiana wchodzi w życie dopiero po Twojej zgodzie.',
  'autopilot.camp.runningSince': 'aktywna od {date}',
  'autopilot.camp.sReplies': '{n} odpowiedzi',
  'autopilot.camp.sSent': '{n} wysłano',
  'autopilot.camp.sectionRunning': 'Aktualnie aktywne',
  'autopilot.camp.sending': 'Wysyłka',
  'autopilot.camp.sequence': 'Sekwencja',
  'autopilot.camp.sequenceHint':
    'Każdy mail jest unikalny — {{zmienne}} silnik wypełnia indywidualnie dla każdej firmy.',
  'autopilot.camp.showMail': 'Zobacz mail',
  'autopilot.camp.startsAt': 'Start {when}',
  'autopilot.camp.stepStart': 'Początek sekwencji',
  'autopilot.camp.stepWait': '+{n} dni później',
  'autopilot.camp.subject': 'Temat',
  'autopilot.contact.hint':
    'Bezpośredni kontakt, bez systemu zgłoszeń. Wyłącznik awaryjny znajdziesz w sekcji Zatwierdzenia.',
  'autopilot.contact.title': 'Twoja osoba kontaktowa',
  'autopilot.contact.write': 'Napisz wiadomość',
  'autopilot.end.testing': 'Aktualnie w teście: {label}',
  'autopilot.exp.empty':
    'Gdy tylko Twój silnik zacznie testować hipotezy, zobaczysz tutaj, co jest testowane — i dlaczego.',
  'autopilot.exp.since': 'od {date}',
  'autopilot.exp.title': 'Eksperymenty',
  'autopilot.foot.details': 'Szczegóły w sekcji Technika',
  'autopilot.foot.quota': 'Limit {used}/{target}',
  'autopilot.health.amber': 'Pod obserwacją',
  'autopilot.health.blacklistOk': 'Czarne listy czyste',
  'autopilot.health.bounce': 'Wskaźnik odrzuceń {n}%',
  'autopilot.health.green': 'Wszystkie systemy działają prawidłowo',
  'autopilot.health.red': 'Zajmujemy się tym',
  'autopilot.health.suppressed':
    '{n} rezygnacji uwzględnionych, zablokowane we wszystkich kampaniach',
  'autopilot.health.title': 'Stan systemu',
  'autopilot.hist.campaigns': 'Zakończone',
  'autopilot.hist.completed': 'zakończona',
  'autopilot.hist.emptyHint':
    'Gdy tylko Twoja pierwsza kampania ruszy, pojawią się tu bilanse kampanii oraz wyniki zakończonych testów.',
  'autopilot.hist.emptyTitle': 'Brak historii',
  'autopilot.hist.intro':
    'Co się właśnie dzieje, co się już zakończyło — i czego przy tym nauczył się Twój silnik. Przeglądaj i sprawdzaj szczegóły; sterowanie odbywa się poprzez Twoje zatwierdzenia.',
  'autopilot.hist.ongoing': 'w toku',
  'autopilot.hist.running': 'w toku',
  'autopilot.hist.steps': '{n} etapów sekwencji',
  'autopilot.hist.tests': 'Zakończone testy',
  'autopilot.hist.tie': 'Remis',
  'autopilot.hist.title': 'Kampanie',
  'autopilot.hist.vs': 'kontra',
  'autopilot.ho.none': 'Brak otwartych przekazań — silnik pracuje.',
  'autopilot.ho.title': 'Ciepłe przekazania',
  'autopilot.infra.dns': 'Uwierzytelnianie e-mail skonfigurowane (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': 'Domena wysyłkowa zarejestrowana — na Twoje nazwisko',
  'autopilot.infra.mailboxes': 'Skrzynki mailowe skonfigurowane',
  'autopilot.infra.title': 'Twoja infrastruktura',
  'autopilot.infra.verify': 'Domena zweryfikowana i gotowa do wysyłki',
  'autopilot.infra.yourTask': 'Twoje zadanie',
  'autopilot.setup.title': 'Twój engine powstaje',
  'autopilot.setup.intro': 'Co właśnie dla Ciebie budujemy — każdy krok udokumentowany.',
  'autopilot.setup.ev.domain_registered':
    'Domena wysyłkowa {domain} zarejestrowana — na Twoją firmę, to Ty jesteś właścicielem.',
  'autopilot.setup.ev.dns_shield':
    'Siatka bezpieczeństwa DNS dla {domain} aktywna: uwierzytelnianie nadawcy (SPF · DKIM · DMARC) i ochrona anty-spoofingowa.',
  'autopilot.setup.ev.redirect_live':
    '{domain} prowadzi teraz odwiedzających prosto na {target} — pełna przejrzystość dla każdego odbiorcy.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} skrzynek skonfigurowanych na {domain}, zabezpieczonych i zaszyfrowanych.',
  'autopilot.setup.ev.warmup_started':
    'Sieć rozgrzewania uruchomiona: {n} skrzynek dzień po dniu buduje reputację dostarczalności.',
  'autopilot.setup.ev.warmup_progress':
    'Rozgrzewka: dzień {day} z {total} — {rate}% trafień do skrzynki odbiorczej.',
  'autopilot.setup.ev.blacklist_clean':
    'Kontrola reputacji: {n} czarnych list sprawdzonych — wszystko czyste.',
  'autopilot.kpi.contacted': 'Skontaktowani',
  'autopilot.kpi.delivered': 'Dostarczone',
  'autopilot.kpi.handovers': 'Przekazania',
  'autopilot.kpi.lockedHint': 'Liczby pojawią się, gdy Twoja kampania ruszy.',
  'autopilot.kpi.modulePrice': 'Moduł: {price}/miesiąc',
  'autopilot.kpi.replies': 'Odpowiedzi',
  'autopilot.kpi.won': 'Wygrane',
  'autopilot.kpi.wonValueLabel': 'Wartość wygranych zleceń',
  'autopilot.mb.empty': 'Twoje skrzynki są właśnie konfigurowane.',
  'autopilot.mb.hint':
    'Warmup działa nieprzerwanie — nawet w trybie live niski poziom bazowy utrzymuje wysoką dostarczalność.',
  'autopilot.mb.perDay': '{n} maili/dzień',
  'autopilot.mb.score': 'Dostarczalność',
  'autopilot.mb.st.connecting': 'łączenie',
  'autopilot.mb.st.ready': 'gotowe',
  'autopilot.mb.st.sending': 'aktywne · Warmup podtrzymujący',
  'autopilot.mb.st.warmup': 'Warmup · dzień {d}/{total}',
  'autopilot.mb.title': 'Skrzynki i Warmup',
  'autopilot.mb.count': '{active} z {total} aktywnych',
  'autopilot.mb.scoreLabel': 'Wynik dostarczalności',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot to dodatkowy moduł – dowiedz się więcej',
  'autopilot.mode.search': 'Standard',
  'autopilot.nav.history': 'Kampanie',
  'autopilot.nav.overview': 'Dashboard',
  'autopilot.nav.replies': 'Kanban',
  'autopilot.nav.tech': 'Technika',
  'autopilot.notActive.hint': 'Jeśli chcesz korzystać z Autopilota, skontaktuj się z nami.',
  'autopilot.notActive.title': 'Autopilot nie jest aktywny dla tego konta',
  'autopilot.ov.activeTitle': 'Twój silnik działa',
  'autopilot.ov.awaitCta': 'Przejdź do zatwierdzeń',
  'autopilot.ov.awaitHint': 'Brakuje już tylko Twoich zatwierdzeń — potem uruchamiamy wysyłkę.',
  'autopilot.ov.awaitTitle': 'Twój silnik jest gotowy do startu',
  'autopilot.ov.endedTitle': 'Autopilot zakończony',
  'autopilot.ov.engineTitle': 'Twój silnik',
  'autopilot.ov.offerHint': 'Gdy tylko umowa zostanie zawarta, zaczynamy konfigurować Twój silnik.',
  'autopilot.ov.offerTitle': 'Twój Autopilot jest przygotowywany',
  'autopilot.ov.pausedHint':
    'Nic nie jest wysyłane. Skontaktuj się ze swoją osobą kontaktową, aby wznowić.',
  'autopilot.ov.pausedTitle': 'Wysyłka wstrzymana',
  'autopilot.ov.setupHint':
    'Konfigurujemy domenę, uwierzytelnianie i skrzynki mailowe — w całości po naszej stronie. Nie musisz nic robić; odezwiemy się, gdy tylko Twoje pierwsze zatwierdzenia będą gotowe.',
  'autopilot.ov.setupTitle': 'Budujemy Twój silnik',
  'autopilot.ov.warmupDay': 'Rozgrzewka · Dzień {d} z {total}',
  'autopilot.ov.warmupHint':
    'Twoje skrzynki mailowe są stopniowo rozgrzewane, aby Twoje wiadomości trafiały do skrzynki odbiorczej — nie do spamu. W tym czasie możesz zająć się swoimi zatwierdzeniami.',
  'autopilot.ov.warmupTitle': 'Trwa rozgrzewka',
  'autopilot.pause.hintContact':
    'Wysyłkę zatrzyma dla Ciebie Twoja osoba kontaktowa — napisz do niej, działa od razu.',
  'autopilot.pause.action': 'Wstrzymaj wysyłkę',
  'autopilot.pause.hint':
    'Zatrzymuje wysyłkę natychmiast i całkowicie. Twój opiekun skontaktuje się z Tobą osobiście.',
  'autopilot.pause.title': 'Wyłącznik awaryjny',
  'autopilot.pause.confirm': 'Na pewno zatrzymać?',
  'autopilot.pause.done': 'Wysyłka wstrzymana — Twój opiekun skontaktuje się z Tobą osobiście.',
  'autopilot.pause.error':
    'Nie udało się wstrzymać — skontaktuj się bezpośrednio ze swoim opiekunem.',
  'autopilot.pause.pausedHint':
    'Wysyłka jest wstrzymana. Twój opiekun skontaktuje się z Tobą osobiście przed wznowieniem.',
  'autopilot.pulse.checked': '{n} sprawdzonych przez AI',
  'autopilot.pulse.next': 'Następna wysyłka {when}',
  'autopilot.pulse.queue': '{n} w kolejce',
  'autopilot.pulse.quiet':
    'Jeszcze brak wysyłek — silnik jest w trakcie budowy. Gdy tylko ruszy, zobaczysz tutaj dzienny puls.',
  'autopilot.pulse.researched': '{n} zbadanych',
  'autopilot.pulse.sent': '{n} wysłanych dzisiaj',
  'autopilot.pulse.title': 'Silnik w tej chwili',
  'autopilot.quota.progress': '{used} z ~{target} firm',
  'autopilot.quota.title': 'Limit w tym miesiącu',
  'autopilot.rc.interested': 'Zainteresowanie',
  'autopilot.rc.later': 'Później',
  'autopilot.rc.noNeed': 'Brak potrzeby',
  'autopilot.rc.ooo': 'Nieobecność',
  'autopilot.rc.unsub': 'Rezygnacja',
  'autopilot.rcls.title': 'Odpowiedzi według klasyfikacji',
  'autopilot.rep.actionFailed': 'Działanie nie powiodło się — spróbuj ponownie.',
  'autopilot.rep.call': 'Zadzwoń teraz',
  'autopilot.rep.contacted': 'Oznacz jako przejęte',
  'autopilot.rep.contactedDone': 'Przejęte dnia {date}',
  'autopilot.rep.contactedSet': 'Oznaczono jako przejęte — dziękujemy, to nam pomaga.',
  'autopilot.rep.contactedShort': 'Przejęte',
  'autopilot.rep.dealPlaceholder': 'Wartość zlecenia',
  'autopilot.rep.emptyHint':
    'Gdy Twoja kampania ruszy, pojawią się tu odpowiedzi firm, do których napisano — z pełną historią i naszą oceną.',
  'autopilot.rep.emptyTitle': 'Brak odpowiedzi',
  'autopilot.rep.intro':
    'Każda odpowiedź trafia tutaj — sklasyfikowana i z pełną historią. My wyjaśniamy, Ty dzwonisz.',
  'autopilot.rep.lostPlaceholder': 'Powód (opcjonalnie)',
  'autopilot.rep.noFit': 'Brak dopasowania',
  'autopilot.rep.noFitSet': 'Oznaczono jako „brak dopasowania” — Twój silnik się z tego uczy.',
  'autopilot.rep.saveClose': 'Zapisz',
  'autopilot.rep.title': 'Odpowiedzi',
  'autopilot.rep.viewThread': 'Zobacz wątek ({n})',
  'autopilot.rep.threadEmpty': 'Brak historii tej rozmowy.',
  'autopilot.rep.threadSent': 'Wysłano · {step}',
  'autopilot.rep.threadSentPlain': 'Wysłane przez Ciebie',
  'autopilot.rep.threadFoot': 'Wysłane w Twoim imieniu. Zmiany idą przez Twoją osobę kontaktową.',
  'autopilot.rep.cls.interested': 'Zainteresowanie',
  'autopilot.rep.cls.later': 'Później',
  'autopilot.rep.cls.noNeed': 'Brak potrzeby',
  'autopilot.rep.cls.referral': 'Inna osoba kontaktowa',
  'autopilot.rep.cls.question': 'Pytanie',
  'autopilot.rep.cls.outOfOffice': 'Nieobecność',
  'autopilot.rep.cls.unsubscribed': 'Wypisanie',
  'autopilot.rep.wonNoValue': 'Wygrane',
  'autopilot.rep.wonSet': 'Wygrane — świetnie! Wartość zlecenia trafia do Twojego bilansu.',
  'autopilot.report.first':
    'Twój następny raport pojawi się {date} — wysłane, dostarczone, odpowiedzi, przekazania. Bez upiększania.',
  'autopilot.report.title': 'Raport miesięczny',
  'autopilot.res.angles': 'Podejścia',
  'autopilot.res.anglesHint': 'Z jakim wstępem zaczynamy rozmowę.',
  'autopilot.res.emptyHint':
    'Gdy Twoja kampania zacznie działać i nadejdą pierwsze odpowiedzi, tutaj zobaczysz, co przyciąga, a co nie.',
  'autopilot.res.emptyTitle': 'Jeszcze brak odpowiedzi',
  'autopilot.res.footnote':
    'Wskaźniki dostępne od 30 skontaktowanych firm — poniżej tej liczby wynik procentowy byłby przypadkowy.',
  'autopilot.res.intro':
    'Skąd pochodzą odpowiedzi — i na co nikt nie reaguje. Twój silnik mierzy każdą wiadomość i wyciąga z tego wnioski.',
  'autopilot.res.learnedTitle': 'Co Twój silnik z tego wynosi',
  'autopilot.res.segments': 'Segmenty',
  'autopilot.res.segmentsHint': 'Które branże i role odpowiadają.',
  'autopilot.res.subjects': 'Tematy wiadomości',
  'autopilot.res.subjectsHint': 'Co jest otwierane i na co odpowiadają.',
  'autopilot.res.thin': 'za mało danych',
  'autopilot.res.title': 'Co przyciąga',
  'autopilot.spark.empty': 'Pojawi się, gdy tylko rozpocznie się wysyłka.',
  'autopilot.spark.title': 'Aktywność wysyłki (4 tygodnie)',
  'autopilot.stage.clarify': 'W wyjaśnianiu',
  'autopilot.stage.handover': 'Przekazany',
  'autopilot.stage.lost': 'Utracony',
  'autopilot.stage.new': 'Nowy',
  'autopilot.stage.won': 'Wygrany',
  'autopilot.status.active': 'Aktywny',
  'autopilot.status.awaiting': 'Oczekuje na zatwierdzenie',
  'autopilot.status.contract': 'Umowa podpisana',
  'autopilot.status.ended': 'Zakończony',
  'autopilot.status.offer': 'W przygotowaniu',
  'autopilot.status.paused': 'Wstrzymany',
  'autopilot.status.setup': 'Konfiguracja',
  'autopilot.status.warmup': 'Rozgrzewka',
  'autopilot.step.approvals': 'Zatwierdzenia',
  'autopilot.step.live': 'Na żywo',
  'autopilot.step.setup': 'Konfiguracja',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'Zobacz wszystkie',
  'autopilot.talk.empty':
    'Gdy Twoja kampania będzie aktywna, zobaczysz tutaj, z kim silnik aktualnie rozmawia.',
  'autopilot.talk.emptyLive':
    'Obecnie brak otwartych rozmów — po następnej odpowiedzi firma pojawi się tutaj.',
  'autopilot.talk.title': 'Aktualnie w rozmowie',
  'autopilot.tasks.approvals': '{n} zatwierdzeń czeka na Ciebie',
  'autopilot.tasks.call1': 'Jedno ciepłe przekazanie czeka na Twój telefon',
  'autopilot.tasks.calls': '{n} ciepłych przekazań czeka na Twój telefon',
  'autopilot.tasks.none': 'Nic do zrobienia — silnik pracuje dla Ciebie.',
  'autopilot.tasks.title': 'Twoje zadania',
  'autopilot.tech.allGreen': 'Wszystko sprawne',
  'autopilot.tech.auto': 'Działa automatycznie',
  'autopilot.tech.autoHint':
    'Te zadania konserwacyjne działają w tle — bez konieczności podnoszenia palca.',
  'autopilot.tech.blacklists': 'Monitorowanie czarnych list',
  'autopilot.tech.clean': 'czysta',
  'autopilot.tech.dmarcReports': 'Raporty zbiorcze DMARC aktywne',
  'autopilot.tech.domains': 'Domeny wysyłkowe',
  'autopilot.tech.integrations': 'Połączone systemy',
  'autopilot.tech.intro':
    'Cała Twoja infrastruktura wysyłkowa na jeden rzut oka — domeny, uwierzytelnianie DNS, skrzynki, monitoring. Konfigurujemy wszystko i dbamy, by działało bez zarzutu; Ty nie musisz nic ruszać.',
  'autopilot.tech.mailboxes': 'Skrzynki i uwierzytelnianie',
  'autopilot.tech.nis2': 'Domena potwierdzona',
  'autopilot.tech.owner': 'Właściciel: Ty',
  'autopilot.tech.pending':
    'Twoja infrastruktura jest właśnie konfigurowana — wkrótce pojawi się tu Twoje pełne centrum kontroli.',
  'autopilot.tech.pipeline': 'Potok AI',
  'autopilot.tech.pipelineHint':
    'Każda wiadomość przechodzi przez te niezależne kontrole, zanim będzie gotowa do wysyłki.',
  'autopilot.tech.placement': 'Ostatni test dostarczalności: {n}% w skrzynce odbiorczej',
  'autopilot.tech.registrar': 'Rejestrator: {name}',
  'autopilot.tech.rep': 'Reputacja {n}',
  'autopilot.tech.replyLogic': 'Inteligencja odpowiedzi',
  'autopilot.tech.reputation': 'Reputacja i monitoring dostarczalności',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Technika i dostarczalność',
  'autopilot.tech.warmup': 'Rozgrzewanie',
  'autopilot.warm.traffic.weekendShort': 'WE',
  'autopilot.warm.traffic.pauseShort': 'Pauza',
  'autopilot.warm.traffic.weekend': 'Weekend: sieć rozgrzewania ogranicza ruch zgodnie z planem',
  'autopilot.warm.traffic.pause': 'Dzień przerwy w sieci rozgrzewania',
  'autopilot.ov.hero.warmOffen':
    'Twoje skrzynki wciąż się rozgrzewają (dzień {d} z {total}). Zatwierdź teraz, a zaczniemy, gdy będą gotowe.',
  'autopilot.ov.hero.warmFrei':
    'Wszystko zatwierdzone. Twoje skrzynki wciąż się rozgrzewają (dzień {d} z {total}), potem wyślemy pierwszy e-mail.',
  'autopilot.ov.hero.fertigOffen':
    'Twoje skrzynki są rozgrzane. Czekamy już tylko na Twoje zatwierdzenia, by zacząć.',
  'autopilot.ov.hero.fertigFrei':
    'Skrzynki rozgrzane, wszystko zatwierdzone. Przygotowujemy pierwszą wysyłkę.',
  'autopilot.ov.hero.startNachFreigabe': 'gdy tylko zatwierdzisz',
  'autopilot.ov.hero.startInVorbereitung': 'w przygotowaniu',
  'autopilot.mb.st.fertig': 'Rozgrzane',
  'autopilot.appr.zf.lead':
    'Skontaktujemy się z każdą firmą, której nie wykluczysz. Zaznaczenie jest opcjonalne i pomaga nam zrozumieć, jakie firmy preferujesz.',
  'autopilot.appr.zf.f.alle': 'Wszystkie {n}',
  'autopilot.appr.zf.f.dabei': 'Uwzględnione {n}',
  'autopilot.appr.zf.f.raus': 'Wykluczone {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Bez kontaktu {n}',
  'autopilot.camp.offenN': '{n} zatwierdzeń oczekuje: {liste}',
  'autopilot.camp.offen1': 'Jedno zatwierdzenie oczekuje: {liste}',
  'autopilot.appr.zf.neuTitle': 'Nowa od Twojej ostatniej wizyty',
  'autopilot.appr.zf.g.bekanntHinweis':
    '„Już ich znamy” trwale usuwa firmę z Twoich propozycji, także w przyszłych kampaniach.',
  'autopilot.camp.offenDanach': ', potem {label}',
  'autopilot.ov.ring.bereit': 'gotowe',
  'autopilot.ov.hero.bereitOffen':
    'Gotowe do startu: wszystkie {n} skrzynki mają co najmniej {s} punktów dostarczalności. Brakuje tylko Twoich zatwierdzeń.',
  'autopilot.ov.hero.bereitFrei':
    'Gotowe i zatwierdzone. Wszystkie {n} skrzynki mają co najmniej {s}; przygotowujemy pierwszą wysyłkę.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} z {n} skrzynek jest gotowych (dostarczalność od {s}). Zatwierdź teraz, a wystartujemy, gdy tylko wszystkie będą gotowe.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} z {n} skrzynek jest gotowych (dostarczalność od {s}). Wystartujemy, gdy tylko wszystkie będą gotowe.',
  'autopilot.ov.hero.scoreRegel': 'Dostarczalność na skrzynkę · gotowa od {s}',
  'autopilot.mb.st.bereit': 'Gotowe do startu',
  'autopilot.mb.st.bereitTeil': '{bereit} z {n} gotowych',
  'autopilot.mb.st.mbBereit': 'gotowa · dzień {d}/{total}',
  'autopilot.warm.regel':
    'Skrzynka jest gotowa do startu od {s} punktów dostarczalności. {total} dni to wskazówka, nie warunek.',
  'autopilot.camp.vs.post': '{n} pocztą',
  'autopilot.camp.vs.geprueft': '{n} potwierdzonych',
  'autopilot.camp.vs.ungeprueft': '{n} niepotwierdzonych',
  'autopilot.camp.vs.zust.ok': 'Adres potwierdzony',
  'autopilot.camp.vs.zust.ungeprueft': 'Adres niepotwierdzony',
  'autopilot.camp.vs.erkl.geprueft':
    'Sprawdzamy każdy adres przed wysyłką. Potwierdzony oznacza, że serwer go zaakceptował. Niepotwierdzony zwykle wskazuje na catch-all, gdzie serwer odpowiada tak samo na każdy adres.',
  'autopilot.camp.vs.absender': 'Nadawca',
  'autopilot.camp.vs.takt': 'Tempo',
  'autopilot.camp.vs.taktWert': '{n} e-maili dziennie',
  'autopilot.camp.vs.naechster': 'następna wysyłka {when}',
  'autopilot.camp.vs.keinAbsender':
    'Do tej kampanii nie przypisano jeszcze skrzynki nadawcy. Skonfigurujemy ją przed uruchomieniem.',
  'autopilot.camp.vs.hint':
    'Tak wychodzi e-mail. Zielone podkreślenie: uzupełnione z naszego researchu. Przerywane: uzupełniane per osoba przy wysyłce.',
  'autopilot.camp.vs.wartetTitel':
    'Firmy bez znalezionego adresu e-mail. Dołączają automatycznie, gdy tylko znajdzie się kontakt z adresem.',
  'autopilot.camp.vs.empfaenger': 'Odbiorcy',
  'autopilot.camp.vs.vorschauFuer': 'Podgląd dla',
  'autopilot.camp.vs.an': 'Do',
  'autopilot.camp.vs.platzhalter': 'uzupełniane per osoba przy wysyłce',
  'autopilot.erkl.aria': 'Jak to jest obliczane?',
  'autopilot.erkl.quelle': 'Źródło: {q}',
  'autopilot.warm.traffic.title': 'Ruch rozgrzewający Twoich skrzynek',
  'autopilot.warm.traffic.hint':
    'Wychodzące wiadomości rozgrzewające i wiadomości zarejestrowane w skrzynce odbiorczej we wszystkich Twoich skrzynkach.',
  'autopilot.mb.place.hint':
    'Maile rozgrzewające w skrzynce odbiorczej i spamie we wszystkich skrzynkach.',
  'autopilot.ov.zu.sub': 'z {n} wiadomości rozgrzewających z ostatnich 7 dni',
  'autopilot.warm.scoreChart.title': 'Wynik dostarczalności według skrzynki',
  'autopilot.warm.scoreChart.hint':
    'Pasmo obejmuje wszystkie skrzynki, linia pokazuje najsłabszą. Gotowe od {s}.',
  'autopilot.warm.scoreChart.perBox': 'według skrzynki',
  'autopilot.warm.scoreChart.perDomain': 'według domeny',
  'autopilot.warm.scoreChart.schwelle': 'gotowa od {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Każdy punkt to zapisana zmiana wyniku, po prawej widzisz aktualny wynik.',
  'autopilot.warm.scoreChart.messpunkt': 'Punkt pomiarowy {n}',
  'autopilot.warm.chart.gesendet': 'Wysłane',
  'autopilot.warm.scoreChart.titleDomain': 'Wynik dostarczalności według domeny',
  'autopilot.warm.scoreChart.hintDomain':
    'Pasmo obejmuje Twoje domeny, linia pokazuje najsłabszą. Skrzynka jest gotowa od {s}.',
  'autopilot.warm.erkl.traffic':
    'Tutaj widzisz wiadomości rozgrzewające w sieci lemwarm. Liczby obejmują też ruch przychodzący z sieci i nie pokazują wysyłek kampanii.',
  'autopilot.warm.erkl.placement':
    'Wartości pokazują, gdzie trafiają Twoje wiadomości rozgrzewające, w tym wiadomości przychodzące z sieci. Wskaźnik skrzynki odbiorczej to liczba wiadomości w skrzynce odbiorczej podzielona przez sumę wiadomości w skrzynce odbiorczej i spamie.',
  'autopilot.warm.erkl.tage':
    'Liczba dni jest wskazówką dla rozgrzewki; warunkiem jest wynik dostarczalności co najmniej {s} dla każdej skrzynki.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'To ruch w sieci rozgrzewającej, jeszcze nie wiadomości z kampanii.',
  'autopilot.warm.placement.vorwoche':
    'Wskaźnik skrzynki odbiorczej z ostatnich 7 zarejestrowanych dni w porównaniu z poprzednimi 7 dniami.',
  'autopilot.camp.vs.absenderKonto':
    'Te skrzynki należą do Twojego konta. Która z nich wyśle tę kampanię, ustalamy przed startem.',
  'autopilot.camp.vs.quellePruefung': 'weryfikacja e-mail',
  'autopilot.appr.zf.unvollstaendig':
    'Pokazujemy najnowsze firmy do limitu wyświetlania. Starszych tu nie ma.',
  'autopilot.appr.zf.ladeFehler':
    'Części Twoich firm nie udało się załadować. Odśwież stronę, spróbujemy ponownie.',
  'autopilot.warm.scoreChart.schwelleKurz': 'gotowe',
  'autopilot.warm.scoreChart.alle': 'Wszystkie',
  'autopilot.warm.scoreChart.hintEines': 'Przebieg dla {adresse}. Gotowe od {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    'Twoja karta zostanie zapisana do późniejszych doładowań jednym kliknięciem. Obciążymy ją tylko wtedy, gdy wyraźnie potwierdzisz doładowanie na wyświetloną kwotę — bez subskrypcji, bez automatycznego doładowania. Kartę możesz w każdej chwili usunąć w portalu klienta.',
  'refill.title': 'Dokup kontakty',
  'refill.subtitle': 'Zapisaną kartą — bez ponownego przechodzenia przez checkout.',
  'refill.choose': 'Wybierz pakiet',
  'refill.pack': '{n} kontaktów',
  'refill.net': '{amount} netto',
  'refill.total': 'Razem',
  'refill.inclTax': 'w tym {tax} VAT',
  'refill.reverseCharge': 'Bez VAT — odwrotne obciążenie, podatek rozlicza nabywca.',
  'refill.cardLabel': 'Płatność kartą {brand} •••• {last4}',
  'refill.cta': 'Zapłać teraz {amount}',
  'refill.quoting': 'Obliczanie kwoty …',
  'refill.paying': 'Trwa płatność …',
  'refill.terms': 'Płatność jednorazowa, bez subskrypcji. Twoje kontakty nie wygasają.',
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Kup kontakty',
  'packs.first.subtitle': 'Wybierz pakiet, a potem odblokuj nim kontakty.',
  'packs.first.balance': 'Dostępne kontakty: {n}',
  'packs.first.popular': 'Popularny',
  'packs.first.cta': 'Przejdź do płatności',
  'packs.first.redirecting': 'Przekierowanie do Stripe…',
  'packs.first.checkoutNote':
    'W następnym kroku zapłacisz bezpiecznie przez Stripe i zobaczysz tam kwotę końcową z VAT.',
  'packs.first.error': 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
  'packs.first.loadError': 'Nie udało się teraz załadować pakietów.',
  'packs.first.retry': 'Spróbuj ponownie',
  'refill.success': 'Dodano {n} kontaktów. Nowe saldo: {balance}.',
  'refill.again': 'Kup kolejny pakiet',
  'refill.amountChanged': 'Kwota się zmieniła. Potwierdź nową kwotę.',
  'refill.inProgress': 'Doładowanie już trwa. Chwileczkę …',
  'refill.processing': 'Płatność jest jeszcze przetwarzana. Za chwilę sprawdzimy ponownie.',
  'refill.failedDeclined': 'Twój bank odrzucił płatność. Nic nie zostało pobrane.',
  'refill.failedAuth': 'Potwierdzenie w banku nie zostało zakończone. Nic nie zostało pobrane.',
  'refill.failed': 'Płatność nie została zrealizowana. Nic nie zostało pobrane.',
  'refill.error': 'Nie udało się. Spróbuj ponownie za chwilę.',
  'refill.checking': 'Sprawdzamy status Twojej płatności …',
  'refill.unknown':
    'Nie udało się jeszcze potwierdzić płatności. Sprawdź saldo, zanim kupisz ponownie.',
  'refill.retryQuote': 'Wczytaj kwotę ponownie',
  'refill.checkStatus': 'Sprawdź status płatności',

  'auth.register.errPwPolicy':
    'Hasło jest zbyt słabe. Użyj co najmniej 8 znaków, w tym wielkich i małych liter, cyfry i znaku specjalnego.',
  'auth.err.emailTaken': 'Ten adres e-mail jest już zarejestrowany. Zaloguj się.',
  'auth.err.rateLimited':
    'Zbyt wiele prób z tego połączenia. Spróbuj ponownie za maksymalnie {minutes} min.',
  'auth.err.rateLimitedLater': 'Zbyt wiele prób z tego połączenia. Spróbuj ponownie później.',
  'auth.err.network': 'Nie udało się połączyć z serwerem. Sprawdź połączenie z internetem.',
  'auth.err.busy': 'Serwer jest teraz przeciążony. Spróbuj ponownie za chwilę.',
  'auth.err.signupFailed': 'Rejestracja nie powiodła się. Spróbuj ponownie za chwilę.',
  'auth.err.invalidInput': 'Sprawdź wprowadzone dane.',
  'auth.err.turnstileFailed':
    'Weryfikacja antybotowa nie powiodła się lub wygasła. Odśwież stronę i spróbuj ponownie.',
  'auth.err.turnstileBlocked':
    'Nie udało się uruchomić kontroli bezpieczeństwa. Może ją blokować blokada reklam lub śledzenia: zezwól na challenges.cloudflare.com dla tej strony albo użyj innej przeglądarki.',
  'auth.err.popupBlocked':
    'Okno logowania zostało zablokowane. Zezwól na wyskakujące okna dla tej strony i spróbuj ponownie.',
  'auth.err.popupClosed': 'Okno logowania zostało zamknięte przed zakończeniem uwierzytelniania.',
  'auth.err.otherProvider':
    'Konto z tym adresem e-mail już istnieje. Zaloguj się przez {provider}.',
  'auth.err.otherMethod':
    'Konto z tym adresem e-mail już istnieje. Zaloguj się tak, jak przy rejestracji (Google, Microsoft lub e-mail i hasło).',
  'auth.err.providerPassword': 'e-mail i hasło',
  'auth.err.firstName': 'Podaj swoje imię.',
  'auth.err.lastName': 'Podaj swoje nazwisko.',
  'auth.err.pwLong': 'Hasło jest zbyt długie.',
  'auth.err.oauthFailed': 'Logowanie przez dostawcę tożsamości nie powiodło się. Spróbuj ponownie.',
  'auth.err.noEmailFromProvider':
    'Nie otrzymaliśmy adresu e-mail od Twojego dostawcy. Wybierz inny sposób logowania.',
  'auth.err.ssoUnavailable':
    'Logowanie przez Google lub Microsoft jest chwilowo niedostępne. Użyj adresu e-mail i hasła.',
  'auth.err.accountGone': 'To konto zostało usunięte lub jest wyłączone.',
  'auth.err.sessionFailed': 'Nie udało się utworzyć sesji. Spróbuj ponownie.',
  'auth.register.next.prism':
    'Następny krok: opisz grupę docelową i zobacz prawdziwe firmy. Płacisz dopiero, gdy odblokowujesz leady.',
  'auth.register.next.noCard':
    'Po rejestracji możesz od razu zacząć. Nie potrzeba danych płatniczych.',
  'auth.register.next.trial':
    'Następny krok: wybierz pakiet i przetestuj go przez 3 dni. Wymagana karta, dziś 0 €; potem pakiet działa dalej, jeśli nie zrezygnujesz przed końcem testu.',
  'auth.register.next.plan':
    'Następny krok: wybierz pakiet. Płatność kartą jest pobierana od razu.',
  'auth.register.busyHint': 'Tworzymy Twoje konto. To potrwa kilka sekund.',
  'auth.login.legalSso':
    'Jesteś tu nowy? Logując się przez Google lub Microsoft, automatycznie tworzysz konto i akceptujesz nasz {terms}. Informacje o Twoich danych znajdziesz w naszej {privacy}.',
  'auth.r19.form.pw.title': 'Wymagania dotyczące hasła',
  'auth.r19.form.pw.len': 'Co najmniej 8 znaków',
  'auth.r19.form.pw.case': 'Wielkie i małe litery',
  'auth.r19.form.pw.digit': 'Cyfra',
  'auth.r19.form.pw.special': 'Znak specjalny',
  'auth.r19.form.pw.met': 'spełnione',
  'auth.r19.form.pw.open': 'do spełnienia',
  'auth.r19.chat.greeting':
    'Napisz tutaj swoje pytanie. Jeśli podasz adres e-mail, będziemy mogli odpowiedzieć również później.',
  'auth.r19.chat.failed': 'Nie można teraz otworzyć czatu. Napisz do nas zamiast tego na adres',

  'prism.abandon.fit': 'Firmy nie pasują',
  'prism.abandon.fitQ': 'Jakich firm się spodziewałeś?',
  'prism.abandon.freeText': 'Albo napisz jednym zdaniem…',
  'prism.abandon.later': 'Zajrzę później',
  'prism.abandon.price': 'Cena',
  'prism.abandon.q': 'Krótkie pytanie: co Cię powstrzymuje?',
  'prism.abandon.send': 'Wyślij',
  'prism.abandon.skip': 'Pomiń',
  'prism.abandon.thanks': 'Dziękujemy — to naprawdę pomaga.',
  'prism.checkout.autoNote':
    'Automatycznie przechodzi w abonament Starter (250 kredytów/mies.), jeśli nie zrezygnujesz w ciągu 3 dni testu.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '49 € dziś · od 4. dnia: 290 €/mies. · rezygnacja co miesiąc jednym kliknięciem',
  'prism.abo.afterDelivery':
    'Co tydzień ~{n} nowych firm. Do każdej szukamy decydenta i płacisz tylko, jeśli go znajdziemy.',
  'prism.abo.afterCredits':
    'Potem co miesiąc {credits} kredytów na nowe firmy i kontakty.',
  'prism.teaser.tag':
    'Osoba decyzyjna gratis na start',
  'prism.teaser.running':
    'Szukamy osoby decyzyjnej w {company} …',
  'prism.teaser.foundShort':
    'Osoba decyzyjna: {name}',
  'prism.teaser.noneShort':
    'Brak osoby decyzyjnej z dowodem',
  'prism.teaser.failedShort':
    'Wyszukiwanie chwilowo niemożliwe',
  'prism.teaser.open':
    'Zobacz',
  'prism.teaser.close':
    'Zwiń',
  'prism.teaser.role':
    'Stanowisko',
  'prism.teaser.source':
    'Dowód',
  'prism.teaser.email':
    'E-mail',
  'prism.teaser.src.impressum':
    'Nota prawna {domain}',
  'prism.teaser.src.handelsregister':
    'Rejestr handlowy',
  'prism.teaser.src.website':
    'Strona {domain}',
  'prism.teaser.mail.verified':
    'sprawdzony na serwerze pocztowym',
  'prism.teaser.mail.probable':
    'bardzo prawdopodobnie poprawny',
  'prism.teaser.mail.found':
    'tak podany na ich stronie',
  'prism.teaser.mail.none':
    'nie znaleźliśmy osobistego e-maila',
  'prism.teaser.foundNote':
    'Tak sprawdzamy każdą z twoich firm ({n}). Pełny e-mail zobaczysz po odblokowaniu, telefon tam, gdzie jest dostępny.',
  'prism.teaser.noneBody':
    'W {company} nie znaleźliśmy osoby decyzyjnej z dowodem (nota prawna, rejestr handlowy lub własna strona). Zamiast coś wymyślać, wolimy nic nie pokazywać.',
  'prism.teaser.noneNote':
    'Po odblokowaniu kredyt liczy się tylko wtedy, gdy znajdziemy osobę kontaktową.',
  'prism.teaser.failedBody':
    'Wyszukiwanie chwilowo się nie udało. Po odblokowaniu ruszy dla wszystkich firm ({n}).',
  'prism.teaser.cta':
    'Odblokuj wszystkie ({n})',
  'prism.cardHint.body':
    'Osobę decyzyjną w {company} sprawdzimy po odblokowaniu: imię i nazwisko, stanowisko oraz e-mail lub telefon, jeśli są publiczne.',
  'prism.cardHint.example':
    'Przykład widzisz wyżej przy {top}.',
  'prism.cardHint.cta':
    'Odblokuj',
  'prism.website.skip':
    'Dalej bez strony',
  'prism.website.issue.own_product':
    'To nasza strona, nie twoja. Wpisz tu stronę swojej firmy, żebyśmy zrozumieli, co sprzedajesz.',
  'prism.website.issue.ai_chat':
    'To link do czatu AI. Potrzebujemy strony twojej firmy, np. „twoja-firma.pl”.',
  'prism.website.issue.social':
    'Profil w mediach społecznościowych mówi nam za mało o twojej ofercie. Masz własną stronę? Jeśli nie, po prostu pomiń ten krok.',
  'prism.website.issue.redirect':
    'To krótki link lub przekierowanie. Wpisz bezpośrednio adres swojej strony, np. „twoja-firma.pl”.',
  'prism.notice.title':
    'Krótko o danych',
  'prism.notice.local_b2c':
    'Małe lokale dla klientów prywatnych (np. fryzjerzy czy bary) podają w sieci często tylko telefon i właściciela. Zweryfikowane e-maile osób decyzyjnych znajdujemy tam rzadziej niż w firmach sprzedających innym firmom.',
  'prism.notice.outside_dach':
    'Nasze dane są najpełniejsze w Niemczech, Austrii i Szwajcarii. Poza nimi często brakuje noty prawnej i wpisu w rejestrze, więc znajdujemy mniej osób decyzyjnych.',
  'prism.notice.continue':
    'Mimo to możesz szukać.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Twoje darmowe leady ({n}), gotowe do użycia',
  'prism.free.tagRunning':
    'Szukamy twoich darmowych leadów ({n})',
  'prism.free.tagOne':
    'Twój darmowy lead, gotowy do użycia',
  'prism.free.tagNone':
    'Darmowe leady: tym razem żadnego z dowodem',
  'prism.free.tagSlow':
    'Twoje darmowe leady potrzebują trochę więcej czasu',
  'prism.free.slowBody':
    'Wyszukiwanie trwa tym razem dłużej niż zwykle. Pokażemy tu twoje darmowe leady, gdy tylko będą gotowe, także jeśli wrócisz później.',
  'prism.free.running':
    'Szukamy osób decyzyjnych w twoich najlepszych firmach … ({found} z {n})',
  'prism.free.noneBody':
    'W twoich najlepszych firmach nie znaleźliśmy osoby decyzyjnej z dowodem i e-mailem (nota prawna, rejestr handlowy lub własna strona). Zamiast coś wymyślać, wolimy nic nie pokazywać. Po odblokowaniu kredyt liczy się tylko wtedy, gdy znajdziemy osobę kontaktową.',
  'prism.free.fewer':
    'Udało się potwierdzić {found} z {n}. Przy pozostałych firmach z góry listy brakowało dowodu, więc nic tam nie pokazujemy.',
  'prism.free.yours':
    'Skopiuj je lub wyeksportuj, należą do ciebie.',
  'prism.free.export':
    'Eksportuj jako CSV',
  'prism.free.copy':
    'Kopiuj',
  'prism.free.copied':
    'Skopiowano',
  'prism.free.cta':
    'Odblokuj wszystkie ({n})',
  'prism.free.usedNote':
    'Darmowe leady są raz na konto i firmę. Tę osobę decyzyjną widzisz tu jako podgląd.',
  'prism.free.csv.company':
    'Firma',
  'prism.free.csv.domain':
    'Domena',
  'prism.free.csv.name':
    'Imię i nazwisko',
  'prism.free.csv.role':
    'Stanowisko',
  'prism.free.csv.email':
    'E-mail',
  'prism.free.csv.phone':
    'Telefon',
  'prism.free.csv.source':
    'Dowód',
  'prism.pattern.first':
    'imię',
  'prism.pattern.last':
    'nazwisko',
  'prism.pattern.f':
    'i',
  'prism.hint.freeAbove':
    'Odblokowane za darmo, patrz wyżej',
  'prism.hint.dmsOne':
    '1 osoba decyzyjna: {roles}',
  'prism.hint.dmsMany':
    'Osoby decyzyjne ({count}): {roles}',
  'prism.hint.dmsNoRole':
    'Potwierdzone osoby decyzyjne: {count}',
  'prism.hint.pattern':
    'Rozpoznany format e-maila:',
  'prism.hint.src.impressum':
    'Nota prawna',
  'prism.hint.src.handelsregister':
    'Rejestr handlowy',
  'prism.hint.src.website':
    'Strona',
  'prism.hint.unlock':
    'Odblokuj',
  'prism.hint.unlockSub':
    'kontakt',
  'prism.freelead.tagTop': 'Twoja najlepiej dopasowana firma',
  'prism.rail.label': 'Postęp',
  'prism.rail.audience': 'Grupa docelowa',
  'prism.rail.website': 'Strona WWW',
  'prism.rail.refine': 'Doprecyzowanie',
  'prism.rail.result': 'Wynik',
  'prism.rail.done': 'zakończono',
  'prism.steps.earlier': 'Wcześniej zakończone kroki: {n}',
  'prism.lead.evidenceTag': 'Na ich stronie:',
  'prism.plan.termsStrong': 'Od 4. dnia: 290 €/mies.',
  'prism.plan.termsBody':
    'Po 3 dniach testu Twój dostęp automatycznie przechodzi na abonament Starter (250 kredytów/mies.). Jeśli wcześniej zrezygnujesz na koncie, zapłacisz tylko 49 €.',
  'prism.rateLimited.body':
    'Wykorzystano dzisiejsze wyszukiwania. Jutro można kontynuować — wprowadzone dane zostają zapisane.',
  'prism.rateLimited.title': 'Osiągnięto dzienny limit',
  'prism.results.queriesLabel': 'Tak szukaliśmy:',
  'prism.results.queriesMore': '+{count} kolejnych',
  'prism.score.possible': 'Możliwe dopasowanie',
  'prism.target.errEmpty':
    'Najpierw powiedz nam, do kogo chcesz dotrzeć — np. „dentyści w Warszawie”.',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Znaleziono kontakty, nadal zablokowane',
  'ld.reveal.hint':
    'Imię i nazwisko, e-mail i telefon zobaczysz po odblokowaniu. Jedno odblokowanie otwiera wszystkie kontakty tej firmy.',
  'ld.reveal.cta': 'Odblokuj kontakty',
  'ld.reveal.confirm':
    'To zużywa 1 kredyt. Potem zobaczysz pełne kontakty tej firmy, a plan pozyskania nie kosztuje nic dodatkowo.',
  'ld.reveal.confirmCta': 'Odblokuj za 1 kredyt',
  'ld.reveal.busy': 'Odblokowywanie…',
  'ld.reveal.done': 'Kontakty odblokowane, zużyto 1 kredyt.',
  'ld.reveal.already': 'Już odblokowane, nic nie zostało ponownie pobrane.',
  'ld.reveal.notEligible':
    'Brak osiągalnej osoby kontaktowej: nie ma czego odblokować i nic nie jest pobierane.',
  'ld.reveal.verificationPending':
    'Kontakty są jeszcze weryfikowane. Spróbuj ponownie za minutę; nic nie zostało pobrane.',
  'ld.reveal.researchRunning':
    'Wyszukiwanie kontaktów wciąż trwa. Odblokujesz je, gdy się zakończy.',
  'ld.reveal.failed': 'Nie udało się odblokować. Spróbuj ponownie; nigdy nie płacisz dwa razy.',
  'ld.reveal.noCredits': 'Do odblokowania potrzebujesz 1 kredytu.',
  'ld.reveal.buyContacts': 'Twoje saldo jest puste – tutaj możesz dokupić kontakty',
  'ld.reveal.planLocked': 'Najpierw odblokuj kontakty',
  'ld.reveal.planNoContact': 'Brak osiągalnej osoby kontaktowej, więc brak planu pozyskania',
  'ld.contact.lockedEmailPhone': 'E-mail i telefon po odblokowaniu',
  'ld.contact.lockedEmail': 'E-mail po odblokowaniu',
  'ld.contact.lockedPhone': 'Telefon po odblokowaniu',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Cotygodniowa dostawa',
  'delivery.card.badgeNew': 'Nowe',
  'delivery.card.forAudience': 'dla {name}',
  'delivery.card.amount': 'Co tydzień ~{n} nowych firm. Do każdej szukamy decydenta i płacisz tylko, jeśli go znajdziemy.',
  'delivery.card.credits': 'Do {credits} kredytów na dostawę: 1 za firmę, 1 za znalezionego decydenta',
  'delivery.card.switchLabel': 'Włącz lub wyłącz cotygodniową dostawę',
  'delivery.card.on': 'Wł.',
  'delivery.card.off': 'Wył.',
  'delivery.card.offHint': 'Włącz ją, a pierwsza dostawa ruszy od razu.',
  'delivery.card.next.label': 'Następna dostawa',
  'delivery.card.next.afterRating': 'gdy ocenisz bieżącą, najpóźniej {date}',
  'delivery.card.next.soon': 'rusza za chwilę',
  'delivery.card.running': 'Dostawa {no} w toku: {delivered} z {target} firm',
  'delivery.card.runningConnect': 'Dostawa {no}: {delivered} firm jest, teraz szukamy decydentów',
  'delivery.card.lowCredits': 'Masz {credits} kredytów, pełna dostawa potrzebuje {need}.',
  'delivery.card.topUp': 'Doładuj kredyty',
  'delivery.card.loadFailed': 'Nie udało się wczytać dostawy.',
  'delivery.pause.out_of_credits.title': 'Wstrzymana: brak kredytów',
  'delivery.pause.out_of_credits.body': 'Z nowymi kredytami dostawa sama ruszy dalej.',
  'delivery.pause.niche_exhausted.title': 'Wstrzymana: Twoja grupa docelowa jest wyczerpana',
  'delivery.pause.niche_exhausted.body': 'Nie znajdujemy tu już nowych firm. Poszerz ją jednym kliknięciem:',
  'delivery.pause.subscription_ended.title': 'Wstrzymana: Twoja subskrypcja się zakończyła',
  'delivery.pause.subscription_ended.body': 'Z aktywnym pakietem dostawa jest kontynuowana.',
  'delivery.pause.subscription_ended.cta': 'Wybierz pakiet',
  'delivery.pause.subscription_paused.title': 'Wstrzymana: Twoja subskrypcja jest zawieszona',
  'delivery.pause.subscription_paused.body': 'Gdy subskrypcja znów ruszy, dostawa będzie kontynuowana.',
  'delivery.pause.payment_issue.title': 'Wstrzymana: zaległa płatność',
  'delivery.pause.payment_issue.body': 'Zaktualizuj metodę płatności, a dostawa ruszy dalej.',
  'delivery.pause.payment_issue.cta': 'Zaktualizuj płatność',
  'delivery.pause.other.title': 'Wstrzymana',
  'delivery.pause.other.body': 'Napisz do nas krótką wiadomość, a sprawdzimy to.',
  'delivery.expand.hint': 'To zmienia Twoją grupę docelową, także dla ręcznych wyszukiwań.',
  'delivery.pause.profile_missing.title': 'Wstrzymana: ta grupa docelowa już nie istnieje',
  'delivery.pause.profile_missing.body': 'Utwórz nową grupę docelową i włącz tam dostawę.',
  'delivery.pause.profile_missing.cta': 'Utwórz grupę docelową',
  'delivery.pause.not_self_service.title': 'Wstrzymana: Twoim kontem zajmuje się nasz zespół',
  'delivery.pause.not_self_service.body': 'Firmy otrzymujesz przez Autopilot.',
  'delivery.pause.account_closed.title': 'Wstrzymana: zgłoszono usunięcie',
  'delivery.pause.account_closed.body': 'Nie dostarczamy do konta w trakcie usuwania.',
  'delivery.pause.unsupported_model.title': 'Wstrzymana: nie wchodzi w Twój pakiet',
  'delivery.pause.unsupported_model.body': 'Dostawa jest częścią pakietów Basic, Starter i Growth.',
  'delivery.short.title': 'Ostatnia dostawa: {delivered} z {target} firm',
  'delivery.short.body': 'Twoja grupa docelowa nie daje teraz więcej. Poszerz ją jednym kliknięciem:',
  'delivery.expand.loading': 'Sprawdzamy propozycje …',
  'delivery.expand.none': 'Opisz grupę docelową szerzej, aby kontynuować.',
  'delivery.expand.edit': 'Edytuj grupę docelową',
  'delivery.expand.applied': 'Grupa docelowa poszerzona. Następna dostawa rusza za chwilę.',
  'delivery.expand.opt.area': 'Poszerz na cały region {area} zamiast {from} i uruchom dostawę',
  'delivery.expand.opt.dach': 'Poszerz na Niemcy, Austrię i Szwajcarię i uruchom dostawę',
  'delivery.expand.opt.industry': 'Dodaj {industry} do grupy docelowej i uruchom dostawę',
  'delivery.expand.opt.size': 'Dopuść firmy każdej wielkości zamiast {from} pracowników i uruchom dostawę',
  'delivery.toast.on': 'Dostawa jest włączona. Pierwsza rusza za chwilę.',
  'delivery.toast.off': 'Dostawa jest wyłączona.',
  'delivery.toast.failed': 'Nie udało się. Spróbuj ponownie.',
  'delivery.toast.planRequired': 'Do dostawy potrzebujesz aktywnego pakietu.',
  'delivery.history.title': 'Poprzednie dostawy',
  'delivery.history.cycle': 'Dostawa {no}',
  'delivery.history.companies': '{n} firm',
  'delivery.history.withContact': '{n} z decydentem',
  'delivery.history.acceptRate': '{pct} % pasuje',
  'delivery.history.noRating': 'jeszcze nieoceniona',
  'delivery.history.review': 'Oceń teraz ({n} otwartych)',
  'delivery.history.show': 'Zobacz',
  'delivery.history.empty': 'Tu pojawi się Twoja pierwsza dostawa.',
  'delivery.history.more': 'Pokaż wszystkie',
  'delivery.history.less': 'Pokaż mniej',
  'delivery.filter.prefix': 'Filtrowane:',
  'delivery.notif.ready.title': 'Twoja dostawa jest gotowa: {n} firm',
  'delivery.notif.ready.body': '{connected} z decydentem, dla {name}. Oceń je, a przyjdzie następna.',
  'delivery.notif.paused.out_of_credits.title': 'Dostawa wstrzymana: brak kredytów',
  'delivery.notif.paused.out_of_credits.body': 'Z nowymi kredytami sama ruszy dalej.',
  'delivery.notif.paused.niche_exhausted.title': 'Dostawa wstrzymana: grupa docelowa wyczerpana',
  'delivery.notif.paused.niche_exhausted.body': 'Poszerz {name} jednym kliknięciem, aby kontynuować.',
  'agent.delivery.tool.status': 'Sprawdź dostawę',
  'agent.delivery.tool.set': 'Cotygodniowa dostawa',
  'agent.delivery.cost.enable': 'Do {credits} kredytów na dostawę: co tydzień ~{n} nowych firm, a do każdej szukamy decydenta. Za ten kredyt płacisz tylko, jeśli go znajdziemy. Wyłączyć możesz w każdej chwili.',
};

export default pl;
